export var RPCDocs;
(function (RPCDocs) {
    let ActivityFeed;
    (function (ActivityFeed) {
        let GetOpsActivityFeed;
        (function (GetOpsActivityFeed) {
            let v1;
            (function (v1) {
                let Scope;
                (function (Scope) {
                    Scope["Bolo"] = "bolo";
                    Scope["UserGeoFence"] = "user-geo-fence";
                    Scope["UserStatus"] = "user-status";
                    Scope["Passdown"] = "passdown";
                    Scope["Event"] = "event";
                    Scope["EventAssignmentUserStatus"] = "event-assignment-user-status";
                    Scope["LocationCheckpointScan"] = "location-checkpoint-scan";
                    Scope["LocationCheckpointTour"] = "location-checkpoint-tour";
                    Scope["LocationLogEntry"] = "location-log-entry";
                    Scope["PatrolRoute"] = "patrol-route";
                    Scope["PatrolRouteVisit"] = "patrol-route-visit";
                    Scope["Report"] = "report";
                    Scope["ReportStatus"] = "report-status";
                    Scope["Shift"] = "shift";
                    Scope["UserSos"] = "user-sos";
                })(Scope = v1.Scope || (v1.Scope = {}));
                let Type;
                (function (Type) {
                    Type["Arrive"] = "arrive";
                    Type["Depart"] = "depart";
                })(Type = v1.Type || (v1.Type = {}));
                let Status;
                (function (Status) {
                    Status["Inside"] = "inside";
                    Status["Near"] = "near";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetOpsActivityFeed.v1 || (GetOpsActivityFeed.v1 = {}));
        })(GetOpsActivityFeed = ActivityFeed.GetOpsActivityFeed || (ActivityFeed.GetOpsActivityFeed = {}));
    })(ActivityFeed = RPCDocs.ActivityFeed || (RPCDocs.ActivityFeed = {}));
    let Admin;
    (function (Admin) {
        let CreateOpsSummarySubscriber;
        (function (CreateOpsSummarySubscriber) {
            let v1;
            (function (v1) {
                let DeliveryMethod;
                (function (DeliveryMethod) {
                    DeliveryMethod["Email"] = "email";
                    DeliveryMethod["Sms"] = "sms";
                })(DeliveryMethod = v1.DeliveryMethod || (v1.DeliveryMethod = {}));
                let LocationAndGroupIds;
                (function (LocationAndGroupIds) {
                    LocationAndGroupIds["All"] = "all";
                })(LocationAndGroupIds = v1.LocationAndGroupIds || (v1.LocationAndGroupIds = {}));
                let ScopesLocationAndGroupIds;
                (function (ScopesLocationAndGroupIds) {
                    ScopesLocationAndGroupIds["None"] = "none";
                })(ScopesLocationAndGroupIds = v1.ScopesLocationAndGroupIds || (v1.ScopesLocationAndGroupIds = {}));
                let Frequency;
                (function (Frequency) {
                    Frequency["Daily"] = "daily";
                    Frequency["Weekly"] = "weekly";
                })(Frequency = v1.Frequency || (v1.Frequency = {}));
            })(v1 = CreateOpsSummarySubscriber.v1 || (CreateOpsSummarySubscriber.v1 = {}));
        })(CreateOpsSummarySubscriber = Admin.CreateOpsSummarySubscriber || (Admin.CreateOpsSummarySubscriber = {}));
        let FindOpsSummarySubscribers;
        (function (FindOpsSummarySubscribers) {
            let v1;
            (function (v1) {
                let LocationAndGroupIds;
                (function (LocationAndGroupIds) {
                    LocationAndGroupIds["All"] = "all";
                })(LocationAndGroupIds = v1.LocationAndGroupIds || (v1.LocationAndGroupIds = {}));
                let ScopesLocationAndGroupIds;
                (function (ScopesLocationAndGroupIds) {
                    ScopesLocationAndGroupIds["None"] = "none";
                })(ScopesLocationAndGroupIds = v1.ScopesLocationAndGroupIds || (v1.ScopesLocationAndGroupIds = {}));
            })(v1 = FindOpsSummarySubscribers.v1 || (FindOpsSummarySubscribers.v1 = {}));
        })(FindOpsSummarySubscribers = Admin.FindOpsSummarySubscribers || (Admin.FindOpsSummarySubscribers = {}));
        let SendOpsSummarySubscriberEmail;
        (function (SendOpsSummarySubscriberEmail) {
            let v1;
            (function (v1) {
                let Reason;
                (function (Reason) {
                    Reason["SubscriberNotFound"] = "subscriber-not-found";
                })(Reason = v1.Reason || (v1.Reason = {}));
                let DataReason;
                (function (DataReason) {
                    DataReason["NoRegions"] = "no-regions";
                })(DataReason = v1.DataReason || (v1.DataReason = {}));
                let DataReason2;
                (function (DataReason2) {
                    DataReason2["InvalidRegion"] = "invalid-region";
                })(DataReason2 = v1.DataReason2 || (v1.DataReason2 = {}));
                let DataReason3;
                (function (DataReason3) {
                    DataReason3["Empty"] = "empty";
                })(DataReason3 = v1.DataReason3 || (v1.DataReason3 = {}));
            })(v1 = SendOpsSummarySubscriberEmail.v1 || (SendOpsSummarySubscriberEmail.v1 = {}));
        })(SendOpsSummarySubscriberEmail = Admin.SendOpsSummarySubscriberEmail || (Admin.SendOpsSummarySubscriberEmail = {}));
        let UpdateOpsSummarySubscriber;
        (function (UpdateOpsSummarySubscriber) {
            let v1;
            (function (v1) {
                let DeliveryMethod;
                (function (DeliveryMethod) {
                    DeliveryMethod["Email"] = "email";
                    DeliveryMethod["Sms"] = "sms";
                })(DeliveryMethod = v1.DeliveryMethod || (v1.DeliveryMethod = {}));
                let LocationAndGroupIds;
                (function (LocationAndGroupIds) {
                    LocationAndGroupIds["All"] = "all";
                })(LocationAndGroupIds = v1.LocationAndGroupIds || (v1.LocationAndGroupIds = {}));
                let ScopesLocationAndGroupIds;
                (function (ScopesLocationAndGroupIds) {
                    ScopesLocationAndGroupIds["None"] = "none";
                })(ScopesLocationAndGroupIds = v1.ScopesLocationAndGroupIds || (v1.ScopesLocationAndGroupIds = {}));
                let Frequency;
                (function (Frequency) {
                    Frequency["Daily"] = "daily";
                    Frequency["Weekly"] = "weekly";
                })(Frequency = v1.Frequency || (v1.Frequency = {}));
            })(v1 = UpdateOpsSummarySubscriber.v1 || (UpdateOpsSummarySubscriber.v1 = {}));
        })(UpdateOpsSummarySubscriber = Admin.UpdateOpsSummarySubscriber || (Admin.UpdateOpsSummarySubscriber = {}));
    })(Admin = RPCDocs.Admin || (RPCDocs.Admin = {}));
    let Auth;
    (function (Auth) {
        let GetIdentityInfo;
        (function (GetIdentityInfo) {
            let v1;
            (function (v1) {
                let BlockReason;
                (function (BlockReason) {
                    BlockReason["BillingTrialEnd"] = "billing_trial_end";
                    BlockReason["BillingDelinquent"] = "billing_delinquent";
                    BlockReason["ManualBlock"] = "manual_block";
                })(BlockReason = v1.BlockReason || (v1.BlockReason = {}));
                let Roles;
                (function (Roles) {
                    Roles["Admin"] = "admin";
                    Roles["Ops"] = "ops";
                    Roles["Portal"] = "portal";
                    Roles["Scheduling"] = "scheduling";
                    Roles["Dispatch"] = "dispatch";
                })(Roles = v1.Roles || (v1.Roles = {}));
                let Status;
                (function (Status) {
                    Status["Inside"] = "inside";
                    Status["Near"] = "near";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetIdentityInfo.v1 || (GetIdentityInfo.v1 = {}));
        })(GetIdentityInfo = Auth.GetIdentityInfo || (Auth.GetIdentityInfo = {}));
        let SaveDeviceInfo;
        (function (SaveDeviceInfo) {
            let v1;
            (function (v1) {
                let Platform;
                (function (Platform) {
                    Platform["Android"] = "android";
                    Platform["Ios"] = "ios";
                    Platform["Web"] = "web";
                })(Platform = v1.Platform || (v1.Platform = {}));
            })(v1 = SaveDeviceInfo.v1 || (SaveDeviceInfo.v1 = {}));
        })(SaveDeviceInfo = Auth.SaveDeviceInfo || (Auth.SaveDeviceInfo = {}));
        let SaveDevicePhysicalActivity;
        (function (SaveDevicePhysicalActivity) {
            let v1;
            (function (v1) {
                let PhysicalActivity;
                (function (PhysicalActivity) {
                    PhysicalActivity["Walking"] = "walking";
                    PhysicalActivity["Driving"] = "driving";
                    PhysicalActivity["Still"] = "still";
                    PhysicalActivity["Running"] = "running";
                })(PhysicalActivity = v1.PhysicalActivity || (v1.PhysicalActivity = {}));
            })(v1 = SaveDevicePhysicalActivity.v1 || (SaveDevicePhysicalActivity.v1 = {}));
        })(SaveDevicePhysicalActivity = Auth.SaveDevicePhysicalActivity || (Auth.SaveDevicePhysicalActivity = {}));
        let SendMobileAppLinkSms;
        (function (SendMobileAppLinkSms) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Android"] = "android";
                    Type["Ios"] = "ios";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = SendMobileAppLinkSms.v1 || (SendMobileAppLinkSms.v1 = {}));
        })(SendMobileAppLinkSms = Auth.SendMobileAppLinkSms || (Auth.SendMobileAppLinkSms = {}));
    })(Auth = RPCDocs.Auth || (RPCDocs.Auth = {}));
    let Entries;
    (function (Entries) {
        let GetEntry;
        (function (GetEntry) {
            let v3;
            (function (v3) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v3.FormId || (v3.FormId = {}));
            })(v3 = GetEntry.v3 || (GetEntry.v3 = {}));
        })(GetEntry = Entries.GetEntry || (Entries.GetEntry = {}));
    })(Entries = RPCDocs.Entries || (RPCDocs.Entries = {}));
    let Events;
    (function (Events) {
        let CreateEvent;
        (function (CreateEvent) {
            let v1;
            (function (v1) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v1.FormId || (v1.FormId = {}));
                let State;
                (function (State) {
                    State["Pending"] = "pending";
                    State["Active"] = "active";
                    State["Closed"] = "closed";
                })(State = v1.State || (v1.State = {}));
            })(v1 = CreateEvent.v1 || (CreateEvent.v1 = {}));
        })(CreateEvent = Events.CreateEvent || (Events.CreateEvent = {}));
        let DownloadEvent;
        (function (DownloadEvent) {
            let v1;
            (function (v1) {
                let Format;
                (function (Format) {
                    Format["Html"] = "html";
                    Format["Pdf"] = "pdf";
                })(Format = v1.Format || (v1.Format = {}));
            })(v1 = DownloadEvent.v1 || (DownloadEvent.v1 = {}));
        })(DownloadEvent = Events.DownloadEvent || (Events.DownloadEvent = {}));
        let GetEvent;
        (function (GetEvent) {
            let v1;
            (function (v1) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v1.FormId || (v1.FormId = {}));
                let State;
                (function (State) {
                    State["Pending"] = "pending";
                    State["Active"] = "active";
                    State["Closed"] = "closed";
                })(State = v1.State || (v1.State = {}));
            })(v1 = GetEvent.v1 || (GetEvent.v1 = {}));
            let v2;
            (function (v2) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v2.FormId || (v2.FormId = {}));
                let State;
                (function (State) {
                    State["Pending"] = "pending";
                    State["Active"] = "active";
                    State["Closed"] = "closed";
                })(State = v2.State || (v2.State = {}));
            })(v2 = GetEvent.v2 || (GetEvent.v2 = {}));
        })(GetEvent = Events.GetEvent || (Events.GetEvent = {}));
        let GetEventsList;
        (function (GetEventsList) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
                let StateFilter;
                (function (StateFilter) {
                    StateFilter["Pending"] = "pending";
                    StateFilter["Active"] = "active";
                    StateFilter["Closed"] = "closed";
                })(StateFilter = v1.StateFilter || (v1.StateFilter = {}));
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v1.FormId || (v1.FormId = {}));
            })(v1 = GetEventsList.v1 || (GetEventsList.v1 = {}));
        })(GetEventsList = Events.GetEventsList || (Events.GetEventsList = {}));
        let SaveEventDisposition;
        (function (SaveEventDisposition) {
            let v1;
            (function (v1) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v1.FormId || (v1.FormId = {}));
            })(v1 = SaveEventDisposition.v1 || (SaveEventDisposition.v1 = {}));
        })(SaveEventDisposition = Events.SaveEventDisposition || (Events.SaveEventDisposition = {}));
        let UpdateEvent;
        (function (UpdateEvent) {
            let v2;
            (function (v2) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v2.FormId || (v2.FormId = {}));
            })(v2 = UpdateEvent.v2 || (UpdateEvent.v2 = {}));
        })(UpdateEvent = Events.UpdateEvent || (Events.UpdateEvent = {}));
    })(Events = RPCDocs.Events || (RPCDocs.Events = {}));
    let External;
    (function (External) {
        let GetFileUploadUrl;
        (function (GetFileUploadUrl) {
            let v1;
            (function (v1) {
                let UploadMethod;
                (function (UploadMethod) {
                    UploadMethod["POST"] = "POST";
                    UploadMethod["PUT"] = "PUT";
                })(UploadMethod = v1.UploadMethod || (v1.UploadMethod = {}));
            })(v1 = GetFileUploadUrl.v1 || (GetFileUploadUrl.v1 = {}));
        })(GetFileUploadUrl = External.GetFileUploadUrl || (External.GetFileUploadUrl = {}));
        let NewRegistrationWithEmail;
        (function (NewRegistrationWithEmail) {
            let v1;
            (function (v1) {
                let AccountType;
                (function (AccountType) {
                    AccountType["User"] = "user";
                    AccountType["Organization"] = "organization";
                })(AccountType = v1.AccountType || (v1.AccountType = {}));
            })(v1 = NewRegistrationWithEmail.v1 || (NewRegistrationWithEmail.v1 = {}));
        })(NewRegistrationWithEmail = External.NewRegistrationWithEmail || (External.NewRegistrationWithEmail = {}));
    })(External = RPCDocs.External || (RPCDocs.External = {}));
    let Files;
    (function (Files) {
        let GetFileUploadUrl;
        (function (GetFileUploadUrl) {
            let v1;
            (function (v1) {
                let UploadMethod;
                (function (UploadMethod) {
                    UploadMethod["POST"] = "POST";
                    UploadMethod["PUT"] = "PUT";
                })(UploadMethod = v1.UploadMethod || (v1.UploadMethod = {}));
            })(v1 = GetFileUploadUrl.v1 || (GetFileUploadUrl.v1 = {}));
        })(GetFileUploadUrl = Files.GetFileUploadUrl || (Files.GetFileUploadUrl = {}));
    })(Files = RPCDocs.Files || (RPCDocs.Files = {}));
    let Geo;
    (function (Geo) {
        let GetGooglePlacesAutocompleteSuggestions;
        (function (GetGooglePlacesAutocompleteSuggestions) {
            let v1;
            (function (v1) {
                let SearchTypes;
                (function (SearchTypes) {
                    SearchTypes["Address"] = "address";
                    SearchTypes["Locality"] = "locality";
                })(SearchTypes = v1.SearchTypes || (v1.SearchTypes = {}));
            })(v1 = GetGooglePlacesAutocompleteSuggestions.v1 || (GetGooglePlacesAutocompleteSuggestions.v1 = {}));
        })(GetGooglePlacesAutocompleteSuggestions = Geo.GetGooglePlacesAutocompleteSuggestions || (Geo.GetGooglePlacesAutocompleteSuggestions = {}));
    })(Geo = RPCDocs.Geo || (RPCDocs.Geo = {}));
    let Locations;
    (function (Locations) {
        let CompleteLocationTaskTodo;
        (function (CompleteLocationTaskTodo) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Completed"] = "completed";
                    Status["Missed"] = "missed";
                    Status["Skipped"] = "skipped";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = CompleteLocationTaskTodo.v1 || (CompleteLocationTaskTodo.v1 = {}));
        })(CompleteLocationTaskTodo = Locations.CompleteLocationTaskTodo || (Locations.CompleteLocationTaskTodo = {}));
        let CreateLocationCheckpoint;
        (function (CreateLocationCheckpoint) {
            let v1;
            (function (v1) {
                let Action;
                (function (Action) {
                    Action["Save"] = "save";
                    Action["Prompt"] = "prompt";
                    Action["EntryType"] = "entryType";
                })(Action = v1.Action || (v1.Action = {}));
                let Type;
                (function (Type) {
                    Type["Qr"] = "qr";
                    Type["Nfc"] = "nfc";
                    Type["Ble"] = "ble";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = CreateLocationCheckpoint.v1 || (CreateLocationCheckpoint.v1 = {}));
        })(CreateLocationCheckpoint = Locations.CreateLocationCheckpoint || (Locations.CreateLocationCheckpoint = {}));
        let CreateLocationLogEntry;
        (function (CreateLocationLogEntry) {
            let v2;
            (function (v2) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v2.FormId || (v2.FormId = {}));
            })(v2 = CreateLocationLogEntry.v2 || (CreateLocationLogEntry.v2 = {}));
        })(CreateLocationLogEntry = Locations.CreateLocationLogEntry || (Locations.CreateLocationLogEntry = {}));
        let CreateLocationSubscriber;
        (function (CreateLocationSubscriber) {
            let v1;
            (function (v1) {
                let DeliveryMethod;
                (function (DeliveryMethod) {
                    DeliveryMethod["Email"] = "email";
                    DeliveryMethod["Sms"] = "sms";
                    DeliveryMethod["Webhook"] = "webhook";
                })(DeliveryMethod = v1.DeliveryMethod || (v1.DeliveryMethod = {}));
                let DeliveryFormat;
                (function (DeliveryFormat) {
                    DeliveryFormat["Detailed"] = "detailed";
                    DeliveryFormat["Summary"] = "summary";
                })(DeliveryFormat = v1.DeliveryFormat || (v1.DeliveryFormat = {}));
                let Frequency;
                (function (Frequency) {
                    Frequency["Immediate"] = "immediate";
                    Frequency["Daily"] = "daily";
                    Frequency["Weekly"] = "weekly";
                    Frequency["Monthly"] = "monthly";
                    Frequency["Yearly"] = "yearly";
                })(Frequency = v1.Frequency || (v1.Frequency = {}));
            })(v1 = CreateLocationSubscriber.v1 || (CreateLocationSubscriber.v1 = {}));
        })(CreateLocationSubscriber = Locations.CreateLocationSubscriber || (Locations.CreateLocationSubscriber = {}));
        let DownloadLocationCheckpointActivity;
        (function (DownloadLocationCheckpointActivity) {
            let v1;
            (function (v1) {
                let Format;
                (function (Format) {
                    Format["Html"] = "html";
                    Format["Pdf"] = "pdf";
                })(Format = v1.Format || (v1.Format = {}));
            })(v1 = DownloadLocationCheckpointActivity.v1 || (DownloadLocationCheckpointActivity.v1 = {}));
        })(DownloadLocationCheckpointActivity = Locations.DownloadLocationCheckpointActivity || (Locations.DownloadLocationCheckpointActivity = {}));
        let DownloadLocationCheckpointScans;
        (function (DownloadLocationCheckpointScans) {
            let v1;
            (function (v1) {
                let Format;
                (function (Format) {
                    Format["Html"] = "html";
                    Format["Pdf"] = "pdf";
                })(Format = v1.Format || (v1.Format = {}));
            })(v1 = DownloadLocationCheckpointScans.v1 || (DownloadLocationCheckpointScans.v1 = {}));
        })(DownloadLocationCheckpointScans = Locations.DownloadLocationCheckpointScans || (Locations.DownloadLocationCheckpointScans = {}));
        let DownloadLocationCheckpointTours;
        (function (DownloadLocationCheckpointTours) {
            let v1;
            (function (v1) {
                let Format;
                (function (Format) {
                    Format["Html"] = "html";
                    Format["Pdf"] = "pdf";
                })(Format = v1.Format || (v1.Format = {}));
            })(v1 = DownloadLocationCheckpointTours.v1 || (DownloadLocationCheckpointTours.v1 = {}));
        })(DownloadLocationCheckpointTours = Locations.DownloadLocationCheckpointTours || (Locations.DownloadLocationCheckpointTours = {}));
        let DownloadLocationLogEntries;
        (function (DownloadLocationLogEntries) {
            let v1;
            (function (v1) {
                let Format;
                (function (Format) {
                    Format["Html"] = "html";
                    Format["Pdf"] = "pdf";
                })(Format = v1.Format || (v1.Format = {}));
            })(v1 = DownloadLocationLogEntries.v1 || (DownloadLocationLogEntries.v1 = {}));
        })(DownloadLocationLogEntries = Locations.DownloadLocationLogEntries || (Locations.DownloadLocationLogEntries = {}));
        let DownloadLocationLogEntry;
        (function (DownloadLocationLogEntry) {
            let v1;
            (function (v1) {
                let Format;
                (function (Format) {
                    Format["Html"] = "html";
                    Format["Pdf"] = "pdf";
                })(Format = v1.Format || (v1.Format = {}));
            })(v1 = DownloadLocationLogEntry.v1 || (DownloadLocationLogEntry.v1 = {}));
        })(DownloadLocationLogEntry = Locations.DownloadLocationLogEntry || (Locations.DownloadLocationLogEntry = {}));
        let GetLocationAuditDetails;
        (function (GetLocationAuditDetails) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Location"] = "location";
                    Type["Address"] = "address";
                    Type["SubLocation"] = "sub-location";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetLocationAuditDetails.v1 || (GetLocationAuditDetails.v1 = {}));
        })(GetLocationAuditDetails = Locations.GetLocationAuditDetails || (Locations.GetLocationAuditDetails = {}));
        let GetLocationCheckpointDetail;
        (function (GetLocationCheckpointDetail) {
            let v1;
            (function (v1) {
                let Action;
                (function (Action) {
                    Action["Save"] = "save";
                    Action["Prompt"] = "prompt";
                    Action["EntryType"] = "entryType";
                })(Action = v1.Action || (v1.Action = {}));
                let Type;
                (function (Type) {
                    Type["Qr"] = "qr";
                    Type["Nfc"] = "nfc";
                    Type["Ble"] = "ble";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetLocationCheckpointDetail.v1 || (GetLocationCheckpointDetail.v1 = {}));
        })(GetLocationCheckpointDetail = Locations.GetLocationCheckpointDetail || (Locations.GetLocationCheckpointDetail = {}));
        let GetLocationCheckpointScanDetail;
        (function (GetLocationCheckpointScanDetail) {
            let v1;
            (function (v1) {
                let Action;
                (function (Action) {
                    Action["Save"] = "save";
                    Action["Prompt"] = "prompt";
                    Action["EntryType"] = "entryType";
                })(Action = v1.Action || (v1.Action = {}));
                let Type;
                (function (Type) {
                    Type["Qr"] = "qr";
                    Type["Nfc"] = "nfc";
                    Type["Ble"] = "ble";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetLocationCheckpointScanDetail.v1 || (GetLocationCheckpointScanDetail.v1 = {}));
            let v2;
            (function (v2) {
                let Action;
                (function (Action) {
                    Action["Save"] = "save";
                    Action["Prompt"] = "prompt";
                    Action["EntryType"] = "entryType";
                })(Action = v2.Action || (v2.Action = {}));
                let Type;
                (function (Type) {
                    Type["Qr"] = "qr";
                    Type["Nfc"] = "nfc";
                    Type["Ble"] = "ble";
                })(Type = v2.Type || (v2.Type = {}));
            })(v2 = GetLocationCheckpointScanDetail.v2 || (GetLocationCheckpointScanDetail.v2 = {}));
        })(GetLocationCheckpointScanDetail = Locations.GetLocationCheckpointScanDetail || (Locations.GetLocationCheckpointScanDetail = {}));
        let GetLocationCheckpointTourDetail;
        (function (GetLocationCheckpointTourDetail) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Qr"] = "qr";
                    Type["Nfc"] = "nfc";
                    Type["Ble"] = "ble";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetLocationCheckpointTourDetail.v1 || (GetLocationCheckpointTourDetail.v1 = {}));
        })(GetLocationCheckpointTourDetail = Locations.GetLocationCheckpointTourDetail || (Locations.GetLocationCheckpointTourDetail = {}));
        let GetLocationCheckpointTourRunDetail;
        (function (GetLocationCheckpointTourRunDetail) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Qr"] = "qr";
                    Type["Nfc"] = "nfc";
                    Type["Ble"] = "ble";
                })(Type = v1.Type || (v1.Type = {}));
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetLocationCheckpointTourRunDetail.v1 || (GetLocationCheckpointTourRunDetail.v1 = {}));
        })(GetLocationCheckpointTourRunDetail = Locations.GetLocationCheckpointTourRunDetail || (Locations.GetLocationCheckpointTourRunDetail = {}));
        let GetLocationCheckpointTourRunsList;
        (function (GetLocationCheckpointTourRunsList) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetLocationCheckpointTourRunsList.v1 || (GetLocationCheckpointTourRunsList.v1 = {}));
            let v2;
            (function (v2) {
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v2.Status || (v2.Status = {}));
            })(v2 = GetLocationCheckpointTourRunsList.v2 || (GetLocationCheckpointTourRunsList.v2 = {}));
        })(GetLocationCheckpointTourRunsList = Locations.GetLocationCheckpointTourRunsList || (Locations.GetLocationCheckpointTourRunsList = {}));
        let GetLocationCheckpointsDetail;
        (function (GetLocationCheckpointsDetail) {
            let v1;
            (function (v1) {
                let Action;
                (function (Action) {
                    Action["Save"] = "save";
                    Action["Prompt"] = "prompt";
                    Action["EntryType"] = "entryType";
                })(Action = v1.Action || (v1.Action = {}));
                let Type;
                (function (Type) {
                    Type["Qr"] = "qr";
                    Type["Nfc"] = "nfc";
                    Type["Ble"] = "ble";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetLocationCheckpointsDetail.v1 || (GetLocationCheckpointsDetail.v1 = {}));
        })(GetLocationCheckpointsDetail = Locations.GetLocationCheckpointsDetail || (Locations.GetLocationCheckpointsDetail = {}));
        let GetLocationCheckpointsList;
        (function (GetLocationCheckpointsList) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Qr"] = "qr";
                    Type["Nfc"] = "nfc";
                    Type["Ble"] = "ble";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetLocationCheckpointsList.v1 || (GetLocationCheckpointsList.v1 = {}));
        })(GetLocationCheckpointsList = Locations.GetLocationCheckpointsList || (Locations.GetLocationCheckpointsList = {}));
        let GetLocationLogEntriesDetails;
        (function (GetLocationLogEntriesDetails) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v1.FormId || (v1.FormId = {}));
            })(v1 = GetLocationLogEntriesDetails.v1 || (GetLocationLogEntriesDetails.v1 = {}));
        })(GetLocationLogEntriesDetails = Locations.GetLocationLogEntriesDetails || (Locations.GetLocationLogEntriesDetails = {}));
        let GetLocationLogEntriesList;
        (function (GetLocationLogEntriesList) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
            })(v1 = GetLocationLogEntriesList.v1 || (GetLocationLogEntriesList.v1 = {}));
        })(GetLocationLogEntriesList = Locations.GetLocationLogEntriesList || (Locations.GetLocationLogEntriesList = {}));
        let GetLocationLogEntryDetail;
        (function (GetLocationLogEntryDetail) {
            let v1;
            (function (v1) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v1.FormId || (v1.FormId = {}));
            })(v1 = GetLocationLogEntryDetail.v1 || (GetLocationLogEntryDetail.v1 = {}));
        })(GetLocationLogEntryDetail = Locations.GetLocationLogEntryDetail || (Locations.GetLocationLogEntryDetail = {}));
        let GetLocationLogEntryList;
        (function (GetLocationLogEntryList) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
            })(v1 = GetLocationLogEntryList.v1 || (GetLocationLogEntryList.v1 = {}));
            let v2;
            (function (v2) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v2.Sort || (v2.Sort = {}));
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v2.FormId || (v2.FormId = {}));
            })(v2 = GetLocationLogEntryList.v2 || (GetLocationLogEntryList.v2 = {}));
        })(GetLocationLogEntryList = Locations.GetLocationLogEntryList || (Locations.GetLocationLogEntryList = {}));
        let GetLocationLogEntryTypeLocationsRelations;
        (function (GetLocationLogEntryTypeLocationsRelations) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
            })(v1 = GetLocationLogEntryTypeLocationsRelations.v1 || (GetLocationLogEntryTypeLocationsRelations.v1 = {}));
        })(GetLocationLogEntryTypeLocationsRelations = Locations.GetLocationLogEntryTypeLocationsRelations || (Locations.GetLocationLogEntryTypeLocationsRelations = {}));
        let GetLocationLogEntryTypesList;
        (function (GetLocationLogEntryTypesList) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
            })(v1 = GetLocationLogEntryTypesList.v1 || (GetLocationLogEntryTypesList.v1 = {}));
        })(GetLocationLogEntryTypesList = Locations.GetLocationLogEntryTypesList || (Locations.GetLocationLogEntryTypesList = {}));
        let GetLocationSubscribers;
        (function (GetLocationSubscribers) {
            let v1;
            (function (v1) {
                let DeliveryMethod;
                (function (DeliveryMethod) {
                    DeliveryMethod["Email"] = "email";
                    DeliveryMethod["Sms"] = "sms";
                    DeliveryMethod["User"] = "user";
                    DeliveryMethod["Webhook"] = "webhook";
                })(DeliveryMethod = v1.DeliveryMethod || (v1.DeliveryMethod = {}));
                let DeliveryFormat;
                (function (DeliveryFormat) {
                    DeliveryFormat["Detailed"] = "detailed";
                    DeliveryFormat["Summary"] = "summary";
                })(DeliveryFormat = v1.DeliveryFormat || (v1.DeliveryFormat = {}));
                let DeliveryStatus;
                (function (DeliveryStatus) {
                    DeliveryStatus["Active"] = "active";
                    DeliveryStatus["Suspended"] = "suspended";
                })(DeliveryStatus = v1.DeliveryStatus || (v1.DeliveryStatus = {}));
                let Frequency;
                (function (Frequency) {
                    Frequency["Immediate"] = "immediate";
                    Frequency["Daily"] = "daily";
                    Frequency["Weekly"] = "weekly";
                    Frequency["Monthly"] = "monthly";
                    Frequency["Yearly"] = "yearly";
                })(Frequency = v1.Frequency || (v1.Frequency = {}));
            })(v1 = GetLocationSubscribers.v1 || (GetLocationSubscribers.v1 = {}));
        })(GetLocationSubscribers = Locations.GetLocationSubscribers || (Locations.GetLocationSubscribers = {}));
        let GetLocationTaskCompletions;
        (function (GetLocationTaskCompletions) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Completed"] = "completed";
                    Status["Missed"] = "missed";
                    Status["Skipped"] = "skipped";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetLocationTaskCompletions.v1 || (GetLocationTaskCompletions.v1 = {}));
        })(GetLocationTaskCompletions = Locations.GetLocationTaskCompletions || (Locations.GetLocationTaskCompletions = {}));
        let GetLocationTaskTodos;
        (function (GetLocationTaskTodos) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Pending"] = "pending";
                })(Status = v1.Status || (v1.Status = {}));
                let ArgsStatus;
                (function (ArgsStatus) {
                    ArgsStatus["Completed"] = "completed";
                })(ArgsStatus = v1.ArgsStatus || (v1.ArgsStatus = {}));
                let ArgsStatus2;
                (function (ArgsStatus2) {
                    ArgsStatus2["Missed"] = "missed";
                })(ArgsStatus2 = v1.ArgsStatus2 || (v1.ArgsStatus2 = {}));
                let ArgsStatus3;
                (function (ArgsStatus3) {
                    ArgsStatus3["Skipped"] = "skipped";
                })(ArgsStatus3 = v1.ArgsStatus3 || (v1.ArgsStatus3 = {}));
            })(v1 = GetLocationTaskTodos.v1 || (GetLocationTaskTodos.v1 = {}));
        })(GetLocationTaskTodos = Locations.GetLocationTaskTodos || (Locations.GetLocationTaskTodos = {}));
        let GetLocationTasks;
        (function (GetLocationTasks) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Active"] = "active";
                    Status["Paused"] = "paused";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetLocationTasks.v1 || (GetLocationTasks.v1 = {}));
        })(GetLocationTasks = Locations.GetLocationTasks || (Locations.GetLocationTasks = {}));
        let GetLocationsList;
        (function (GetLocationsList) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
            })(v1 = GetLocationsList.v1 || (GetLocationsList.v1 = {}));
        })(GetLocationsList = Locations.GetLocationsList || (Locations.GetLocationsList = {}));
        let GetStatsCountsByLocation;
        (function (GetStatsCountsByLocation) {
            let v1;
            (function (v1) {
                let State;
                (function (State) {
                    State["Active"] = "active";
                    State["Closed"] = "closed";
                    State["Pending"] = "pending";
                })(State = v1.State || (v1.State = {}));
                let ReportArgsState;
                (function (ReportArgsState) {
                    ReportArgsState["Open"] = "open";
                    ReportArgsState["Closed"] = "closed";
                    ReportArgsState["Review"] = "review";
                })(ReportArgsState = v1.ReportArgsState || (v1.ReportArgsState = {}));
            })(v1 = GetStatsCountsByLocation.v1 || (GetStatsCountsByLocation.v1 = {}));
        })(GetStatsCountsByLocation = Locations.GetStatsCountsByLocation || (Locations.GetStatsCountsByLocation = {}));
        let SaveLocationCheckpointScan;
        (function (SaveLocationCheckpointScan) {
            let v1;
            (function (v1) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v1.FormId || (v1.FormId = {}));
            })(v1 = SaveLocationCheckpointScan.v1 || (SaveLocationCheckpointScan.v1 = {}));
            let v2;
            (function (v2) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v2.FormId || (v2.FormId = {}));
            })(v2 = SaveLocationCheckpointScan.v2 || (SaveLocationCheckpointScan.v2 = {}));
        })(SaveLocationCheckpointScan = Locations.SaveLocationCheckpointScan || (Locations.SaveLocationCheckpointScan = {}));
        let UpdateLocationCheckpoint;
        (function (UpdateLocationCheckpoint) {
            let v1;
            (function (v1) {
                let Action;
                (function (Action) {
                    Action["Save"] = "save";
                    Action["Prompt"] = "prompt";
                    Action["EntryType"] = "entryType";
                })(Action = v1.Action || (v1.Action = {}));
            })(v1 = UpdateLocationCheckpoint.v1 || (UpdateLocationCheckpoint.v1 = {}));
        })(UpdateLocationCheckpoint = Locations.UpdateLocationCheckpoint || (Locations.UpdateLocationCheckpoint = {}));
        let UpdateLocationLogEntry;
        (function (UpdateLocationLogEntry) {
            let v2;
            (function (v2) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v2.FormId || (v2.FormId = {}));
            })(v2 = UpdateLocationLogEntry.v2 || (UpdateLocationLogEntry.v2 = {}));
        })(UpdateLocationLogEntry = Locations.UpdateLocationLogEntry || (Locations.UpdateLocationLogEntry = {}));
        let UpdateLocationSubscriber;
        (function (UpdateLocationSubscriber) {
            let v1;
            (function (v1) {
                let DeliveryMethod;
                (function (DeliveryMethod) {
                    DeliveryMethod["Email"] = "email";
                    DeliveryMethod["Sms"] = "sms";
                    DeliveryMethod["Webhook"] = "webhook";
                })(DeliveryMethod = v1.DeliveryMethod || (v1.DeliveryMethod = {}));
                let DeliveryFormat;
                (function (DeliveryFormat) {
                    DeliveryFormat["Detailed"] = "detailed";
                    DeliveryFormat["Summary"] = "summary";
                })(DeliveryFormat = v1.DeliveryFormat || (v1.DeliveryFormat = {}));
                let DeliveryStatus;
                (function (DeliveryStatus) {
                    DeliveryStatus["Active"] = "active";
                    DeliveryStatus["Suspended"] = "suspended";
                })(DeliveryStatus = v1.DeliveryStatus || (v1.DeliveryStatus = {}));
                let Frequency;
                (function (Frequency) {
                    Frequency["Immediate"] = "immediate";
                    Frequency["Daily"] = "daily";
                    Frequency["Weekly"] = "weekly";
                    Frequency["Monthly"] = "monthly";
                    Frequency["Yearly"] = "yearly";
                })(Frequency = v1.Frequency || (v1.Frequency = {}));
            })(v1 = UpdateLocationSubscriber.v1 || (UpdateLocationSubscriber.v1 = {}));
        })(UpdateLocationSubscriber = Locations.UpdateLocationSubscriber || (Locations.UpdateLocationSubscriber = {}));
    })(Locations = RPCDocs.Locations || (RPCDocs.Locations = {}));
    let Mail;
    (function (Mail) {
        let GetMessage;
        (function (GetMessage) {
            let v1;
            (function (v1) {
                let UserFolder;
                (function (UserFolder) {
                    UserFolder["Inbox"] = "inbox";
                    UserFolder["Sent"] = "sent";
                    UserFolder["Trash"] = "trash";
                })(UserFolder = v1.UserFolder || (v1.UserFolder = {}));
            })(v1 = GetMessage.v1 || (GetMessage.v1 = {}));
        })(GetMessage = Mail.GetMessage || (Mail.GetMessage = {}));
        let GetMessagesList;
        (function (GetMessagesList) {
            let v1;
            (function (v1) {
                let Folder;
                (function (Folder) {
                    Folder["Inbox"] = "inbox";
                    Folder["Sent"] = "sent";
                    Folder["Trash"] = "trash";
                })(Folder = v1.Folder || (v1.Folder = {}));
            })(v1 = GetMessagesList.v1 || (GetMessagesList.v1 = {}));
        })(GetMessagesList = Mail.GetMessagesList || (Mail.GetMessagesList = {}));
    })(Mail = RPCDocs.Mail || (RPCDocs.Mail = {}));
    let Notifications;
    (function (Notifications) {
        let FindMyNotifications;
        (function (FindMyNotifications) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
                let Category;
                (function (Category) {
                    Category["ReportReview"] = "report-review";
                    Category["ShiftRequest"] = "shift-request";
                    Category["System"] = "system";
                    Category["EventOpened"] = "event-opened";
                    Category["EventAssignment"] = "event-assignment";
                })(Category = v1.Category || (v1.Category = {}));
                let Priority;
                (function (Priority) {
                    Priority["Low"] = "low";
                    Priority["Normal"] = "normal";
                    Priority["High"] = "high";
                    Priority["Critical"] = "critical";
                })(Priority = v1.Priority || (v1.Priority = {}));
                let EntityType;
                (function (EntityType) {
                    EntityType["Event"] = "event";
                    EntityType["Report"] = "report";
                })(EntityType = v1.EntityType || (v1.EntityType = {}));
            })(v1 = FindMyNotifications.v1 || (FindMyNotifications.v1 = {}));
        })(FindMyNotifications = Notifications.FindMyNotifications || (Notifications.FindMyNotifications = {}));
        let GetMyNotificationPreferences;
        (function (GetMyNotificationPreferences) {
            let v1;
            (function (v1) {
                let Category;
                (function (Category) {
                    Category["ReportReview"] = "report-review";
                    Category["ShiftRequest"] = "shift-request";
                    Category["System"] = "system";
                    Category["EventOpened"] = "event-opened";
                    Category["EventAssignment"] = "event-assignment";
                })(Category = v1.Category || (v1.Category = {}));
                let Email;
                (function (Email) {
                    Email["Always"] = "always";
                    Email["QuietHours"] = "quiet-hours";
                    Email["Never"] = "never";
                })(Email = v1.Email || (v1.Email = {}));
                let OffDuty;
                (function (OffDuty) {
                    OffDuty["QuietHours"] = "quiet-hours";
                    OffDuty["Never"] = "never";
                })(OffDuty = v1.OffDuty || (v1.OffDuty = {}));
                let Days;
                (function (Days) {
                    Days["Sun"] = "sun";
                    Days["Mon"] = "mon";
                    Days["Tue"] = "tue";
                    Days["Wed"] = "wed";
                    Days["Thu"] = "thu";
                    Days["Fri"] = "fri";
                    Days["Sat"] = "sat";
                })(Days = v1.Days || (v1.Days = {}));
            })(v1 = GetMyNotificationPreferences.v1 || (GetMyNotificationPreferences.v1 = {}));
        })(GetMyNotificationPreferences = Notifications.GetMyNotificationPreferences || (Notifications.GetMyNotificationPreferences = {}));
        let ResolveNotification;
        (function (ResolveNotification) {
            let v1;
            (function (v1) {
                let Via;
                (function (Via) {
                    Via["UserDismiss"] = "user-dismiss";
                    Via["SourceStateChanged"] = "source-state-changed";
                    Via["Expired"] = "expired";
                    Via["System"] = "system";
                })(Via = v1.Via || (v1.Via = {}));
            })(v1 = ResolveNotification.v1 || (ResolveNotification.v1 = {}));
        })(ResolveNotification = Notifications.ResolveNotification || (Notifications.ResolveNotification = {}));
        let SendPushNotification;
        (function (SendPushNotification) {
            let v1;
            (function (v1) {
                let Priority;
                (function (Priority) {
                    Priority["High"] = "high";
                    Priority["Normal"] = "normal";
                })(Priority = v1.Priority || (v1.Priority = {}));
            })(v1 = SendPushNotification.v1 || (SendPushNotification.v1 = {}));
        })(SendPushNotification = Notifications.SendPushNotification || (Notifications.SendPushNotification = {}));
        let SendPushNotificationRaw;
        (function (SendPushNotificationRaw) {
            let v1;
            (function (v1) {
                let Priority;
                (function (Priority) {
                    Priority["High"] = "high";
                    Priority["Normal"] = "normal";
                })(Priority = v1.Priority || (v1.Priority = {}));
                let NotificationPriority;
                (function (NotificationPriority) {
                    NotificationPriority["Min"] = "min";
                    NotificationPriority["Low"] = "low";
                    NotificationPriority["Default"] = "default";
                    NotificationPriority["High"] = "high";
                    NotificationPriority["Max"] = "max";
                })(NotificationPriority = v1.NotificationPriority || (v1.NotificationPriority = {}));
                let Visibility;
                (function (Visibility) {
                    Visibility["Private"] = "private";
                    Visibility["Public"] = "public";
                    Visibility["Secret"] = "secret";
                })(Visibility = v1.Visibility || (v1.Visibility = {}));
                let Type;
                (function (Type) {
                    Type["Fcm"] = "fcm";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = SendPushNotificationRaw.v1 || (SendPushNotificationRaw.v1 = {}));
        })(SendPushNotificationRaw = Notifications.SendPushNotificationRaw || (Notifications.SendPushNotificationRaw = {}));
        let SetMyNotificationPreferences;
        (function (SetMyNotificationPreferences) {
            let v1;
            (function (v1) {
                let Category;
                (function (Category) {
                    Category["ReportReview"] = "report-review";
                    Category["ShiftRequest"] = "shift-request";
                    Category["System"] = "system";
                    Category["EventOpened"] = "event-opened";
                    Category["EventAssignment"] = "event-assignment";
                })(Category = v1.Category || (v1.Category = {}));
                let Email;
                (function (Email) {
                    Email["Always"] = "always";
                    Email["QuietHours"] = "quiet-hours";
                    Email["Never"] = "never";
                })(Email = v1.Email || (v1.Email = {}));
                let OffDuty;
                (function (OffDuty) {
                    OffDuty["QuietHours"] = "quiet-hours";
                    OffDuty["Never"] = "never";
                })(OffDuty = v1.OffDuty || (v1.OffDuty = {}));
                let Days;
                (function (Days) {
                    Days["Sun"] = "sun";
                    Days["Mon"] = "mon";
                    Days["Tue"] = "tue";
                    Days["Wed"] = "wed";
                    Days["Thu"] = "thu";
                    Days["Fri"] = "fri";
                    Days["Sat"] = "sat";
                })(Days = v1.Days || (v1.Days = {}));
            })(v1 = SetMyNotificationPreferences.v1 || (SetMyNotificationPreferences.v1 = {}));
        })(SetMyNotificationPreferences = Notifications.SetMyNotificationPreferences || (Notifications.SetMyNotificationPreferences = {}));
    })(Notifications = RPCDocs.Notifications || (RPCDocs.Notifications = {}));
    let OpsTrends;
    (function (OpsTrends) {
        let CompareTrendPeriods;
        (function (CompareTrendPeriods) {
            let v1;
            (function (v1) {
                let Direction;
                (function (Direction) {
                    Direction["Up"] = "up";
                })(Direction = v1.Direction || (v1.Direction = {}));
                let DeltaDirection;
                (function (DeltaDirection) {
                    DeltaDirection["Down"] = "down";
                })(DeltaDirection = v1.DeltaDirection || (v1.DeltaDirection = {}));
                let DataDeltaDirection;
                (function (DataDeltaDirection) {
                    DataDeltaDirection["Flat"] = "flat";
                })(DataDeltaDirection = v1.DataDeltaDirection || (v1.DataDeltaDirection = {}));
            })(v1 = CompareTrendPeriods.v1 || (CompareTrendPeriods.v1 = {}));
        })(CompareTrendPeriods = OpsTrends.CompareTrendPeriods || (OpsTrends.CompareTrendPeriods = {}));
        let CreateTrendConfig;
        (function (CreateTrendConfig) {
            let v1;
            (function (v1) {
                let Measure;
                (function (Measure) {
                    Measure["Count"] = "count";
                })(Measure = v1.Measure || (v1.Measure = {}));
                let ArgsMeasure;
                (function (ArgsMeasure) {
                    ArgsMeasure["Sum"] = "sum";
                })(ArgsMeasure = v1.ArgsMeasure || (v1.ArgsMeasure = {}));
                let ArgsMeasure2;
                (function (ArgsMeasure2) {
                    ArgsMeasure2["Avg"] = "avg";
                })(ArgsMeasure2 = v1.ArgsMeasure2 || (v1.ArgsMeasure2 = {}));
                let DefaultInterval;
                (function (DefaultInterval) {
                    DefaultInterval["Hour"] = "hour";
                })(DefaultInterval = v1.DefaultInterval || (v1.DefaultInterval = {}));
                let ArgsDefaultInterval;
                (function (ArgsDefaultInterval) {
                    ArgsDefaultInterval["Day"] = "day";
                })(ArgsDefaultInterval = v1.ArgsDefaultInterval || (v1.ArgsDefaultInterval = {}));
                let ArgsDefaultInterval2;
                (function (ArgsDefaultInterval2) {
                    ArgsDefaultInterval2["Week"] = "week";
                })(ArgsDefaultInterval2 = v1.ArgsDefaultInterval2 || (v1.ArgsDefaultInterval2 = {}));
                let ArgsDefaultInterval3;
                (function (ArgsDefaultInterval3) {
                    ArgsDefaultInterval3["Month"] = "month";
                })(ArgsDefaultInterval3 = v1.ArgsDefaultInterval3 || (v1.ArgsDefaultInterval3 = {}));
                let ArgsDefaultInterval4;
                (function (ArgsDefaultInterval4) {
                    ArgsDefaultInterval4["Year"] = "year";
                })(ArgsDefaultInterval4 = v1.ArgsDefaultInterval4 || (v1.ArgsDefaultInterval4 = {}));
            })(v1 = CreateTrendConfig.v1 || (CreateTrendConfig.v1 = {}));
        })(CreateTrendConfig = OpsTrends.CreateTrendConfig || (OpsTrends.CreateTrendConfig = {}));
        let FindTrendConfigs;
        (function (FindTrendConfigs) {
            let v1;
            (function (v1) {
                let Measure;
                (function (Measure) {
                    Measure["Count"] = "count";
                })(Measure = v1.Measure || (v1.Measure = {}));
                let ConfigsMeasure;
                (function (ConfigsMeasure) {
                    ConfigsMeasure["Sum"] = "sum";
                })(ConfigsMeasure = v1.ConfigsMeasure || (v1.ConfigsMeasure = {}));
                let DataConfigsMeasure;
                (function (DataConfigsMeasure) {
                    DataConfigsMeasure["Avg"] = "avg";
                })(DataConfigsMeasure = v1.DataConfigsMeasure || (v1.DataConfigsMeasure = {}));
                let DefaultInterval;
                (function (DefaultInterval) {
                    DefaultInterval["Hour"] = "hour";
                })(DefaultInterval = v1.DefaultInterval || (v1.DefaultInterval = {}));
                let ConfigsDefaultInterval;
                (function (ConfigsDefaultInterval) {
                    ConfigsDefaultInterval["Day"] = "day";
                })(ConfigsDefaultInterval = v1.ConfigsDefaultInterval || (v1.ConfigsDefaultInterval = {}));
                let DataConfigsDefaultInterval;
                (function (DataConfigsDefaultInterval) {
                    DataConfigsDefaultInterval["Week"] = "week";
                })(DataConfigsDefaultInterval = v1.DataConfigsDefaultInterval || (v1.DataConfigsDefaultInterval = {}));
                let DataConfigsDefaultInterval2;
                (function (DataConfigsDefaultInterval2) {
                    DataConfigsDefaultInterval2["Month"] = "month";
                })(DataConfigsDefaultInterval2 = v1.DataConfigsDefaultInterval2 || (v1.DataConfigsDefaultInterval2 = {}));
                let DataConfigsDefaultInterval3;
                (function (DataConfigsDefaultInterval3) {
                    DataConfigsDefaultInterval3["Year"] = "year";
                })(DataConfigsDefaultInterval3 = v1.DataConfigsDefaultInterval3 || (v1.DataConfigsDefaultInterval3 = {}));
            })(v1 = FindTrendConfigs.v1 || (FindTrendConfigs.v1 = {}));
        })(FindTrendConfigs = OpsTrends.FindTrendConfigs || (OpsTrends.FindTrendConfigs = {}));
        let GetTrendsPeriod;
        (function (GetTrendsPeriod) {
            let v1;
            (function (v1) {
                let Interval;
                (function (Interval) {
                    Interval["Hour"] = "hour";
                })(Interval = v1.Interval || (v1.Interval = {}));
                let ArgsInterval;
                (function (ArgsInterval) {
                    ArgsInterval["Day"] = "day";
                })(ArgsInterval = v1.ArgsInterval || (v1.ArgsInterval = {}));
                let ArgsInterval2;
                (function (ArgsInterval2) {
                    ArgsInterval2["Week"] = "week";
                })(ArgsInterval2 = v1.ArgsInterval2 || (v1.ArgsInterval2 = {}));
                let ArgsInterval3;
                (function (ArgsInterval3) {
                    ArgsInterval3["Month"] = "month";
                })(ArgsInterval3 = v1.ArgsInterval3 || (v1.ArgsInterval3 = {}));
                let ArgsInterval4;
                (function (ArgsInterval4) {
                    ArgsInterval4["Year"] = "year";
                })(ArgsInterval4 = v1.ArgsInterval4 || (v1.ArgsInterval4 = {}));
                let Measure;
                (function (Measure) {
                    Measure["Count"] = "count";
                })(Measure = v1.Measure || (v1.Measure = {}));
                let ConfigMeasure;
                (function (ConfigMeasure) {
                    ConfigMeasure["Sum"] = "sum";
                })(ConfigMeasure = v1.ConfigMeasure || (v1.ConfigMeasure = {}));
                let DataConfigMeasure;
                (function (DataConfigMeasure) {
                    DataConfigMeasure["Avg"] = "avg";
                })(DataConfigMeasure = v1.DataConfigMeasure || (v1.DataConfigMeasure = {}));
            })(v1 = GetTrendsPeriod.v1 || (GetTrendsPeriod.v1 = {}));
        })(GetTrendsPeriod = OpsTrends.GetTrendsPeriod || (OpsTrends.GetTrendsPeriod = {}));
        let UpdateTrendConfig;
        (function (UpdateTrendConfig) {
            let v1;
            (function (v1) {
                let Measure;
                (function (Measure) {
                    Measure["Count"] = "count";
                })(Measure = v1.Measure || (v1.Measure = {}));
                let ArgsMeasure;
                (function (ArgsMeasure) {
                    ArgsMeasure["Sum"] = "sum";
                })(ArgsMeasure = v1.ArgsMeasure || (v1.ArgsMeasure = {}));
                let ArgsMeasure2;
                (function (ArgsMeasure2) {
                    ArgsMeasure2["Avg"] = "avg";
                })(ArgsMeasure2 = v1.ArgsMeasure2 || (v1.ArgsMeasure2 = {}));
                let DefaultInterval;
                (function (DefaultInterval) {
                    DefaultInterval["Hour"] = "hour";
                })(DefaultInterval = v1.DefaultInterval || (v1.DefaultInterval = {}));
                let ArgsDefaultInterval;
                (function (ArgsDefaultInterval) {
                    ArgsDefaultInterval["Day"] = "day";
                })(ArgsDefaultInterval = v1.ArgsDefaultInterval || (v1.ArgsDefaultInterval = {}));
                let ArgsDefaultInterval2;
                (function (ArgsDefaultInterval2) {
                    ArgsDefaultInterval2["Week"] = "week";
                })(ArgsDefaultInterval2 = v1.ArgsDefaultInterval2 || (v1.ArgsDefaultInterval2 = {}));
                let ArgsDefaultInterval3;
                (function (ArgsDefaultInterval3) {
                    ArgsDefaultInterval3["Month"] = "month";
                })(ArgsDefaultInterval3 = v1.ArgsDefaultInterval3 || (v1.ArgsDefaultInterval3 = {}));
                let ArgsDefaultInterval4;
                (function (ArgsDefaultInterval4) {
                    ArgsDefaultInterval4["Year"] = "year";
                })(ArgsDefaultInterval4 = v1.ArgsDefaultInterval4 || (v1.ArgsDefaultInterval4 = {}));
            })(v1 = UpdateTrendConfig.v1 || (UpdateTrendConfig.v1 = {}));
        })(UpdateTrendConfig = OpsTrends.UpdateTrendConfig || (OpsTrends.UpdateTrendConfig = {}));
    })(OpsTrends = RPCDocs.OpsTrends || (RPCDocs.OpsTrends = {}));
    let Organizations;
    (function (Organizations) {
        let GetOrganizationProfile;
        (function (GetOrganizationProfile) {
            let v1;
            (function (v1) {
                let Email;
                (function (Email) {
                    Email["Always"] = "always";
                    Email["QuietHours"] = "quiet-hours";
                    Email["Never"] = "never";
                })(Email = v1.Email || (v1.Email = {}));
                let OffDuty;
                (function (OffDuty) {
                    OffDuty["QuietHours"] = "quiet-hours";
                    OffDuty["Never"] = "never";
                })(OffDuty = v1.OffDuty || (v1.OffDuty = {}));
                let AttachmentFormat;
                (function (AttachmentFormat) {
                    AttachmentFormat["Html"] = "html";
                    AttachmentFormat["Pdf"] = "pdf";
                })(AttachmentFormat = v1.AttachmentFormat || (v1.AttachmentFormat = {}));
                let ContentSortOrder;
                (function (ContentSortOrder) {
                    ContentSortOrder["OldestFirst"] = "oldest-first";
                    ContentSortOrder["NewestFirst"] = "newest-first";
                })(ContentSortOrder = v1.ContentSortOrder || (v1.ContentSortOrder = {}));
            })(v1 = GetOrganizationProfile.v1 || (GetOrganizationProfile.v1 = {}));
        })(GetOrganizationProfile = Organizations.GetOrganizationProfile || (Organizations.GetOrganizationProfile = {}));
        let GetOrganizationSubscriptionDetails;
        (function (GetOrganizationSubscriptionDetails) {
            let v1;
            (function (v1) {
                let Plan;
                (function (Plan) {
                    Plan["Cancelled"] = "cancelled";
                    Plan["Free"] = "free";
                    Plan["Core"] = "core";
                    Plan["Trial"] = "trial";
                })(Plan = v1.Plan || (v1.Plan = {}));
                let Status;
                (function (Status) {
                    Status["InitialTrial"] = "initial_trial";
                    Status["ExtendedTrial"] = "extended_trial";
                    Status["TrialEnded"] = "trial_ended";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetOrganizationSubscriptionDetails.v1 || (GetOrganizationSubscriptionDetails.v1 = {}));
        })(GetOrganizationSubscriptionDetails = Organizations.GetOrganizationSubscriptionDetails || (Organizations.GetOrganizationSubscriptionDetails = {}));
        let SetOrganizationNotificationDefaults;
        (function (SetOrganizationNotificationDefaults) {
            let v1;
            (function (v1) {
                let Email;
                (function (Email) {
                    Email["Always"] = "always";
                    Email["QuietHours"] = "quiet-hours";
                    Email["Never"] = "never";
                })(Email = v1.Email || (v1.Email = {}));
                let OffDuty;
                (function (OffDuty) {
                    OffDuty["QuietHours"] = "quiet-hours";
                    OffDuty["Never"] = "never";
                })(OffDuty = v1.OffDuty || (v1.OffDuty = {}));
            })(v1 = SetOrganizationNotificationDefaults.v1 || (SetOrganizationNotificationDefaults.v1 = {}));
        })(SetOrganizationNotificationDefaults = Organizations.SetOrganizationNotificationDefaults || (Organizations.SetOrganizationNotificationDefaults = {}));
        let UpdateOrganization;
        (function (UpdateOrganization) {
            let v1;
            (function (v1) {
                let AttachmentFormat;
                (function (AttachmentFormat) {
                    AttachmentFormat["Html"] = "html";
                    AttachmentFormat["Pdf"] = "pdf";
                })(AttachmentFormat = v1.AttachmentFormat || (v1.AttachmentFormat = {}));
                let ContentSortOrder;
                (function (ContentSortOrder) {
                    ContentSortOrder["OldestFirst"] = "oldest-first";
                    ContentSortOrder["NewestFirst"] = "newest-first";
                })(ContentSortOrder = v1.ContentSortOrder || (v1.ContentSortOrder = {}));
            })(v1 = UpdateOrganization.v1 || (UpdateOrganization.v1 = {}));
        })(UpdateOrganization = Organizations.UpdateOrganization || (Organizations.UpdateOrganization = {}));
    })(Organizations = RPCDocs.Organizations || (RPCDocs.Organizations = {}));
    let Patrol;
    (function (Patrol) {
        let EndPatrolRouteRun;
        (function (EndPatrolRouteRun) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = EndPatrolRouteRun.v1 || (EndPatrolRouteRun.v1 = {}));
        })(EndPatrolRouteRun = Patrol.EndPatrolRouteRun || (Patrol.EndPatrolRouteRun = {}));
        let FindPatrolRoutes;
        (function (FindPatrolRoutes) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
            })(v1 = FindPatrolRoutes.v1 || (FindPatrolRoutes.v1 = {}));
        })(FindPatrolRoutes = Patrol.FindPatrolRoutes || (Patrol.FindPatrolRoutes = {}));
        let FindPatrolRoutesRuns;
        (function (FindPatrolRoutesRuns) {
            let v1;
            (function (v1) {
                let StatusFilter;
                (function (StatusFilter) {
                    StatusFilter["Ended"] = "ended";
                    StatusFilter["Inprogress"] = "inprogress";
                })(StatusFilter = v1.StatusFilter || (v1.StatusFilter = {}));
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
            })(v1 = FindPatrolRoutesRuns.v1 || (FindPatrolRoutesRuns.v1 = {}));
            let v2;
            (function (v2) {
                let StatusFilter;
                (function (StatusFilter) {
                    StatusFilter["Ended"] = "ended";
                    StatusFilter["Inprogress"] = "inprogress";
                })(StatusFilter = v2.StatusFilter || (v2.StatusFilter = {}));
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v2.Sort || (v2.Sort = {}));
                let Status;
                (function (Status) {
                    Status["Completed"] = "completed";
                    Status["Skipped"] = "skipped";
                    Status["InProgress"] = "in-progress";
                })(Status = v2.Status || (v2.Status = {}));
            })(v2 = FindPatrolRoutesRuns.v2 || (FindPatrolRoutesRuns.v2 = {}));
        })(FindPatrolRoutesRuns = Patrol.FindPatrolRoutesRuns || (Patrol.FindPatrolRoutesRuns = {}));
        let GetPatrolRouteDetails;
        (function (GetPatrolRouteDetails) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetPatrolRouteDetails.v1 || (GetPatrolRouteDetails.v1 = {}));
        })(GetPatrolRouteDetails = Patrol.GetPatrolRouteDetails || (Patrol.GetPatrolRouteDetails = {}));
        let GetPatrolRouteRunDetails;
        (function (GetPatrolRouteRunDetails) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v1.Status || (v1.Status = {}));
                let LocationVisitsStatus;
                (function (LocationVisitsStatus) {
                    LocationVisitsStatus["Completed"] = "completed";
                    LocationVisitsStatus["Skipped"] = "skipped";
                    LocationVisitsStatus["InProgress"] = "in-progress";
                })(LocationVisitsStatus = v1.LocationVisitsStatus || (v1.LocationVisitsStatus = {}));
            })(v1 = GetPatrolRouteRunDetails.v1 || (GetPatrolRouteRunDetails.v1 = {}));
            let v2;
            (function (v2) {
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v2.Status || (v2.Status = {}));
                let VisitsStatus;
                (function (VisitsStatus) {
                    VisitsStatus["Completed"] = "completed";
                    VisitsStatus["Skipped"] = "skipped";
                    VisitsStatus["InProgress"] = "in-progress";
                })(VisitsStatus = v2.VisitsStatus || (v2.VisitsStatus = {}));
            })(v2 = GetPatrolRouteRunDetails.v2 || (GetPatrolRouteRunDetails.v2 = {}));
        })(GetPatrolRouteRunDetails = Patrol.GetPatrolRouteRunDetails || (Patrol.GetPatrolRouteRunDetails = {}));
        let GetPatrolRoutesActivityForTheDay;
        (function (GetPatrolRoutesActivityForTheDay) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v1.Status || (v1.Status = {}));
                let VisitsStatusesStatus;
                (function (VisitsStatusesStatus) {
                    VisitsStatusesStatus["Completed"] = "completed";
                    VisitsStatusesStatus["Skipped"] = "skipped";
                    VisitsStatusesStatus["InProgress"] = "in-progress";
                })(VisitsStatusesStatus = v1.VisitsStatusesStatus || (v1.VisitsStatusesStatus = {}));
            })(v1 = GetPatrolRoutesActivityForTheDay.v1 || (GetPatrolRoutesActivityForTheDay.v1 = {}));
        })(GetPatrolRoutesActivityForTheDay = Patrol.GetPatrolRoutesActivityForTheDay || (Patrol.GetPatrolRoutesActivityForTheDay = {}));
        let ReOpenPatrolRouteRun;
        (function (ReOpenPatrolRouteRun) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = ReOpenPatrolRouteRun.v1 || (ReOpenPatrolRouteRun.v1 = {}));
        })(ReOpenPatrolRouteRun = Patrol.ReOpenPatrolRouteRun || (Patrol.ReOpenPatrolRouteRun = {}));
        let StartPatrolRouteRun;
        (function (StartPatrolRouteRun) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v1.Status || (v1.Status = {}));
                let LocationVisitsStatus;
                (function (LocationVisitsStatus) {
                    LocationVisitsStatus["Completed"] = "completed";
                    LocationVisitsStatus["Skipped"] = "skipped";
                    LocationVisitsStatus["InProgress"] = "in-progress";
                })(LocationVisitsStatus = v1.LocationVisitsStatus || (v1.LocationVisitsStatus = {}));
            })(v1 = StartPatrolRouteRun.v1 || (StartPatrolRouteRun.v1 = {}));
            let v2;
            (function (v2) {
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v2.Status || (v2.Status = {}));
                let VisitsStatus;
                (function (VisitsStatus) {
                    VisitsStatus["Completed"] = "completed";
                    VisitsStatus["Skipped"] = "skipped";
                    VisitsStatus["InProgress"] = "in-progress";
                })(VisitsStatus = v2.VisitsStatus || (v2.VisitsStatus = {}));
            })(v2 = StartPatrolRouteRun.v2 || (StartPatrolRouteRun.v2 = {}));
        })(StartPatrolRouteRun = Patrol.StartPatrolRouteRun || (Patrol.StartPatrolRouteRun = {}));
        let UpdatePatrolRouteRun;
        (function (UpdatePatrolRouteRun) {
            let v1;
            (function (v1) {
                let NewStatus;
                (function (NewStatus) {
                    NewStatus["Ended"] = "ended";
                    NewStatus["Inprogress"] = "inprogress";
                })(NewStatus = v1.NewStatus || (v1.NewStatus = {}));
            })(v1 = UpdatePatrolRouteRun.v1 || (UpdatePatrolRouteRun.v1 = {}));
        })(UpdatePatrolRouteRun = Patrol.UpdatePatrolRouteRun || (Patrol.UpdatePatrolRouteRun = {}));
        let UpdatePatrolRouteRunVisit;
        (function (UpdatePatrolRouteRunVisit) {
            let v1;
            (function (v1) {
                let NewStatus;
                (function (NewStatus) {
                    NewStatus["Completed"] = "completed";
                    NewStatus["Skipped"] = "skipped";
                    NewStatus["InProgress"] = "in-progress";
                })(NewStatus = v1.NewStatus || (v1.NewStatus = {}));
            })(v1 = UpdatePatrolRouteRunVisit.v1 || (UpdatePatrolRouteRunVisit.v1 = {}));
        })(UpdatePatrolRouteRunVisit = Patrol.UpdatePatrolRouteRunVisit || (Patrol.UpdatePatrolRouteRunVisit = {}));
    })(Patrol = RPCDocs.Patrol || (RPCDocs.Patrol = {}));
    let Public;
    (function (Public) {
        let GetLocationSubscriberContent;
        (function (GetLocationSubscriberContent) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Pdf"] = "pdf";
                    Type["Image"] = "image";
                    Type["Video"] = "video";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetLocationSubscriberContent.v1 || (GetLocationSubscriberContent.v1 = {}));
        })(GetLocationSubscriberContent = Public.GetLocationSubscriberContent || (Public.GetLocationSubscriberContent = {}));
        let GetPublicContentDetails;
        (function (GetPublicContentDetails) {
            let v2;
            (function (v2) {
                let Methods;
                (function (Methods) {
                    Methods["OneTimeCode"] = "one-time-code";
                })(Methods = v2.Methods || (v2.Methods = {}));
                let DataMethods;
                (function (DataMethods) {
                    DataMethods["AccountPassword"] = "account-password";
                })(DataMethods = v2.DataMethods || (v2.DataMethods = {}));
                let Status;
                (function (Status) {
                    Status["Ok"] = "ok";
                })(Status = v2.Status || (v2.Status = {}));
                let DataStatus;
                (function (DataStatus) {
                    DataStatus["Challenge"] = "challenge";
                })(DataStatus = v2.DataStatus || (v2.DataStatus = {}));
            })(v2 = GetPublicContentDetails.v2 || (GetPublicContentDetails.v2 = {}));
        })(GetPublicContentDetails = Public.GetPublicContentDetails || (Public.GetPublicContentDetails = {}));
    })(Public = RPCDocs.Public || (RPCDocs.Public = {}));
    let Records;
    (function (Records) {
        let BulkCreateRecords;
        (function (BulkCreateRecords) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Item"] = "item";
                    Type["Person"] = "person";
                    Type["Vehicle"] = "vehicle";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = BulkCreateRecords.v1 || (BulkCreateRecords.v1 = {}));
        })(BulkCreateRecords = Records.BulkCreateRecords || (Records.BulkCreateRecords = {}));
        let CreateRecord;
        (function (CreateRecord) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Item"] = "item";
                    Type["Person"] = "person";
                    Type["Vehicle"] = "vehicle";
                })(Type = v1.Type || (v1.Type = {}));
                let RefLinksType;
                (function (RefLinksType) {
                    RefLinksType["Event"] = "event";
                    RefLinksType["Location"] = "location";
                    RefLinksType["LocationLogEntry"] = "location-log-entry";
                    RefLinksType["Report"] = "report";
                    RefLinksType["ReportEntry"] = "report-entry";
                    RefLinksType["Record"] = "record";
                    RefLinksType["User"] = "user";
                })(RefLinksType = v1.RefLinksType || (v1.RefLinksType = {}));
            })(v1 = CreateRecord.v1 || (CreateRecord.v1 = {}));
        })(CreateRecord = Records.CreateRecord || (Records.CreateRecord = {}));
        let CreateRecordTag;
        (function (CreateRecordTag) {
            let v1;
            (function (v1) {
                let Types;
                (function (Types) {
                    Types["Item"] = "item";
                    Types["Person"] = "person";
                    Types["Vehicle"] = "vehicle";
                })(Types = v1.Types || (v1.Types = {}));
            })(v1 = CreateRecordTag.v1 || (CreateRecordTag.v1 = {}));
        })(CreateRecordTag = Records.CreateRecordTag || (Records.CreateRecordTag = {}));
        let DownloadRecord;
        (function (DownloadRecord) {
            let v1;
            (function (v1) {
                let Format;
                (function (Format) {
                    Format["Html"] = "html";
                    Format["Pdf"] = "pdf";
                })(Format = v1.Format || (v1.Format = {}));
            })(v1 = DownloadRecord.v1 || (DownloadRecord.v1 = {}));
        })(DownloadRecord = Records.DownloadRecord || (Records.DownloadRecord = {}));
        let GetRecordProfile;
        (function (GetRecordProfile) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Person"] = "person";
                    Type["Item"] = "item";
                    Type["Vehicle"] = "vehicle";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetRecordProfile.v1 || (GetRecordProfile.v1 = {}));
        })(GetRecordProfile = Records.GetRecordProfile || (Records.GetRecordProfile = {}));
        let GetRecordProfiles;
        (function (GetRecordProfiles) {
            let v1;
            (function (v1) {
                let TypeFilter;
                (function (TypeFilter) {
                    TypeFilter["Item"] = "item";
                    TypeFilter["Person"] = "person";
                    TypeFilter["Vehicle"] = "vehicle";
                })(TypeFilter = v1.TypeFilter || (v1.TypeFilter = {}));
            })(v1 = GetRecordProfiles.v1 || (GetRecordProfiles.v1 = {}));
        })(GetRecordProfiles = Records.GetRecordProfiles || (Records.GetRecordProfiles = {}));
        let GetRecordTagsList;
        (function (GetRecordTagsList) {
            let v1;
            (function (v1) {
                let TypeFilter;
                (function (TypeFilter) {
                    TypeFilter["Item"] = "item";
                    TypeFilter["Person"] = "person";
                    TypeFilter["Vehicle"] = "vehicle";
                })(TypeFilter = v1.TypeFilter || (v1.TypeFilter = {}));
            })(v1 = GetRecordTagsList.v1 || (GetRecordTagsList.v1 = {}));
        })(GetRecordTagsList = Records.GetRecordTagsList || (Records.GetRecordTagsList = {}));
        let GetRecordsList;
        (function (GetRecordsList) {
            let v1;
            (function (v1) {
                let TypeFilter;
                (function (TypeFilter) {
                    TypeFilter["Item"] = "item";
                    TypeFilter["Person"] = "person";
                    TypeFilter["Vehicle"] = "vehicle";
                })(TypeFilter = v1.TypeFilter || (v1.TypeFilter = {}));
            })(v1 = GetRecordsList.v1 || (GetRecordsList.v1 = {}));
        })(GetRecordsList = Records.GetRecordsList || (Records.GetRecordsList = {}));
        let UpdateRecordTag;
        (function (UpdateRecordTag) {
            let v1;
            (function (v1) {
                let Types;
                (function (Types) {
                    Types["Item"] = "item";
                    Types["Person"] = "person";
                    Types["Vehicle"] = "vehicle";
                })(Types = v1.Types || (v1.Types = {}));
            })(v1 = UpdateRecordTag.v1 || (UpdateRecordTag.v1 = {}));
        })(UpdateRecordTag = Records.UpdateRecordTag || (Records.UpdateRecordTag = {}));
    })(Records = RPCDocs.Records || (RPCDocs.Records = {}));
    let RefLinks;
    (function (RefLinks) {
        let GetRefLink;
        (function (GetRefLink) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Event"] = "event";
                    Type["Location"] = "location";
                    Type["LocationLogEntry"] = "location-log-entry";
                    Type["Report"] = "report";
                    Type["ReportEntry"] = "report-entry";
                    Type["Record"] = "record";
                    Type["User"] = "user";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetRefLink.v1 || (GetRefLink.v1 = {}));
        })(GetRefLink = RefLinks.GetRefLink || (RefLinks.GetRefLink = {}));
        let GetRefLinks;
        (function (GetRefLinks) {
            let v1;
            (function (v1) {
                let RefTypes;
                (function (RefTypes) {
                    RefTypes["Event"] = "event";
                    RefTypes["Location"] = "location";
                    RefTypes["LocationLogEntry"] = "location-log-entry";
                    RefTypes["Report"] = "report";
                    RefTypes["ReportEntry"] = "report-entry";
                    RefTypes["Record"] = "record";
                    RefTypes["User"] = "user";
                })(RefTypes = v1.RefTypes || (v1.RefTypes = {}));
            })(v1 = GetRefLinks.v1 || (GetRefLinks.v1 = {}));
        })(GetRefLinks = RefLinks.GetRefLinks || (RefLinks.GetRefLinks = {}));
        let SaveRefLink;
        (function (SaveRefLink) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Event"] = "event";
                    Type["Location"] = "location";
                    Type["LocationLogEntry"] = "location-log-entry";
                    Type["Report"] = "report";
                    Type["ReportEntry"] = "report-entry";
                    Type["Record"] = "record";
                    Type["User"] = "user";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = SaveRefLink.v1 || (SaveRefLink.v1 = {}));
        })(SaveRefLink = RefLinks.SaveRefLink || (RefLinks.SaveRefLink = {}));
    })(RefLinks = RPCDocs.RefLinks || (RPCDocs.RefLinks = {}));
    let Regions;
    (function (Regions) {
        let CreateRegion;
        (function (CreateRegion) {
            let v1;
            (function (v1) {
                let AttachmentFormat;
                (function (AttachmentFormat) {
                    AttachmentFormat["Html"] = "html";
                    AttachmentFormat["Pdf"] = "pdf";
                })(AttachmentFormat = v1.AttachmentFormat || (v1.AttachmentFormat = {}));
                let ContentSortOrder;
                (function (ContentSortOrder) {
                    ContentSortOrder["OldestFirst"] = "oldest-first";
                    ContentSortOrder["NewestFirst"] = "newest-first";
                })(ContentSortOrder = v1.ContentSortOrder || (v1.ContentSortOrder = {}));
                let ActivityTypeTags;
                (function (ActivityTypeTags) {
                    ActivityTypeTags["OnlyOwnRegion"] = "only-own-region";
                    ActivityTypeTags["OwnRegionAndOrg"] = "own-region-and-org";
                })(ActivityTypeTags = v1.ActivityTypeTags || (v1.ActivityTypeTags = {}));
            })(v1 = CreateRegion.v1 || (CreateRegion.v1 = {}));
        })(CreateRegion = Regions.CreateRegion || (Regions.CreateRegion = {}));
        let GetRegionProfile;
        (function (GetRegionProfile) {
            let v1;
            (function (v1) {
                let AttachmentFormat;
                (function (AttachmentFormat) {
                    AttachmentFormat["Html"] = "html";
                    AttachmentFormat["Pdf"] = "pdf";
                })(AttachmentFormat = v1.AttachmentFormat || (v1.AttachmentFormat = {}));
                let ContentSortOrder;
                (function (ContentSortOrder) {
                    ContentSortOrder["OldestFirst"] = "oldest-first";
                    ContentSortOrder["NewestFirst"] = "newest-first";
                })(ContentSortOrder = v1.ContentSortOrder || (v1.ContentSortOrder = {}));
                let ActivityTypeTags;
                (function (ActivityTypeTags) {
                    ActivityTypeTags["OnlyOwnRegion"] = "only-own-region";
                    ActivityTypeTags["OwnRegionAndOrg"] = "own-region-and-org";
                })(ActivityTypeTags = v1.ActivityTypeTags || (v1.ActivityTypeTags = {}));
            })(v1 = GetRegionProfile.v1 || (GetRegionProfile.v1 = {}));
        })(GetRegionProfile = Regions.GetRegionProfile || (Regions.GetRegionProfile = {}));
        let UpdateRegion;
        (function (UpdateRegion) {
            let v1;
            (function (v1) {
                let AttachmentFormat;
                (function (AttachmentFormat) {
                    AttachmentFormat["Html"] = "html";
                    AttachmentFormat["Pdf"] = "pdf";
                })(AttachmentFormat = v1.AttachmentFormat || (v1.AttachmentFormat = {}));
                let ContentSortOrder;
                (function (ContentSortOrder) {
                    ContentSortOrder["OldestFirst"] = "oldest-first";
                    ContentSortOrder["NewestFirst"] = "newest-first";
                })(ContentSortOrder = v1.ContentSortOrder || (v1.ContentSortOrder = {}));
                let ActivityTypeTags;
                (function (ActivityTypeTags) {
                    ActivityTypeTags["OnlyOwnRegion"] = "only-own-region";
                    ActivityTypeTags["OwnRegionAndOrg"] = "own-region-and-org";
                })(ActivityTypeTags = v1.ActivityTypeTags || (v1.ActivityTypeTags = {}));
            })(v1 = UpdateRegion.v1 || (UpdateRegion.v1 = {}));
        })(UpdateRegion = Regions.UpdateRegion || (Regions.UpdateRegion = {}));
    })(Regions = RPCDocs.Regions || (RPCDocs.Regions = {}));
    let Reports;
    (function (Reports) {
        let CreateReportEntry;
        (function (CreateReportEntry) {
            let v2;
            (function (v2) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v2.FormId || (v2.FormId = {}));
            })(v2 = CreateReportEntry.v2 || (CreateReportEntry.v2 = {}));
        })(CreateReportEntry = Reports.CreateReportEntry || (Reports.CreateReportEntry = {}));
        let CreateReportType;
        (function (CreateReportType) {
            let v1;
            (function (v1) {
                let InitialDate;
                (function (InitialDate) {
                    InitialDate["CreatedDate"] = "created-date";
                    InitialDate["UserSelected"] = "user-selected";
                })(InitialDate = v1.InitialDate || (v1.InitialDate = {}));
                let Type;
                (function (Type) {
                    Type["MultiEntry"] = "multi-entry";
                    Type["SingleEntry"] = "single-entry";
                })(Type = v1.Type || (v1.Type = {}));
                let State;
                (function (State) {
                    State["Closed"] = "closed";
                    State["Open"] = "open";
                    State["Review"] = "review";
                })(State = v1.State || (v1.State = {}));
            })(v1 = CreateReportType.v1 || (CreateReportType.v1 = {}));
        })(CreateReportType = Reports.CreateReportType || (Reports.CreateReportType = {}));
        let CreateReportTypesSubscribers;
        (function (CreateReportTypesSubscribers) {
            let v1;
            (function (v1) {
                let DeliveryMethod;
                (function (DeliveryMethod) {
                    DeliveryMethod["Email"] = "email";
                    DeliveryMethod["Sms"] = "sms";
                    DeliveryMethod["Webhook"] = "webhook";
                })(DeliveryMethod = v1.DeliveryMethod || (v1.DeliveryMethod = {}));
                let Frequency;
                (function (Frequency) {
                    Frequency["Immediate"] = "immediate";
                    Frequency["Daily"] = "daily";
                    Frequency["Weekly"] = "weekly";
                    Frequency["Monthly"] = "monthly";
                    Frequency["Yearly"] = "yearly";
                })(Frequency = v1.Frequency || (v1.Frequency = {}));
            })(v1 = CreateReportTypesSubscribers.v1 || (CreateReportTypesSubscribers.v1 = {}));
        })(CreateReportTypesSubscribers = Reports.CreateReportTypesSubscribers || (Reports.CreateReportTypesSubscribers = {}));
        let DownloadReport;
        (function (DownloadReport) {
            let v1;
            (function (v1) {
                let Format;
                (function (Format) {
                    Format["Html"] = "html";
                    Format["Pdf"] = "pdf";
                })(Format = v1.Format || (v1.Format = {}));
            })(v1 = DownloadReport.v1 || (DownloadReport.v1 = {}));
        })(DownloadReport = Reports.DownloadReport || (Reports.DownloadReport = {}));
        let GetReport;
        (function (GetReport) {
            let v1;
            (function (v1) {
                let State;
                (function (State) {
                    State["Open"] = "open";
                    State["Closed"] = "closed";
                    State["Review"] = "review";
                })(State = v1.State || (v1.State = {}));
                let InitialDate;
                (function (InitialDate) {
                    InitialDate["CreatedDate"] = "created-date";
                    InitialDate["UserSelected"] = "user-selected";
                })(InitialDate = v1.InitialDate || (v1.InitialDate = {}));
                let Type;
                (function (Type) {
                    Type["MultiEntry"] = "multi-entry";
                    Type["SingleEntry"] = "single-entry";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetReport.v1 || (GetReport.v1 = {}));
        })(GetReport = Reports.GetReport || (Reports.GetReport = {}));
        let GetReportEntryDetail;
        (function (GetReportEntryDetail) {
            let v1;
            (function (v1) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v1.FormId || (v1.FormId = {}));
            })(v1 = GetReportEntryDetail.v1 || (GetReportEntryDetail.v1 = {}));
        })(GetReportEntryDetail = Reports.GetReportEntryDetail || (Reports.GetReportEntryDetail = {}));
        let GetReportEntryList;
        (function (GetReportEntryList) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
            })(v1 = GetReportEntryList.v1 || (GetReportEntryList.v1 = {}));
            let v2;
            (function (v2) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v2.Sort || (v2.Sort = {}));
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v2.FormId || (v2.FormId = {}));
            })(v2 = GetReportEntryList.v2 || (GetReportEntryList.v2 = {}));
        })(GetReportEntryList = Reports.GetReportEntryList || (Reports.GetReportEntryList = {}));
        let GetReportEntryTypesList;
        (function (GetReportEntryTypesList) {
            let v1;
            (function (v1) {
                let ReportInputConfigType;
                (function (ReportInputConfigType) {
                    ReportInputConfigType["MultiEntry"] = "multi-entry";
                    ReportInputConfigType["SingleEntry"] = "single-entry";
                })(ReportInputConfigType = v1.ReportInputConfigType || (v1.ReportInputConfigType = {}));
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
            })(v1 = GetReportEntryTypesList.v1 || (GetReportEntryTypesList.v1 = {}));
        })(GetReportEntryTypesList = Reports.GetReportEntryTypesList || (Reports.GetReportEntryTypesList = {}));
        let GetReportTypeEntryTypesFormBuilderInputFields;
        (function (GetReportTypeEntryTypesFormBuilderInputFields) {
            let v1;
            (function (v1) {
                let InputConfigType;
                (function (InputConfigType) {
                    InputConfigType["MultiEntry"] = "multi-entry";
                    InputConfigType["SingleEntry"] = "single-entry";
                })(InputConfigType = v1.InputConfigType || (v1.InputConfigType = {}));
            })(v1 = GetReportTypeEntryTypesFormBuilderInputFields.v1 || (GetReportTypeEntryTypesFormBuilderInputFields.v1 = {}));
        })(GetReportTypeEntryTypesFormBuilderInputFields = Reports.GetReportTypeEntryTypesFormBuilderInputFields || (Reports.GetReportTypeEntryTypesFormBuilderInputFields = {}));
        let GetReportTypesDetails;
        (function (GetReportTypesDetails) {
            let v1;
            (function (v1) {
                let InitialDate;
                (function (InitialDate) {
                    InitialDate["CreatedDate"] = "created-date";
                    InitialDate["UserSelected"] = "user-selected";
                })(InitialDate = v1.InitialDate || (v1.InitialDate = {}));
                let Type;
                (function (Type) {
                    Type["MultiEntry"] = "multi-entry";
                    Type["SingleEntry"] = "single-entry";
                })(Type = v1.Type || (v1.Type = {}));
                let State;
                (function (State) {
                    State["Closed"] = "closed";
                    State["Open"] = "open";
                    State["Review"] = "review";
                })(State = v1.State || (v1.State = {}));
            })(v1 = GetReportTypesDetails.v1 || (GetReportTypesDetails.v1 = {}));
        })(GetReportTypesDetails = Reports.GetReportTypesDetails || (Reports.GetReportTypesDetails = {}));
        let GetReportTypesList;
        (function (GetReportTypesList) {
            let v1;
            (function (v1) {
                let InputConfigType;
                (function (InputConfigType) {
                    InputConfigType["MultiEntry"] = "multi-entry";
                    InputConfigType["SingleEntry"] = "single-entry";
                })(InputConfigType = v1.InputConfigType || (v1.InputConfigType = {}));
            })(v1 = GetReportTypesList.v1 || (GetReportTypesList.v1 = {}));
        })(GetReportTypesList = Reports.GetReportTypesList || (Reports.GetReportTypesList = {}));
        let GetReportTypesSubscribers;
        (function (GetReportTypesSubscribers) {
            let v1;
            (function (v1) {
                let DeliveryMethod;
                (function (DeliveryMethod) {
                    DeliveryMethod["Email"] = "email";
                    DeliveryMethod["Sms"] = "sms";
                    DeliveryMethod["User"] = "user";
                    DeliveryMethod["Webhook"] = "webhook";
                })(DeliveryMethod = v1.DeliveryMethod || (v1.DeliveryMethod = {}));
                let DeliveryStatus;
                (function (DeliveryStatus) {
                    DeliveryStatus["Active"] = "active";
                    DeliveryStatus["Suspended"] = "suspended";
                })(DeliveryStatus = v1.DeliveryStatus || (v1.DeliveryStatus = {}));
                let Frequency;
                (function (Frequency) {
                    Frequency["Immediate"] = "immediate";
                    Frequency["Daily"] = "daily";
                    Frequency["Weekly"] = "weekly";
                    Frequency["Monthly"] = "monthly";
                    Frequency["Yearly"] = "yearly";
                })(Frequency = v1.Frequency || (v1.Frequency = {}));
            })(v1 = GetReportTypesSubscribers.v1 || (GetReportTypesSubscribers.v1 = {}));
        })(GetReportTypesSubscribers = Reports.GetReportTypesSubscribers || (Reports.GetReportTypesSubscribers = {}));
        let GetReportsList;
        (function (GetReportsList) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
                let State;
                (function (State) {
                    State["Open"] = "open";
                    State["Closed"] = "closed";
                    State["Review"] = "review";
                })(State = v1.State || (v1.State = {}));
            })(v1 = GetReportsList.v1 || (GetReportsList.v1 = {}));
        })(GetReportsList = Reports.GetReportsList || (Reports.GetReportsList = {}));
        let UpdateReportEntry;
        (function (UpdateReportEntry) {
            let v2;
            (function (v2) {
                let FormId;
                (function (FormId) {
                    FormId["Local"] = "local";
                })(FormId = v2.FormId || (v2.FormId = {}));
            })(v2 = UpdateReportEntry.v2 || (UpdateReportEntry.v2 = {}));
        })(UpdateReportEntry = Reports.UpdateReportEntry || (Reports.UpdateReportEntry = {}));
        let UpdateReportType;
        (function (UpdateReportType) {
            let v1;
            (function (v1) {
                let InitialDate;
                (function (InitialDate) {
                    InitialDate["CreatedDate"] = "created-date";
                    InitialDate["UserSelected"] = "user-selected";
                })(InitialDate = v1.InitialDate || (v1.InitialDate = {}));
                let Type;
                (function (Type) {
                    Type["MultiEntry"] = "multi-entry";
                    Type["SingleEntry"] = "single-entry";
                })(Type = v1.Type || (v1.Type = {}));
                let State;
                (function (State) {
                    State["Closed"] = "closed";
                    State["Open"] = "open";
                    State["Review"] = "review";
                })(State = v1.State || (v1.State = {}));
            })(v1 = UpdateReportType.v1 || (UpdateReportType.v1 = {}));
        })(UpdateReportType = Reports.UpdateReportType || (Reports.UpdateReportType = {}));
        let UpdateReportTypesSubscriber;
        (function (UpdateReportTypesSubscriber) {
            let v1;
            (function (v1) {
                let DeliveryMethod;
                (function (DeliveryMethod) {
                    DeliveryMethod["Email"] = "email";
                    DeliveryMethod["Sms"] = "sms";
                    DeliveryMethod["Webhook"] = "webhook";
                })(DeliveryMethod = v1.DeliveryMethod || (v1.DeliveryMethod = {}));
                let DeliveryStatus;
                (function (DeliveryStatus) {
                    DeliveryStatus["Active"] = "active";
                    DeliveryStatus["Suspended"] = "suspended";
                })(DeliveryStatus = v1.DeliveryStatus || (v1.DeliveryStatus = {}));
                let Frequency;
                (function (Frequency) {
                    Frequency["Immediate"] = "immediate";
                    Frequency["Daily"] = "daily";
                    Frequency["Weekly"] = "weekly";
                    Frequency["Monthly"] = "monthly";
                    Frequency["Yearly"] = "yearly";
                })(Frequency = v1.Frequency || (v1.Frequency = {}));
            })(v1 = UpdateReportTypesSubscriber.v1 || (UpdateReportTypesSubscriber.v1 = {}));
        })(UpdateReportTypesSubscriber = Reports.UpdateReportTypesSubscriber || (Reports.UpdateReportTypesSubscriber = {}));
    })(Reports = RPCDocs.Reports || (RPCDocs.Reports = {}));
    let Scheduling;
    (function (Scheduling) {
        let CreateCustomSchedulingAssignment;
        (function (CreateCustomSchedulingAssignment) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Custom"] = "custom";
                    Type["Location"] = "location";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = CreateCustomSchedulingAssignment.v1 || (CreateCustomSchedulingAssignment.v1 = {}));
        })(CreateCustomSchedulingAssignment = Scheduling.CreateCustomSchedulingAssignment || (Scheduling.CreateCustomSchedulingAssignment = {}));
        let CreateShift;
        (function (CreateShift) {
            let v1;
            (function (v1) {
                let Action;
                (function (Action) {
                    Action["Startshift"] = "startshift";
                    Action["Endshift"] = "endshift";
                    Action["Startbreak"] = "startbreak";
                    Action["Endbreak"] = "endbreak";
                })(Action = v1.Action || (v1.Action = {}));
            })(v1 = CreateShift.v1 || (CreateShift.v1 = {}));
        })(CreateShift = Scheduling.CreateShift || (Scheduling.CreateShift = {}));
        let EditShift;
        (function (EditShift) {
            let v1;
            (function (v1) {
                let Action;
                (function (Action) {
                    Action["Startshift"] = "startshift";
                    Action["Endshift"] = "endshift";
                    Action["Startbreak"] = "startbreak";
                    Action["Endbreak"] = "endbreak";
                })(Action = v1.Action || (v1.Action = {}));
            })(v1 = EditShift.v1 || (EditShift.v1 = {}));
        })(EditShift = Scheduling.EditShift || (Scheduling.EditShift = {}));
        let EndBreak;
        (function (EndBreak) {
            let v1;
            (function (v1) {
                let Timeframe;
                (function (Timeframe) {
                    Timeframe["Past"] = "past";
                    Timeframe["Current"] = "current";
                    Timeframe["Future"] = "future";
                })(Timeframe = v1.Timeframe || (v1.Timeframe = {}));
                let Title;
                (function (Title) {
                    Title["Completed"] = "completed";
                    Title["Missed"] = "missed";
                    Title["Ended"] = "ended";
                    Title["Inprogress"] = "inprogress";
                    Title["Notended"] = "notended";
                    Title["Notstarted"] = "notstarted";
                    Title["Onbreak"] = "onbreak";
                })(Title = v1.Title || (v1.Title = {}));
                let Action;
                (function (Action) {
                    Action["Startshift"] = "startshift";
                    Action["Endshift"] = "endshift";
                    Action["Startbreak"] = "startbreak";
                    Action["Endbreak"] = "endbreak";
                })(Action = v1.Action || (v1.Action = {}));
                let Type;
                (function (Type) {
                    Type["Edited"] = "edited";
                    Type["Missed"] = "missed";
                    Type["StartedLate"] = "started_late";
                    Type["EndedEarly"] = "ended_early";
                    Type["EndedLate"] = "ended_late";
                    Type["GpsOutOfBounds"] = "gps_out_of_bounds";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = EndBreak.v1 || (EndBreak.v1 = {}));
        })(EndBreak = Scheduling.EndBreak || (Scheduling.EndBreak = {}));
        let EndShift;
        (function (EndShift) {
            let v1;
            (function (v1) {
                let Timeframe;
                (function (Timeframe) {
                    Timeframe["Past"] = "past";
                    Timeframe["Current"] = "current";
                    Timeframe["Future"] = "future";
                })(Timeframe = v1.Timeframe || (v1.Timeframe = {}));
                let Title;
                (function (Title) {
                    Title["Completed"] = "completed";
                    Title["Missed"] = "missed";
                    Title["Ended"] = "ended";
                    Title["Inprogress"] = "inprogress";
                    Title["Notended"] = "notended";
                    Title["Notstarted"] = "notstarted";
                    Title["Onbreak"] = "onbreak";
                })(Title = v1.Title || (v1.Title = {}));
                let Action;
                (function (Action) {
                    Action["Startshift"] = "startshift";
                    Action["Endshift"] = "endshift";
                    Action["Startbreak"] = "startbreak";
                    Action["Endbreak"] = "endbreak";
                })(Action = v1.Action || (v1.Action = {}));
                let Type;
                (function (Type) {
                    Type["Edited"] = "edited";
                    Type["Missed"] = "missed";
                    Type["StartedLate"] = "started_late";
                    Type["EndedEarly"] = "ended_early";
                    Type["EndedLate"] = "ended_late";
                    Type["GpsOutOfBounds"] = "gps_out_of_bounds";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = EndShift.v1 || (EndShift.v1 = {}));
        })(EndShift = Scheduling.EndShift || (Scheduling.EndShift = {}));
        let GetCurrentShiftsList;
        (function (GetCurrentShiftsList) {
            let v1;
            (function (v1) {
                let Timeframe;
                (function (Timeframe) {
                    Timeframe["Past"] = "past";
                    Timeframe["Current"] = "current";
                    Timeframe["Future"] = "future";
                })(Timeframe = v1.Timeframe || (v1.Timeframe = {}));
                let Title;
                (function (Title) {
                    Title["Completed"] = "completed";
                    Title["Missed"] = "missed";
                    Title["Ended"] = "ended";
                    Title["Inprogress"] = "inprogress";
                    Title["Notended"] = "notended";
                    Title["Notstarted"] = "notstarted";
                    Title["Onbreak"] = "onbreak";
                })(Title = v1.Title || (v1.Title = {}));
                let Type;
                (function (Type) {
                    Type["Edited"] = "edited";
                    Type["Missed"] = "missed";
                    Type["StartedLate"] = "started_late";
                    Type["EndedEarly"] = "ended_early";
                    Type["EndedLate"] = "ended_late";
                    Type["GpsOutOfBounds"] = "gps_out_of_bounds";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetCurrentShiftsList.v1 || (GetCurrentShiftsList.v1 = {}));
        })(GetCurrentShiftsList = Scheduling.GetCurrentShiftsList || (Scheduling.GetCurrentShiftsList = {}));
        let GetSchedulingAssignment;
        (function (GetSchedulingAssignment) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Custom"] = "custom";
                    Type["Location"] = "location";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetSchedulingAssignment.v1 || (GetSchedulingAssignment.v1 = {}));
        })(GetSchedulingAssignment = Scheduling.GetSchedulingAssignment || (Scheduling.GetSchedulingAssignment = {}));
        let GetSchedulingAssignments;
        (function (GetSchedulingAssignments) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Custom"] = "custom";
                    Type["Location"] = "location";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetSchedulingAssignments.v1 || (GetSchedulingAssignments.v1 = {}));
        })(GetSchedulingAssignments = Scheduling.GetSchedulingAssignments || (Scheduling.GetSchedulingAssignments = {}));
        let GetShiftDetail;
        (function (GetShiftDetail) {
            let v1;
            (function (v1) {
                let Timeframe;
                (function (Timeframe) {
                    Timeframe["Past"] = "past";
                    Timeframe["Current"] = "current";
                    Timeframe["Future"] = "future";
                })(Timeframe = v1.Timeframe || (v1.Timeframe = {}));
                let Title;
                (function (Title) {
                    Title["Completed"] = "completed";
                    Title["Missed"] = "missed";
                    Title["Ended"] = "ended";
                    Title["Inprogress"] = "inprogress";
                    Title["Notended"] = "notended";
                    Title["Notstarted"] = "notstarted";
                    Title["Onbreak"] = "onbreak";
                })(Title = v1.Title || (v1.Title = {}));
                let Type;
                (function (Type) {
                    Type["Edited"] = "edited";
                    Type["Missed"] = "missed";
                    Type["StartedLate"] = "started_late";
                    Type["EndedEarly"] = "ended_early";
                    Type["EndedLate"] = "ended_late";
                    Type["GpsOutOfBounds"] = "gps_out_of_bounds";
                })(Type = v1.Type || (v1.Type = {}));
                let Action;
                (function (Action) {
                    Action["Startshift"] = "startshift";
                    Action["Endshift"] = "endshift";
                    Action["Startbreak"] = "startbreak";
                    Action["Endbreak"] = "endbreak";
                })(Action = v1.Action || (v1.Action = {}));
            })(v1 = GetShiftDetail.v1 || (GetShiftDetail.v1 = {}));
        })(GetShiftDetail = Scheduling.GetShiftDetail || (Scheduling.GetShiftDetail = {}));
        let GetShiftsByStartTimeDetails;
        (function (GetShiftsByStartTimeDetails) {
            let v1;
            (function (v1) {
                let Timeframe;
                (function (Timeframe) {
                    Timeframe["Past"] = "past";
                    Timeframe["Current"] = "current";
                    Timeframe["Future"] = "future";
                })(Timeframe = v1.Timeframe || (v1.Timeframe = {}));
                let Title;
                (function (Title) {
                    Title["Completed"] = "completed";
                    Title["Missed"] = "missed";
                    Title["Ended"] = "ended";
                    Title["Inprogress"] = "inprogress";
                    Title["Notended"] = "notended";
                    Title["Notstarted"] = "notstarted";
                    Title["Onbreak"] = "onbreak";
                })(Title = v1.Title || (v1.Title = {}));
                let Type;
                (function (Type) {
                    Type["Edited"] = "edited";
                    Type["Missed"] = "missed";
                    Type["StartedLate"] = "started_late";
                    Type["EndedEarly"] = "ended_early";
                    Type["EndedLate"] = "ended_late";
                    Type["GpsOutOfBounds"] = "gps_out_of_bounds";
                })(Type = v1.Type || (v1.Type = {}));
                let Action;
                (function (Action) {
                    Action["Startshift"] = "startshift";
                    Action["Endshift"] = "endshift";
                    Action["Startbreak"] = "startbreak";
                    Action["Endbreak"] = "endbreak";
                })(Action = v1.Action || (v1.Action = {}));
            })(v1 = GetShiftsByStartTimeDetails.v1 || (GetShiftsByStartTimeDetails.v1 = {}));
        })(GetShiftsByStartTimeDetails = Scheduling.GetShiftsByStartTimeDetails || (Scheduling.GetShiftsByStartTimeDetails = {}));
        let GetShiftsByStartTimeList;
        (function (GetShiftsByStartTimeList) {
            let v1;
            (function (v1) {
                let Timeframe;
                (function (Timeframe) {
                    Timeframe["Past"] = "past";
                    Timeframe["Current"] = "current";
                    Timeframe["Future"] = "future";
                })(Timeframe = v1.Timeframe || (v1.Timeframe = {}));
                let Title;
                (function (Title) {
                    Title["Completed"] = "completed";
                    Title["Missed"] = "missed";
                    Title["Ended"] = "ended";
                    Title["Inprogress"] = "inprogress";
                    Title["Notended"] = "notended";
                    Title["Notstarted"] = "notstarted";
                    Title["Onbreak"] = "onbreak";
                })(Title = v1.Title || (v1.Title = {}));
                let Type;
                (function (Type) {
                    Type["Edited"] = "edited";
                    Type["Missed"] = "missed";
                    Type["StartedLate"] = "started_late";
                    Type["EndedEarly"] = "ended_early";
                    Type["EndedLate"] = "ended_late";
                    Type["GpsOutOfBounds"] = "gps_out_of_bounds";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetShiftsByStartTimeList.v1 || (GetShiftsByStartTimeList.v1 = {}));
        })(GetShiftsByStartTimeList = Scheduling.GetShiftsByStartTimeList || (Scheduling.GetShiftsByStartTimeList = {}));
        let GetUserCurrentOrFutureShift;
        (function (GetUserCurrentOrFutureShift) {
            let v1;
            (function (v1) {
                let Timeframe;
                (function (Timeframe) {
                    Timeframe["Past"] = "past";
                    Timeframe["Current"] = "current";
                    Timeframe["Future"] = "future";
                })(Timeframe = v1.Timeframe || (v1.Timeframe = {}));
                let Title;
                (function (Title) {
                    Title["Completed"] = "completed";
                    Title["Missed"] = "missed";
                    Title["Ended"] = "ended";
                    Title["Inprogress"] = "inprogress";
                    Title["Notended"] = "notended";
                    Title["Notstarted"] = "notstarted";
                    Title["Onbreak"] = "onbreak";
                })(Title = v1.Title || (v1.Title = {}));
            })(v1 = GetUserCurrentOrFutureShift.v1 || (GetUserCurrentOrFutureShift.v1 = {}));
        })(GetUserCurrentOrFutureShift = Scheduling.GetUserCurrentOrFutureShift || (Scheduling.GetUserCurrentOrFutureShift = {}));
        let SetShiftAcknowledged;
        (function (SetShiftAcknowledged) {
            let v1;
            (function (v1) {
                let Timeframe;
                (function (Timeframe) {
                    Timeframe["Past"] = "past";
                    Timeframe["Current"] = "current";
                    Timeframe["Future"] = "future";
                })(Timeframe = v1.Timeframe || (v1.Timeframe = {}));
                let Title;
                (function (Title) {
                    Title["Completed"] = "completed";
                    Title["Missed"] = "missed";
                    Title["Ended"] = "ended";
                    Title["Inprogress"] = "inprogress";
                    Title["Notended"] = "notended";
                    Title["Notstarted"] = "notstarted";
                    Title["Onbreak"] = "onbreak";
                })(Title = v1.Title || (v1.Title = {}));
                let Action;
                (function (Action) {
                    Action["Startshift"] = "startshift";
                    Action["Endshift"] = "endshift";
                    Action["Startbreak"] = "startbreak";
                    Action["Endbreak"] = "endbreak";
                })(Action = v1.Action || (v1.Action = {}));
                let Type;
                (function (Type) {
                    Type["Edited"] = "edited";
                    Type["Missed"] = "missed";
                    Type["StartedLate"] = "started_late";
                    Type["EndedEarly"] = "ended_early";
                    Type["EndedLate"] = "ended_late";
                    Type["GpsOutOfBounds"] = "gps_out_of_bounds";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = SetShiftAcknowledged.v1 || (SetShiftAcknowledged.v1 = {}));
        })(SetShiftAcknowledged = Scheduling.SetShiftAcknowledged || (Scheduling.SetShiftAcknowledged = {}));
        let StartBreak;
        (function (StartBreak) {
            let v1;
            (function (v1) {
                let Timeframe;
                (function (Timeframe) {
                    Timeframe["Past"] = "past";
                    Timeframe["Current"] = "current";
                    Timeframe["Future"] = "future";
                })(Timeframe = v1.Timeframe || (v1.Timeframe = {}));
                let Title;
                (function (Title) {
                    Title["Completed"] = "completed";
                    Title["Missed"] = "missed";
                    Title["Ended"] = "ended";
                    Title["Inprogress"] = "inprogress";
                    Title["Notended"] = "notended";
                    Title["Notstarted"] = "notstarted";
                    Title["Onbreak"] = "onbreak";
                })(Title = v1.Title || (v1.Title = {}));
                let Action;
                (function (Action) {
                    Action["Startshift"] = "startshift";
                    Action["Endshift"] = "endshift";
                    Action["Startbreak"] = "startbreak";
                    Action["Endbreak"] = "endbreak";
                })(Action = v1.Action || (v1.Action = {}));
                let Type;
                (function (Type) {
                    Type["Edited"] = "edited";
                    Type["Missed"] = "missed";
                    Type["StartedLate"] = "started_late";
                    Type["EndedEarly"] = "ended_early";
                    Type["EndedLate"] = "ended_late";
                    Type["GpsOutOfBounds"] = "gps_out_of_bounds";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = StartBreak.v1 || (StartBreak.v1 = {}));
        })(StartBreak = Scheduling.StartBreak || (Scheduling.StartBreak = {}));
        let StartShift;
        (function (StartShift) {
            let v1;
            (function (v1) {
                let Timeframe;
                (function (Timeframe) {
                    Timeframe["Past"] = "past";
                    Timeframe["Current"] = "current";
                    Timeframe["Future"] = "future";
                })(Timeframe = v1.Timeframe || (v1.Timeframe = {}));
                let Title;
                (function (Title) {
                    Title["Completed"] = "completed";
                    Title["Missed"] = "missed";
                    Title["Ended"] = "ended";
                    Title["Inprogress"] = "inprogress";
                    Title["Notended"] = "notended";
                    Title["Notstarted"] = "notstarted";
                    Title["Onbreak"] = "onbreak";
                })(Title = v1.Title || (v1.Title = {}));
                let Action;
                (function (Action) {
                    Action["Startshift"] = "startshift";
                    Action["Endshift"] = "endshift";
                    Action["Startbreak"] = "startbreak";
                    Action["Endbreak"] = "endbreak";
                })(Action = v1.Action || (v1.Action = {}));
                let Type;
                (function (Type) {
                    Type["Edited"] = "edited";
                    Type["Missed"] = "missed";
                    Type["StartedLate"] = "started_late";
                    Type["EndedEarly"] = "ended_early";
                    Type["EndedLate"] = "ended_late";
                    Type["GpsOutOfBounds"] = "gps_out_of_bounds";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = StartShift.v1 || (StartShift.v1 = {}));
        })(StartShift = Scheduling.StartShift || (Scheduling.StartShift = {}));
        let UpdateCustomSchedulingAssignment;
        (function (UpdateCustomSchedulingAssignment) {
            let v1;
            (function (v1) {
                let Type;
                (function (Type) {
                    Type["Custom"] = "custom";
                    Type["Location"] = "location";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = UpdateCustomSchedulingAssignment.v1 || (UpdateCustomSchedulingAssignment.v1 = {}));
        })(UpdateCustomSchedulingAssignment = Scheduling.UpdateCustomSchedulingAssignment || (Scheduling.UpdateCustomSchedulingAssignment = {}));
    })(Scheduling = RPCDocs.Scheduling || (RPCDocs.Scheduling = {}));
    let ServicePeriods;
    (function (ServicePeriods) {
        let ApplyServicePeriodTemplate;
        (function (ApplyServicePeriodTemplate) {
            let v1;
            (function (v1) {
                let AssignedToType;
                (function (AssignedToType) {
                    AssignedToType["Location"] = "location";
                })(AssignedToType = v1.AssignedToType || (v1.AssignedToType = {}));
                let AssignmentAssignedToType;
                (function (AssignmentAssignedToType) {
                    AssignmentAssignedToType["LocationGroup"] = "location-group";
                })(AssignmentAssignedToType = v1.AssignmentAssignedToType || (v1.AssignmentAssignedToType = {}));
                let DataType;
                (function (DataType) {
                    DataType["CheckpointScan"] = "checkpoint-scan";
                    DataType["CheckpointTour"] = "checkpoint-tour";
                    DataType["Event"] = "event";
                    DataType["LocationLogEntry"] = "location-log-entry";
                    DataType["PatrolVisit"] = "patrol-visit";
                    DataType["UserGeoFenceArrival"] = "user-geo-fence-arrival";
                    DataType["UserGeoFenceDeparture"] = "user-geo-fence-departure";
                    DataType["UserGpsBreadcrumb"] = "user-gps-breadcrumb";
                    DataType["ShiftStart"] = "shift-start";
                })(DataType = v1.DataType || (v1.DataType = {}));
                let Type;
                (function (Type) {
                    Type["Count"] = "count";
                    Type["Cadence"] = "cadence";
                    Type["Continuous"] = "continuous";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = ApplyServicePeriodTemplate.v1 || (ApplyServicePeriodTemplate.v1 = {}));
        })(ApplyServicePeriodTemplate = ServicePeriods.ApplyServicePeriodTemplate || (ServicePeriods.ApplyServicePeriodTemplate = {}));
        let CreateServicePeriod;
        (function (CreateServicePeriod) {
            let v1;
            (function (v1) {
                let DataType;
                (function (DataType) {
                    DataType["CheckpointScan"] = "checkpoint-scan";
                    DataType["CheckpointTour"] = "checkpoint-tour";
                    DataType["Event"] = "event";
                    DataType["LocationLogEntry"] = "location-log-entry";
                    DataType["PatrolVisit"] = "patrol-visit";
                    DataType["UserGeoFenceArrival"] = "user-geo-fence-arrival";
                    DataType["UserGeoFenceDeparture"] = "user-geo-fence-departure";
                    DataType["UserGpsBreadcrumb"] = "user-gps-breadcrumb";
                    DataType["ShiftStart"] = "shift-start";
                })(DataType = v1.DataType || (v1.DataType = {}));
                let Type;
                (function (Type) {
                    Type["Count"] = "count";
                    Type["Cadence"] = "cadence";
                    Type["Continuous"] = "continuous";
                })(Type = v1.Type || (v1.Type = {}));
                let AssignedToType;
                (function (AssignedToType) {
                    AssignedToType["Location"] = "location";
                    AssignedToType["LocationGroup"] = "location-group";
                })(AssignedToType = v1.AssignedToType || (v1.AssignedToType = {}));
                let AssignmentAssignedToType;
                (function (AssignmentAssignedToType) {
                    AssignmentAssignedToType["Location"] = "location";
                })(AssignmentAssignedToType = v1.AssignmentAssignedToType || (v1.AssignmentAssignedToType = {}));
                let ServicePeriodAssignmentAssignedToType;
                (function (ServicePeriodAssignmentAssignedToType) {
                    ServicePeriodAssignmentAssignedToType["LocationGroup"] = "location-group";
                })(ServicePeriodAssignmentAssignedToType = v1.ServicePeriodAssignmentAssignedToType || (v1.ServicePeriodAssignmentAssignedToType = {}));
            })(v1 = CreateServicePeriod.v1 || (CreateServicePeriod.v1 = {}));
        })(CreateServicePeriod = ServicePeriods.CreateServicePeriod || (ServicePeriods.CreateServicePeriod = {}));
        let CreateServicePeriodTemplate;
        (function (CreateServicePeriodTemplate) {
            let v1;
            (function (v1) {
                let DataType;
                (function (DataType) {
                    DataType["CheckpointScan"] = "checkpoint-scan";
                    DataType["CheckpointTour"] = "checkpoint-tour";
                    DataType["Event"] = "event";
                    DataType["LocationLogEntry"] = "location-log-entry";
                    DataType["PatrolVisit"] = "patrol-visit";
                    DataType["UserGeoFenceArrival"] = "user-geo-fence-arrival";
                    DataType["UserGeoFenceDeparture"] = "user-geo-fence-departure";
                    DataType["UserGpsBreadcrumb"] = "user-gps-breadcrumb";
                    DataType["ShiftStart"] = "shift-start";
                })(DataType = v1.DataType || (v1.DataType = {}));
                let Type;
                (function (Type) {
                    Type["Count"] = "count";
                    Type["Cadence"] = "cadence";
                    Type["Continuous"] = "continuous";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = CreateServicePeriodTemplate.v1 || (CreateServicePeriodTemplate.v1 = {}));
        })(CreateServicePeriodTemplate = ServicePeriods.CreateServicePeriodTemplate || (ServicePeriods.CreateServicePeriodTemplate = {}));
        let FindActivityEvals;
        (function (FindActivityEvals) {
            let v1;
            (function (v1) {
                let DataType;
                (function (DataType) {
                    DataType["CheckpointScan"] = "checkpoint-scan";
                    DataType["CheckpointTour"] = "checkpoint-tour";
                    DataType["Event"] = "event";
                    DataType["LocationLogEntry"] = "location-log-entry";
                    DataType["PatrolVisit"] = "patrol-visit";
                    DataType["UserGeoFenceArrival"] = "user-geo-fence-arrival";
                    DataType["UserGeoFenceDeparture"] = "user-geo-fence-departure";
                    DataType["UserGpsBreadcrumb"] = "user-gps-breadcrumb";
                    DataType["ShiftStart"] = "shift-start";
                })(DataType = v1.DataType || (v1.DataType = {}));
                let Statuses;
                (function (Statuses) {
                    Statuses["Fulfilled"] = "fulfilled";
                    Statuses["Missed"] = "missed";
                    Statuses["Partial"] = "partial";
                    Statuses["Pending"] = "pending";
                })(Statuses = v1.Statuses || (v1.Statuses = {}));
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
                let Type;
                (function (Type) {
                    Type["Count"] = "count";
                    Type["Cadence"] = "cadence";
                    Type["Continuous"] = "continuous";
                })(Type = v1.Type || (v1.Type = {}));
                let SourceRefType;
                (function (SourceRefType) {
                    SourceRefType["ServicePeriodInstance"] = "service-period-instance";
                })(SourceRefType = v1.SourceRefType || (v1.SourceRefType = {}));
            })(v1 = FindActivityEvals.v1 || (FindActivityEvals.v1 = {}));
        })(FindActivityEvals = ServicePeriods.FindActivityEvals || (ServicePeriods.FindActivityEvals = {}));
        let FindServicePeriodInstances;
        (function (FindServicePeriodInstances) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
                let DataType;
                (function (DataType) {
                    DataType["CheckpointScan"] = "checkpoint-scan";
                    DataType["CheckpointTour"] = "checkpoint-tour";
                    DataType["Event"] = "event";
                    DataType["LocationLogEntry"] = "location-log-entry";
                    DataType["PatrolVisit"] = "patrol-visit";
                    DataType["UserGeoFenceArrival"] = "user-geo-fence-arrival";
                    DataType["UserGeoFenceDeparture"] = "user-geo-fence-departure";
                    DataType["UserGpsBreadcrumb"] = "user-gps-breadcrumb";
                    DataType["ShiftStart"] = "shift-start";
                })(DataType = v1.DataType || (v1.DataType = {}));
                let Type;
                (function (Type) {
                    Type["Count"] = "count";
                    Type["Cadence"] = "cadence";
                    Type["Continuous"] = "continuous";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = FindServicePeriodInstances.v1 || (FindServicePeriodInstances.v1 = {}));
        })(FindServicePeriodInstances = ServicePeriods.FindServicePeriodInstances || (ServicePeriods.FindServicePeriodInstances = {}));
        let FindServicePeriodTemplates;
        (function (FindServicePeriodTemplates) {
            let v1;
            (function (v1) {
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
                let DataType;
                (function (DataType) {
                    DataType["CheckpointScan"] = "checkpoint-scan";
                    DataType["CheckpointTour"] = "checkpoint-tour";
                    DataType["Event"] = "event";
                    DataType["LocationLogEntry"] = "location-log-entry";
                    DataType["PatrolVisit"] = "patrol-visit";
                    DataType["UserGeoFenceArrival"] = "user-geo-fence-arrival";
                    DataType["UserGeoFenceDeparture"] = "user-geo-fence-departure";
                    DataType["UserGpsBreadcrumb"] = "user-gps-breadcrumb";
                    DataType["ShiftStart"] = "shift-start";
                })(DataType = v1.DataType || (v1.DataType = {}));
                let Type;
                (function (Type) {
                    Type["Count"] = "count";
                    Type["Cadence"] = "cadence";
                    Type["Continuous"] = "continuous";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = FindServicePeriodTemplates.v1 || (FindServicePeriodTemplates.v1 = {}));
        })(FindServicePeriodTemplates = ServicePeriods.FindServicePeriodTemplates || (ServicePeriods.FindServicePeriodTemplates = {}));
        let FindServicePeriods;
        (function (FindServicePeriods) {
            let v1;
            (function (v1) {
                let AssignedToType;
                (function (AssignedToType) {
                    AssignedToType["Location"] = "location";
                    AssignedToType["LocationGroup"] = "location-group";
                })(AssignedToType = v1.AssignedToType || (v1.AssignedToType = {}));
                let Sort;
                (function (Sort) {
                    Sort["Asc"] = "asc";
                    Sort["Desc"] = "desc";
                })(Sort = v1.Sort || (v1.Sort = {}));
                let AssignmentAssignedToType;
                (function (AssignmentAssignedToType) {
                    AssignmentAssignedToType["Location"] = "location";
                })(AssignmentAssignedToType = v1.AssignmentAssignedToType || (v1.AssignmentAssignedToType = {}));
                let ServicePeriodsAssignmentAssignedToType;
                (function (ServicePeriodsAssignmentAssignedToType) {
                    ServicePeriodsAssignmentAssignedToType["LocationGroup"] = "location-group";
                })(ServicePeriodsAssignmentAssignedToType = v1.ServicePeriodsAssignmentAssignedToType || (v1.ServicePeriodsAssignmentAssignedToType = {}));
                let DataType;
                (function (DataType) {
                    DataType["CheckpointScan"] = "checkpoint-scan";
                    DataType["CheckpointTour"] = "checkpoint-tour";
                    DataType["Event"] = "event";
                    DataType["LocationLogEntry"] = "location-log-entry";
                    DataType["PatrolVisit"] = "patrol-visit";
                    DataType["UserGeoFenceArrival"] = "user-geo-fence-arrival";
                    DataType["UserGeoFenceDeparture"] = "user-geo-fence-departure";
                    DataType["UserGpsBreadcrumb"] = "user-gps-breadcrumb";
                    DataType["ShiftStart"] = "shift-start";
                })(DataType = v1.DataType || (v1.DataType = {}));
                let Type;
                (function (Type) {
                    Type["Count"] = "count";
                    Type["Cadence"] = "cadence";
                    Type["Continuous"] = "continuous";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = FindServicePeriods.v1 || (FindServicePeriods.v1 = {}));
        })(FindServicePeriods = ServicePeriods.FindServicePeriods || (ServicePeriods.FindServicePeriods = {}));
        let UpdateServicePeriod;
        (function (UpdateServicePeriod) {
            let v1;
            (function (v1) {
                let DataType;
                (function (DataType) {
                    DataType["CheckpointScan"] = "checkpoint-scan";
                    DataType["CheckpointTour"] = "checkpoint-tour";
                    DataType["Event"] = "event";
                    DataType["LocationLogEntry"] = "location-log-entry";
                    DataType["PatrolVisit"] = "patrol-visit";
                    DataType["UserGeoFenceArrival"] = "user-geo-fence-arrival";
                    DataType["UserGeoFenceDeparture"] = "user-geo-fence-departure";
                    DataType["UserGpsBreadcrumb"] = "user-gps-breadcrumb";
                    DataType["ShiftStart"] = "shift-start";
                })(DataType = v1.DataType || (v1.DataType = {}));
                let Type;
                (function (Type) {
                    Type["Count"] = "count";
                    Type["Cadence"] = "cadence";
                    Type["Continuous"] = "continuous";
                })(Type = v1.Type || (v1.Type = {}));
                let AssignedToType;
                (function (AssignedToType) {
                    AssignedToType["Location"] = "location";
                    AssignedToType["LocationGroup"] = "location-group";
                })(AssignedToType = v1.AssignedToType || (v1.AssignedToType = {}));
                let AssignmentAssignedToType;
                (function (AssignmentAssignedToType) {
                    AssignmentAssignedToType["Location"] = "location";
                })(AssignmentAssignedToType = v1.AssignmentAssignedToType || (v1.AssignmentAssignedToType = {}));
                let ServicePeriodAssignmentAssignedToType;
                (function (ServicePeriodAssignmentAssignedToType) {
                    ServicePeriodAssignmentAssignedToType["LocationGroup"] = "location-group";
                })(ServicePeriodAssignmentAssignedToType = v1.ServicePeriodAssignmentAssignedToType || (v1.ServicePeriodAssignmentAssignedToType = {}));
            })(v1 = UpdateServicePeriod.v1 || (UpdateServicePeriod.v1 = {}));
        })(UpdateServicePeriod = ServicePeriods.UpdateServicePeriod || (ServicePeriods.UpdateServicePeriod = {}));
        let UpdateServicePeriodTemplate;
        (function (UpdateServicePeriodTemplate) {
            let v1;
            (function (v1) {
                let DataType;
                (function (DataType) {
                    DataType["CheckpointScan"] = "checkpoint-scan";
                    DataType["CheckpointTour"] = "checkpoint-tour";
                    DataType["Event"] = "event";
                    DataType["LocationLogEntry"] = "location-log-entry";
                    DataType["PatrolVisit"] = "patrol-visit";
                    DataType["UserGeoFenceArrival"] = "user-geo-fence-arrival";
                    DataType["UserGeoFenceDeparture"] = "user-geo-fence-departure";
                    DataType["UserGpsBreadcrumb"] = "user-gps-breadcrumb";
                    DataType["ShiftStart"] = "shift-start";
                })(DataType = v1.DataType || (v1.DataType = {}));
                let Type;
                (function (Type) {
                    Type["Count"] = "count";
                    Type["Cadence"] = "cadence";
                    Type["Continuous"] = "continuous";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = UpdateServicePeriodTemplate.v1 || (UpdateServicePeriodTemplate.v1 = {}));
        })(UpdateServicePeriodTemplate = ServicePeriods.UpdateServicePeriodTemplate || (ServicePeriods.UpdateServicePeriodTemplate = {}));
    })(ServicePeriods = RPCDocs.ServicePeriods || (RPCDocs.ServicePeriods = {}));
    let Stats;
    (function (Stats) {
        let DownloadLocationStats;
        (function (DownloadLocationStats) {
            let v1;
            (function (v1) {
                let Format;
                (function (Format) {
                    Format["Html"] = "html";
                    Format["Pdf"] = "pdf";
                })(Format = v1.Format || (v1.Format = {}));
            })(v1 = DownloadLocationStats.v1 || (DownloadLocationStats.v1 = {}));
        })(DownloadLocationStats = Stats.DownloadLocationStats || (Stats.DownloadLocationStats = {}));
        let DownloadOrganizationStats;
        (function (DownloadOrganizationStats) {
            let v1;
            (function (v1) {
                let CalendarInterval;
                (function (CalendarInterval) {
                    CalendarInterval["Day"] = "day";
                    CalendarInterval["Month"] = "month";
                    CalendarInterval["Year"] = "year";
                })(CalendarInterval = v1.CalendarInterval || (v1.CalendarInterval = {}));
                let Format;
                (function (Format) {
                    Format["Html"] = "html";
                    Format["Pdf"] = "pdf";
                })(Format = v1.Format || (v1.Format = {}));
            })(v1 = DownloadOrganizationStats.v1 || (DownloadOrganizationStats.v1 = {}));
            let v2;
            (function (v2) {
                let CalendarInterval;
                (function (CalendarInterval) {
                    CalendarInterval["Day"] = "day";
                    CalendarInterval["Month"] = "month";
                    CalendarInterval["Year"] = "year";
                })(CalendarInterval = v2.CalendarInterval || (v2.CalendarInterval = {}));
            })(v2 = DownloadOrganizationStats.v2 || (DownloadOrganizationStats.v2 = {}));
        })(DownloadOrganizationStats = Stats.DownloadOrganizationStats || (Stats.DownloadOrganizationStats = {}));
        let GetEventsHistogram;
        (function (GetEventsHistogram) {
            let v1;
            (function (v1) {
                let CalendarInterval;
                (function (CalendarInterval) {
                    CalendarInterval["Day"] = "day";
                    CalendarInterval["Month"] = "month";
                    CalendarInterval["Year"] = "year";
                })(CalendarInterval = v1.CalendarInterval || (v1.CalendarInterval = {}));
            })(v1 = GetEventsHistogram.v1 || (GetEventsHistogram.v1 = {}));
        })(GetEventsHistogram = Stats.GetEventsHistogram || (Stats.GetEventsHistogram = {}));
        let GetEventsStatsCount;
        (function (GetEventsStatsCount) {
            let v1;
            (function (v1) {
                let State;
                (function (State) {
                    State["Active"] = "active";
                    State["Closed"] = "closed";
                    State["Pending"] = "pending";
                })(State = v1.State || (v1.State = {}));
            })(v1 = GetEventsStatsCount.v1 || (GetEventsStatsCount.v1 = {}));
        })(GetEventsStatsCount = Stats.GetEventsStatsCount || (Stats.GetEventsStatsCount = {}));
        let GetLocationCheckpointScansHistogram;
        (function (GetLocationCheckpointScansHistogram) {
            let v1;
            (function (v1) {
                let CalendarInterval;
                (function (CalendarInterval) {
                    CalendarInterval["Hour"] = "hour";
                    CalendarInterval["Day"] = "day";
                    CalendarInterval["Week"] = "week";
                    CalendarInterval["Month"] = "month";
                    CalendarInterval["Year"] = "year";
                })(CalendarInterval = v1.CalendarInterval || (v1.CalendarInterval = {}));
            })(v1 = GetLocationCheckpointScansHistogram.v1 || (GetLocationCheckpointScansHistogram.v1 = {}));
        })(GetLocationCheckpointScansHistogram = Stats.GetLocationCheckpointScansHistogram || (Stats.GetLocationCheckpointScansHistogram = {}));
        let GetLocationGeoHistoryStats;
        (function (GetLocationGeoHistoryStats) {
            let v1;
            (function (v1) {
                let CalendarInterval;
                (function (CalendarInterval) {
                    CalendarInterval["Hour"] = "hour";
                    CalendarInterval["Day"] = "day";
                })(CalendarInterval = v1.CalendarInterval || (v1.CalendarInterval = {}));
            })(v1 = GetLocationGeoHistoryStats.v1 || (GetLocationGeoHistoryStats.v1 = {}));
        })(GetLocationGeoHistoryStats = Stats.GetLocationGeoHistoryStats || (Stats.GetLocationGeoHistoryStats = {}));
        let GetLocationLogEntriesHistogram;
        (function (GetLocationLogEntriesHistogram) {
            let v1;
            (function (v1) {
                let CalendarInterval;
                (function (CalendarInterval) {
                    CalendarInterval["Day"] = "day";
                    CalendarInterval["Month"] = "month";
                    CalendarInterval["Year"] = "year";
                })(CalendarInterval = v1.CalendarInterval || (v1.CalendarInterval = {}));
            })(v1 = GetLocationLogEntriesHistogram.v1 || (GetLocationLogEntriesHistogram.v1 = {}));
        })(GetLocationLogEntriesHistogram = Stats.GetLocationLogEntriesHistogram || (Stats.GetLocationLogEntriesHistogram = {}));
        let GetReportsHistogram;
        (function (GetReportsHistogram) {
            let v1;
            (function (v1) {
                let CalendarInterval;
                (function (CalendarInterval) {
                    CalendarInterval["Day"] = "day";
                    CalendarInterval["Week"] = "week";
                    CalendarInterval["Month"] = "month";
                    CalendarInterval["Year"] = "year";
                })(CalendarInterval = v1.CalendarInterval || (v1.CalendarInterval = {}));
            })(v1 = GetReportsHistogram.v1 || (GetReportsHistogram.v1 = {}));
        })(GetReportsHistogram = Stats.GetReportsHistogram || (Stats.GetReportsHistogram = {}));
        let GetReportsStatsCount;
        (function (GetReportsStatsCount) {
            let v1;
            (function (v1) {
                let State;
                (function (State) {
                    State["Open"] = "open";
                    State["Closed"] = "closed";
                    State["Review"] = "review";
                })(State = v1.State || (v1.State = {}));
            })(v1 = GetReportsStatsCount.v1 || (GetReportsStatsCount.v1 = {}));
        })(GetReportsStatsCount = Stats.GetReportsStatsCount || (Stats.GetReportsStatsCount = {}));
        let GetUserWithStatusHistogram;
        (function (GetUserWithStatusHistogram) {
            let v1;
            (function (v1) {
                let CalendarInterval;
                (function (CalendarInterval) {
                    CalendarInterval["Day"] = "day";
                    CalendarInterval["Week"] = "week";
                    CalendarInterval["Month"] = "month";
                    CalendarInterval["Year"] = "year";
                })(CalendarInterval = v1.CalendarInterval || (v1.CalendarInterval = {}));
            })(v1 = GetUserWithStatusHistogram.v1 || (GetUserWithStatusHistogram.v1 = {}));
        })(GetUserWithStatusHistogram = Stats.GetUserWithStatusHistogram || (Stats.GetUserWithStatusHistogram = {}));
    })(Stats = RPCDocs.Stats || (RPCDocs.Stats = {}));
    let Summaries;
    (function (Summaries) {
        let GetOpsSummaryForDates;
        (function (GetOpsSummaryForDates) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Ended"] = "ended";
                    Status["Inprogress"] = "inprogress";
                })(Status = v1.Status || (v1.Status = {}));
                let Type;
                (function (Type) {
                    Type["Edited"] = "edited";
                    Type["Missed"] = "missed";
                    Type["StartedLate"] = "started_late";
                    Type["EndedEarly"] = "ended_early";
                    Type["EndedLate"] = "ended_late";
                    Type["GpsOutOfBounds"] = "gps_out_of_bounds";
                })(Type = v1.Type || (v1.Type = {}));
                let RelativeLocationStatus;
                (function (RelativeLocationStatus) {
                    RelativeLocationStatus["Near"] = "near";
                    RelativeLocationStatus["Inside"] = "inside";
                })(RelativeLocationStatus = v1.RelativeLocationStatus || (v1.RelativeLocationStatus = {}));
                let SetBy;
                (function (SetBy) {
                    SetBy["System"] = "system";
                    SetBy["User"] = "user";
                })(SetBy = v1.SetBy || (v1.SetBy = {}));
                let DetectedBy;
                (function (DetectedBy) {
                    DetectedBy["NoPing"] = "no-ping";
                    DetectedBy["NoPingSweep"] = "no-ping-sweep";
                    DetectedBy["Stationary"] = "stationary";
                })(DetectedBy = v1.DetectedBy || (v1.DetectedBy = {}));
                let Crossing;
                (function (Crossing) {
                    Crossing["Arrive"] = "arrive";
                    Crossing["Depart"] = "depart";
                })(Crossing = v1.Crossing || (v1.Crossing = {}));
            })(v1 = GetOpsSummaryForDates.v1 || (GetOpsSummaryForDates.v1 = {}));
        })(GetOpsSummaryForDates = Summaries.GetOpsSummaryForDates || (Summaries.GetOpsSummaryForDates = {}));
    })(Summaries = RPCDocs.Summaries || (RPCDocs.Summaries = {}));
    let System;
    (function (System) {
        let GetSystemInfoForTarget;
        (function (GetSystemInfoForTarget) {
            let v1;
            (function (v1) {
                let Target;
                (function (Target) {
                    Target["All"] = "all";
                    Target["Admin"] = "admin";
                    Target["Dispatch"] = "dispatch";
                    Target["Ops"] = "ops";
                    Target["OpsMobile"] = "ops_mobile";
                    Target["Portal"] = "portal";
                    Target["Scheduling"] = "scheduling";
                })(Target = v1.Target || (v1.Target = {}));
                let Type;
                (function (Type) {
                    Type["Announcement"] = "announcement";
                    Type["Changelog"] = "changelog";
                })(Type = v1.Type || (v1.Type = {}));
            })(v1 = GetSystemInfoForTarget.v1 || (GetSystemInfoForTarget.v1 = {}));
        })(GetSystemInfoForTarget = System.GetSystemInfoForTarget || (System.GetSystemInfoForTarget = {}));
    })(System = RPCDocs.System || (RPCDocs.System = {}));
    let UserSos;
    (function (UserSos) {
        let GetActivatedUserSos;
        (function (GetActivatedUserSos) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Inside"] = "inside";
                    Status["Near"] = "near";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetActivatedUserSos.v1 || (GetActivatedUserSos.v1 = {}));
        })(GetActivatedUserSos = UserSos.GetActivatedUserSos || (UserSos.GetActivatedUserSos = {}));
        let GetUserSosHistory;
        (function (GetUserSosHistory) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Inside"] = "inside";
                    Status["Near"] = "near";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetUserSosHistory.v1 || (GetUserSosHistory.v1 = {}));
        })(GetUserSosHistory = UserSos.GetUserSosHistory || (UserSos.GetUserSosHistory = {}));
    })(UserSos = RPCDocs.UserSos || (RPCDocs.UserSos = {}));
    let Users;
    (function (Users) {
        let CreateUser;
        (function (CreateUser) {
            let v1;
            (function (v1) {
                let Roles;
                (function (Roles) {
                    Roles["Admin"] = "admin";
                    Roles["Ops"] = "ops";
                    Roles["Portal"] = "portal";
                    Roles["Scheduling"] = "scheduling";
                    Roles["Dispatch"] = "dispatch";
                })(Roles = v1.Roles || (v1.Roles = {}));
            })(v1 = CreateUser.v1 || (CreateUser.v1 = {}));
        })(CreateUser = Users.CreateUser || (Users.CreateUser = {}));
        let CreateUserGroup;
        (function (CreateUserGroup) {
            let v1;
            (function (v1) {
                let Roles;
                (function (Roles) {
                    Roles["Admin"] = "admin";
                    Roles["Ops"] = "ops";
                    Roles["Portal"] = "portal";
                    Roles["Scheduling"] = "scheduling";
                    Roles["Dispatch"] = "dispatch";
                })(Roles = v1.Roles || (v1.Roles = {}));
            })(v1 = CreateUserGroup.v1 || (CreateUserGroup.v1 = {}));
        })(CreateUserGroup = Users.CreateUserGroup || (Users.CreateUserGroup = {}));
        let GetNearbyUsersList;
        (function (GetNearbyUsersList) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Inside"] = "inside";
                    Status["Near"] = "near";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetNearbyUsersList.v1 || (GetNearbyUsersList.v1 = {}));
        })(GetNearbyUsersList = Users.GetNearbyUsersList || (Users.GetNearbyUsersList = {}));
        let GetUserAccessAndPermissions;
        (function (GetUserAccessAndPermissions) {
            let v1;
            (function (v1) {
                let Roles;
                (function (Roles) {
                    Roles["Admin"] = "admin";
                    Roles["Ops"] = "ops";
                    Roles["Portal"] = "portal";
                    Roles["Scheduling"] = "scheduling";
                    Roles["Dispatch"] = "dispatch";
                })(Roles = v1.Roles || (v1.Roles = {}));
            })(v1 = GetUserAccessAndPermissions.v1 || (GetUserAccessAndPermissions.v1 = {}));
        })(GetUserAccessAndPermissions = Users.GetUserAccessAndPermissions || (Users.GetUserAccessAndPermissions = {}));
        let GetUserAuthSessionsHistoryList;
        (function (GetUserAuthSessionsHistoryList) {
            let v1;
            (function (v1) {
                let Platform;
                (function (Platform) {
                    Platform["Android"] = "android";
                    Platform["Ios"] = "ios";
                    Platform["Web"] = "web";
                })(Platform = v1.Platform || (v1.Platform = {}));
            })(v1 = GetUserAuthSessionsHistoryList.v1 || (GetUserAuthSessionsHistoryList.v1 = {}));
        })(GetUserAuthSessionsHistoryList = Users.GetUserAuthSessionsHistoryList || (Users.GetUserAuthSessionsHistoryList = {}));
        let GetUserAuthSessionsList;
        (function (GetUserAuthSessionsList) {
            let v1;
            (function (v1) {
                let Platform;
                (function (Platform) {
                    Platform["Android"] = "android";
                    Platform["Ios"] = "ios";
                    Platform["Web"] = "web";
                })(Platform = v1.Platform || (v1.Platform = {}));
            })(v1 = GetUserAuthSessionsList.v1 || (GetUserAuthSessionsList.v1 = {}));
        })(GetUserAuthSessionsList = Users.GetUserAuthSessionsList || (Users.GetUserAuthSessionsList = {}));
        let GetUserGeoFenceCrossings;
        (function (GetUserGeoFenceCrossings) {
            let v1;
            (function (v1) {
                let Crossing;
                (function (Crossing) {
                    Crossing["Arrive"] = "arrive";
                    Crossing["Depart"] = "depart";
                })(Crossing = v1.Crossing || (v1.Crossing = {}));
            })(v1 = GetUserGeoFenceCrossings.v1 || (GetUserGeoFenceCrossings.v1 = {}));
        })(GetUserGeoFenceCrossings = Users.GetUserGeoFenceCrossings || (Users.GetUserGeoFenceCrossings = {}));
        let GetUserGeoLocationHistory;
        (function (GetUserGeoLocationHistory) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Inside"] = "inside";
                    Status["Near"] = "near";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetUserGeoLocationHistory.v1 || (GetUserGeoLocationHistory.v1 = {}));
        })(GetUserGeoLocationHistory = Users.GetUserGeoLocationHistory || (Users.GetUserGeoLocationHistory = {}));
        let GetUserGeoLocationHistoryAtLocation;
        (function (GetUserGeoLocationHistoryAtLocation) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Inside"] = "inside";
                    Status["Near"] = "near";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetUserGeoLocationHistoryAtLocation.v1 || (GetUserGeoLocationHistoryAtLocation.v1 = {}));
        })(GetUserGeoLocationHistoryAtLocation = Users.GetUserGeoLocationHistoryAtLocation || (Users.GetUserGeoLocationHistoryAtLocation = {}));
        let GetUserGroup;
        (function (GetUserGroup) {
            let v1;
            (function (v1) {
                let Roles;
                (function (Roles) {
                    Roles["Admin"] = "admin";
                    Roles["Ops"] = "ops";
                    Roles["Portal"] = "portal";
                    Roles["Scheduling"] = "scheduling";
                    Roles["Dispatch"] = "dispatch";
                })(Roles = v1.Roles || (v1.Roles = {}));
            })(v1 = GetUserGroup.v1 || (GetUserGroup.v1 = {}));
        })(GetUserGroup = Users.GetUserGroup || (Users.GetUserGroup = {}));
        let GetUserGroups;
        (function (GetUserGroups) {
            let v1;
            (function (v1) {
                let Roles;
                (function (Roles) {
                    Roles["Admin"] = "admin";
                    Roles["Ops"] = "ops";
                    Roles["Portal"] = "portal";
                    Roles["Scheduling"] = "scheduling";
                    Roles["Dispatch"] = "dispatch";
                })(Roles = v1.Roles || (v1.Roles = {}));
            })(v1 = GetUserGroups.v1 || (GetUserGroups.v1 = {}));
        })(GetUserGroups = Users.GetUserGroups || (Users.GetUserGroups = {}));
        let GetUserProfile;
        (function (GetUserProfile) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Inside"] = "inside";
                    Status["Near"] = "near";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetUserProfile.v1 || (GetUserProfile.v1 = {}));
        })(GetUserProfile = Users.GetUserProfile || (Users.GetUserProfile = {}));
        let GetUserRegistrationRequests;
        (function (GetUserRegistrationRequests) {
            let v1;
            (function (v1) {
                let Roles;
                (function (Roles) {
                    Roles["Admin"] = "admin";
                    Roles["Ops"] = "ops";
                    Roles["Portal"] = "portal";
                    Roles["Scheduling"] = "scheduling";
                    Roles["Dispatch"] = "dispatch";
                })(Roles = v1.Roles || (v1.Roles = {}));
            })(v1 = GetUserRegistrationRequests.v1 || (GetUserRegistrationRequests.v1 = {}));
        })(GetUserRegistrationRequests = Users.GetUserRegistrationRequests || (Users.GetUserRegistrationRequests = {}));
        let GetUserStatusHistory;
        (function (GetUserStatusHistory) {
            let v1;
            (function (v1) {
                let SetBy;
                (function (SetBy) {
                    SetBy["System"] = "system";
                    SetBy["User"] = "user";
                })(SetBy = v1.SetBy || (v1.SetBy = {}));
            })(v1 = GetUserStatusHistory.v1 || (GetUserStatusHistory.v1 = {}));
        })(GetUserStatusHistory = Users.GetUserStatusHistory || (Users.GetUserStatusHistory = {}));
        let GetUsersGeoSearch;
        (function (GetUsersGeoSearch) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Inside"] = "inside";
                    Status["Near"] = "near";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetUsersGeoSearch.v1 || (GetUsersGeoSearch.v1 = {}));
        })(GetUsersGeoSearch = Users.GetUsersGeoSearch || (Users.GetUsersGeoSearch = {}));
        let GetUsersList;
        (function (GetUsersList) {
            let v1;
            (function (v1) {
                let Status;
                (function (Status) {
                    Status["Inside"] = "inside";
                    Status["Near"] = "near";
                })(Status = v1.Status || (v1.Status = {}));
            })(v1 = GetUsersList.v1 || (GetUsersList.v1 = {}));
        })(GetUsersList = Users.GetUsersList || (Users.GetUsersList = {}));
        let UpdateUser;
        (function (UpdateUser) {
            let v1;
            (function (v1) {
                let Roles;
                (function (Roles) {
                    Roles["Admin"] = "admin";
                    Roles["Ops"] = "ops";
                    Roles["Portal"] = "portal";
                    Roles["Scheduling"] = "scheduling";
                    Roles["Dispatch"] = "dispatch";
                })(Roles = v1.Roles || (v1.Roles = {}));
            })(v1 = UpdateUser.v1 || (UpdateUser.v1 = {}));
        })(UpdateUser = Users.UpdateUser || (Users.UpdateUser = {}));
        let UpdateUserGroup;
        (function (UpdateUserGroup) {
            let v1;
            (function (v1) {
                let Roles;
                (function (Roles) {
                    Roles["Admin"] = "admin";
                    Roles["Ops"] = "ops";
                    Roles["Portal"] = "portal";
                    Roles["Scheduling"] = "scheduling";
                    Roles["Dispatch"] = "dispatch";
                })(Roles = v1.Roles || (v1.Roles = {}));
            })(v1 = UpdateUserGroup.v1 || (UpdateUserGroup.v1 = {}));
        })(UpdateUserGroup = Users.UpdateUserGroup || (Users.UpdateUserGroup = {}));
    })(Users = RPCDocs.Users || (RPCDocs.Users = {}));
})(RPCDocs || (RPCDocs = {}));
export const RPCs = {
    ActivityFeed: {
        GetOpsActivityFeed: {
            v1: 'activity-feed::get-ops-activity-feed::1',
        },
        GetOpsUserRecentActivity: {
            v1: 'activity-feed::get-ops-user-recent-activity::1',
        },
    },
    Admin: {
        CreateOpsSummarySubscriber: {
            v1: 'admin::create-ops-summary-subscriber::1',
        },
        DeleteOpsSummarySubscriber: {
            v1: 'admin::delete-ops-summary-subscriber::1',
        },
        FindOpsSummarySubscribers: {
            v1: 'admin::find-ops-summary-subscribers::1',
        },
        GetOpsSummarySubscriberEmailPreview: {
            v1: 'admin::get-ops-summary-subscriber-email-preview::1',
        },
        OptimizeSmartWatchCriteria: {
            v1: 'admin::optimize-smart-watch-criteria::1',
        },
        SendOpsSummarySubscriberEmail: {
            v1: 'admin::send-ops-summary-subscriber-email::1',
        },
        UpdateOpsSummarySubscriber: {
            v1: 'admin::update-ops-summary-subscriber::1',
        },
    },
    Ai: {
        GetAiConfigs: {
            v1: 'ai::get-ai-configs::1',
        },
        GetAvailableProviders: {
            v1: 'ai::get-available-providers::1',
        },
        GetOrganizationAiProviderKeys: {
            v1: 'ai::get-organization-ai-provider-keys::1',
        },
        SetOrganizationAiProviderKey: {
            v1: 'ai::set-organization-ai-provider-key::1',
        },
    },
    Auth: {
        Authenticate: {
            v1: 'auth::authenticate::1',
            v2: 'auth::authenticate::2',
        },
        AuthenticateAsUser: {
            v1: 'auth::authenticate-as-user::1',
        },
        CheckExistingEmail: {
            v1: 'auth::check-existing-email::1',
        },
        DeAuthenticate: {
            v1: 'auth::de-authenticate::1',
        },
        GetAuthInfo: {
            v1: 'auth::get-auth-info::1',
        },
        GetIdentityInfo: {
            v1: 'auth::get-identity-info::1',
        },
        ReadonlyToken: {
            v1: 'auth::readonly-token::1',
        },
        RefreshAuthToken: {
            v1: 'auth::refresh-auth-token::1',
        },
        RequestResetPassword: {
            v1: 'auth::request-reset-password::1',
        },
        SaveDeviceInfo: {
            v1: 'auth::save-device-info::1',
        },
        SaveDevicePhysicalActivity: {
            v1: 'auth::save-device-physical-activity::1',
        },
        SaveUserClientMetadataWebData: {
            v1: 'auth::save-user-client-metadata-web-data::1',
        },
        SelfSendPushNotification: {
            v1: 'auth::self-send-push-notification::1',
        },
        SendMobileAppLinkSms: {
            v1: 'auth::send-mobile-app-link-sms::1',
        },
        SetNewPassword: {
            v1: 'auth::set-new-password::1',
        },
        Simulate401: {
            v1: 'auth::simulate-401::1',
        },
        SwitchUserProfile: {
            v1: 'auth::switch-user-profile::1',
        },
    },
    Bolos: {
        DeleteBolo: {
            v1: 'bolos::delete-bolo::1',
        },
        GetBolo: {
            v1: 'bolos::get-bolo::1',
        },
    },
    Bulletins: {
        AcknowledgeBulletin: {
            v1: 'bulletins::acknowledge-bulletin::1',
        },
        CreateBulletin: {
            v1: 'bulletins::create-bulletin::1',
        },
        DeleteBulletinComments: {
            v1: 'bulletins::delete-bulletin-comments::1',
        },
        DeleteBulletins: {
            v1: 'bulletins::delete-bulletins::1',
        },
        GetBulletinComments: {
            v1: 'bulletins::get-bulletin-comments::1',
        },
        GetBulletinsList: {
            v1: 'bulletins::get-bulletins-list::1',
        },
        SaveBulletinComment: {
            v1: 'bulletins::save-bulletin-comment::1',
        },
        UpdateBulletin: {
            v1: 'bulletins::update-bulletin::1',
        },
        ViewBulletin: {
            v1: 'bulletins::view-bulletin::1',
        },
    },
    Entries: {
        GetEntry: {
            v1: 'entries::get-entry::1',
            v2: 'entries::get-entry::2',
            v3: 'entries::get-entry::3',
        },
        GetEntryTypeDetail: {
            v1: 'entries::get-entry-type-detail::1',
        },
        GetEntryTypesDetails: {
            v1: 'entries::get-entry-types-details::1',
            v2: 'entries::get-entry-types-details::2',
            v3: 'entries::get-entry-types-details::3',
        },
        GetEntryTypesList: {
            v1: 'entries::get-entry-types-list::1',
        },
    },
    Events: {
        AddEventAssignedUser: {
            v1: 'events::add-event-assigned-user::1',
        },
        CloseEvent: {
            v1: 'events::close-event::1',
        },
        CreateEvent: {
            v1: 'events::create-event::1',
        },
        CreateEventComment: {
            v1: 'events::create-event-comment::1',
        },
        CreateEventType: {
            v1: 'events::create-event-type::1',
            v2: 'events::create-event-type::2',
        },
        DeleteEvent: {
            v1: 'events::delete-event::1',
        },
        DeleteEventComment: {
            v1: 'events::delete-event-comment::1',
        },
        DeleteEventType: {
            v1: 'events::delete-event-type::1',
        },
        DownloadEvent: {
            v1: 'events::download-event::1',
            v2: 'events::download-event::2',
        },
        GetCurrentEventCounts: {
            v1: 'events::get-current-event-counts::1',
        },
        GetEvent: {
            v1: 'events::get-event::1',
            v2: 'events::get-event::2',
        },
        GetEventComments: {
            v1: 'events::get-event-comments::1',
        },
        GetEventTypeDetail: {
            v1: 'events::get-event-type-detail::1',
        },
        GetEventTypesDetails: {
            v1: 'events::get-event-types-details::1',
            v2: 'events::get-event-types-details::2',
        },
        GetEventTypesList: {
            v1: 'events::get-event-types-list::1',
        },
        GetEventsList: {
            v1: 'events::get-events-list::1',
        },
        RemoveEventAssignedUser: {
            v1: 'events::remove-event-assigned-user::1',
        },
        ReopenEvent: {
            v1: 'events::reopen-event::1',
        },
        SaveEventDisposition: {
            v1: 'events::save-event-disposition::1',
        },
        SaveEventDispositionFields: {
            v1: 'events::save-event-disposition-fields::1',
        },
        SaveEventRefs: {
            v1: 'events::save-event-refs::1',
        },
        SetEventAssignedUserAcknowledged: {
            v1: 'events::set-event-assigned-user-acknowledged::1',
        },
        SetEventAssignedUserStatus: {
            v1: 'events::set-event-assigned-user-status::1',
        },
        UpdateEvent: {
            v1: 'events::update-event::1',
            v2: 'events::update-event::2',
        },
        UpdateEventComment: {
            v1: 'events::update-event-comment::1',
        },
        UpdateEventType: {
            v1: 'events::update-event-type::1',
            v2: 'events::update-event-type::2',
        },
    },
    External: {
        CheckEmailSuppression: {
            v1: 'external::check-email-suppression::1',
        },
        CompleteOrganizationRegistration: {
            v1: 'external::complete-organization-registration::1',
        },
        CompletePortalUserRegistration: {
            v1: 'external::complete-portal-user-registration::1',
        },
        CompleteUserRegistration: {
            v1: 'external::complete-user-registration::1',
        },
        GetFileUploadUrl: {
            v1: 'external::get-file-upload-url::1',
        },
        GetLocationSubscriberDetailsForPortalUserAccountRegistrationRequest: {
            v1: 'external::get-location-subscriber-details-for-portal-user-account-registration-request::1',
        },
        NewRegistrationWithEmail: {
            v1: 'external::new-registration-with-email::1',
        },
        OrganizationLookup: {
            v1: 'external::organization-lookup::1',
        },
        RegisterOrganization: {
            v1: 'external::register-organization::1',
        },
        ResetEmailSuppression: {
            v1: 'external::reset-email-suppression::1',
        },
        SimulateDelay: {
            v1: 'external::simulate-delay::1',
        },
        SimulateResponse: {
            v1: 'external::simulate-response::1',
        },
    },
    Files: {
        GetFileUploadUrl: {
            v1: 'files::get-file-upload-url::1',
        },
    },
    Forms: {
        DeleteForm: {
            v1: 'forms::delete-form::1',
        },
        DeleteFormFieldTemplate: {
            v1: 'forms::delete-form-field-template::1',
        },
        GetForm: {
            v1: 'forms::get-form::1',
        },
        GetFormFieldTemplates: {
            v1: 'forms::get-form-field-templates::1',
        },
        GetFormTemplates: {
            v1: 'forms::get-form-templates::1',
        },
        GetForms: {
            v1: 'forms::get-forms::1',
        },
        SaveForm: {
            v1: 'forms::save-form::1',
        },
        SaveFormFieldTemplate: {
            v1: 'forms::save-form-field-template::1',
        },
        SaveFormTemplate: {
            v1: 'forms::save-form-template::1',
        },
    },
    Geo: {
        GetGooglePlaceDetails: {
            v1: 'geo::get-google-place-details::1',
        },
        GetGooglePlacesAutocompleteSuggestions: {
            v1: 'geo::get-google-places-autocomplete-suggestions::1',
        },
        GetLatLngFromAddress: {
            v1: 'geo::get-lat-lng-from-address::1',
        },
        GetStreetPhotoFromLatLng: {
            v1: 'geo::get-street-photo-from-lat-lng::1',
        },
    },
    GeoZones: {
        CreateGeoZone: {
            v1: 'geo-zones::create-geo-zone::1',
        },
        DeleteGeoZones: {
            v1: 'geo-zones::delete-geo-zones::1',
        },
        FindGeoZones: {
            v1: 'geo-zones::find-geo-zones::1',
        },
        UpdateGeoZone: {
            v1: 'geo-zones::update-geo-zone::1',
        },
    },
    Locations: {
        ActivateLocation: {
            v1: 'locations::activate-location::1',
        },
        ActivateLocationLogEntryType: {
            v1: 'locations::activate-location-log-entry-type::1',
        },
        BulkUpdateLocationConfigSettings: {
            v1: 'locations::bulk-update-location-config-settings::1',
        },
        CompleteLocationTaskTodo: {
            v1: 'locations::complete-location-task-todo::1',
        },
        CreateAddressLocation: {
            v1: 'locations::create-address-location::1',
        },
        CreateLocation: {
            v1: 'locations::create-location::1',
        },
        CreateLocationBolo: {
            v1: 'locations::create-location-bolo::1',
        },
        CreateLocationCheckpoint: {
            v1: 'locations::create-location-checkpoint::1',
        },
        CreateLocationCheckpointTour: {
            v1: 'locations::create-location-checkpoint-tour::1',
        },
        CreateLocationContact: {
            v1: 'locations::create-location-contact::1',
        },
        CreateLocationGroup: {
            v1: 'locations::create-location-group::1',
        },
        CreateLocationInfoBlock: {
            v1: 'locations::create-location-info-block::1',
        },
        CreateLocationInfoBlockCategory: {
            v1: 'locations::create-location-info-block-category::1',
        },
        CreateLocationLogEntry: {
            v1: 'locations::create-location-log-entry::1',
            v2: 'locations::create-location-log-entry::2',
        },
        CreateLocationLogEntryType: {
            v1: 'locations::create-location-log-entry-type::1',
        },
        CreateLocationPassDown: {
            v1: 'locations::create-location-pass-down::1',
        },
        CreateLocationSubscriber: {
            v1: 'locations::create-location-subscriber::1',
        },
        CreateLocationTask: {
            v1: 'locations::create-location-task::1',
        },
        DeactivateLocation: {
            v1: 'locations::deactivate-location::1',
        },
        DeactivateLocationLogEntryType: {
            v1: 'locations::deactivate-location-log-entry-type::1',
        },
        DeleteLocationAdminComment: {
            v1: 'locations::delete-location-admin-comment::1',
        },
        DeleteLocationCheckpoint: {
            v1: 'locations::delete-location-checkpoint::1',
        },
        DeleteLocationCheckpointScan: {
            v1: 'locations::delete-location-checkpoint-scan::1',
        },
        DeleteLocationCheckpointTour: {
            v1: 'locations::delete-location-checkpoint-tour::1',
        },
        DeleteLocationCheckpointTourRun: {
            v1: 'locations::delete-location-checkpoint-tour-run::1',
        },
        DeleteLocationContact: {
            v1: 'locations::delete-location-contact::1',
        },
        DeleteLocationContacts: {
            v1: 'locations::delete-location-contacts::1',
        },
        DeleteLocationGroups: {
            v1: 'locations::delete-location-groups::1',
        },
        DeleteLocationInfoBlockCategories: {
            v1: 'locations::delete-location-info-block-categories::1',
        },
        DeleteLocationInfoBlocks: {
            v1: 'locations::delete-location-info-blocks::1',
        },
        DeleteLocationLogEntry: {
            v1: 'locations::delete-location-log-entry::1',
        },
        DeleteLocationLogEntryType: {
            v1: 'locations::delete-location-log-entry-type::1',
        },
        DeleteLocationSubscribers: {
            v1: 'locations::delete-location-subscribers::1',
        },
        DeleteLocationTasks: {
            v1: 'locations::delete-location-tasks::1',
        },
        DownloadLocationCheckpointActivity: {
            v1: 'locations::download-location-checkpoint-activity::1',
        },
        DownloadLocationCheckpointScans: {
            v1: 'locations::download-location-checkpoint-scans::1',
            v2: 'locations::download-location-checkpoint-scans::2',
        },
        DownloadLocationCheckpointTours: {
            v1: 'locations::download-location-checkpoint-tours::1',
            v2: 'locations::download-location-checkpoint-tours::2',
        },
        DownloadLocationLogEntries: {
            v1: 'locations::download-location-log-entries::1',
            v2: 'locations::download-location-log-entries::2',
        },
        DownloadLocationLogEntry: {
            v1: 'locations::download-location-log-entry::1',
            v2: 'locations::download-location-log-entry::2',
        },
        EndLocationCheckpointTourRun: {
            v1: 'locations::end-location-checkpoint-tour-run::1',
        },
        GetContactsForLocation: {
            v1: 'locations::get-contacts-for-location::1',
        },
        GetInfoBlockCategoriesForLocation: {
            v1: 'locations::get-info-block-categories-for-location::1',
        },
        GetInfoBlocksForLocationCategory: {
            v1: 'locations::get-info-blocks-for-location-category::1',
        },
        GetLocationActivitySummary: {
            v1: 'locations::get-location-activity-summary::1',
        },
        GetLocationAdminComments: {
            v1: 'locations::get-location-admin-comments::1',
        },
        GetLocationAuditDetails: {
            v1: 'locations::get-location-audit-details::1',
        },
        GetLocationBolosList: {
            v1: 'locations::get-location-bolos-list::1',
        },
        GetLocationCheckpointDetail: {
            v1: 'locations::get-location-checkpoint-detail::1',
        },
        GetLocationCheckpointScanDetail: {
            v1: 'locations::get-location-checkpoint-scan-detail::1',
            v2: 'locations::get-location-checkpoint-scan-detail::2',
        },
        GetLocationCheckpointScansList: {
            v1: 'locations::get-location-checkpoint-scans-list::1',
            v2: 'locations::get-location-checkpoint-scans-list::2',
        },
        GetLocationCheckpointTourDetail: {
            v1: 'locations::get-location-checkpoint-tour-detail::1',
        },
        GetLocationCheckpointTourRunDetail: {
            v1: 'locations::get-location-checkpoint-tour-run-detail::1',
        },
        GetLocationCheckpointTourRunsList: {
            v1: 'locations::get-location-checkpoint-tour-runs-list::1',
            v2: 'locations::get-location-checkpoint-tour-runs-list::2',
        },
        GetLocationCheckpointToursList: {
            v1: 'locations::get-location-checkpoint-tours-list::1',
        },
        GetLocationCheckpointsDetail: {
            v1: 'locations::get-location-checkpoints-detail::1',
        },
        GetLocationCheckpointsList: {
            v1: 'locations::get-location-checkpoints-list::1',
        },
        GetLocationContact: {
            v1: 'locations::get-location-contact::1',
        },
        GetLocationContactsList: {
            v1: 'locations::get-location-contacts-list::1',
        },
        GetLocationGeoDetail: {
            v1: 'locations::get-location-geo-detail::1',
        },
        GetLocationGroup: {
            v1: 'locations::get-location-group::1',
        },
        GetLocationGroupsList: {
            v1: 'locations::get-location-groups-list::1',
        },
        GetLocationInfoBlock: {
            v1: 'locations::get-location-info-block::1',
        },
        GetLocationInfoBlockCategories: {
            v1: 'locations::get-location-info-block-categories::1',
        },
        GetLocationInfoBlockCategory: {
            v1: 'locations::get-location-info-block-category::1',
        },
        GetLocationInfoBlocksDetail: {
            v1: 'locations::get-location-info-blocks-detail::1',
        },
        GetLocationInfoBlocksList: {
            v1: 'locations::get-location-info-blocks-list::1',
        },
        GetLocationInfoSubscriberDailyEmailPreview: {
            v1: 'locations::get-location-info-subscriber-daily-email-preview::1',
        },
        GetLocationLogEntriesDetails: {
            v1: 'locations::get-location-log-entries-details::1',
        },
        GetLocationLogEntriesList: {
            v1: 'locations::get-location-log-entries-list::1',
        },
        GetLocationLogEntryDetail: {
            v1: 'locations::get-location-log-entry-detail::1',
        },
        GetLocationLogEntryList: {
            v1: 'locations::get-location-log-entry-list::1',
            v2: 'locations::get-location-log-entry-list::2',
        },
        GetLocationLogEntryType: {
            v1: 'locations::get-location-log-entry-type::1',
        },
        GetLocationLogEntryTypeLocationsRelations: {
            v1: 'locations::get-location-log-entry-type-locations-relations::1',
        },
        GetLocationLogEntryTypesList: {
            v1: 'locations::get-location-log-entry-types-list::1',
        },
        GetLocationPassDownsList: {
            v1: 'locations::get-location-pass-downs-list::1',
        },
        GetLocationProfile: {
            v1: 'locations::get-location-profile::1',
        },
        GetLocationSubscribers: {
            v1: 'locations::get-location-subscribers::1',
        },
        GetLocationTask: {
            v1: 'locations::get-location-task::1',
        },
        GetLocationTaskCompletions: {
            v1: 'locations::get-location-task-completions::1',
        },
        GetLocationTaskTodos: {
            v1: 'locations::get-location-task-todos::1',
        },
        GetLocationTasks: {
            v1: 'locations::get-location-tasks::1',
        },
        GetLocationUserGeofenceHistory: {
            v1: 'locations::get-location-user-geofence-history::1',
        },
        GetLocationsAndGroupsLabelsList: {
            v1: 'locations::get-locations-and-groups-labels-list::1',
        },
        GetLocationsFromLocationAndGroupIdsList: {
            v1: 'locations::get-locations-from-location-and-group-ids-list::1',
        },
        GetLocationsGeoSearch: {
            v1: 'locations::get-locations-geo-search::1',
        },
        GetLocationsList: {
            v1: 'locations::get-locations-list::1',
        },
        GetNearbyLocationsList: {
            v1: 'locations::get-nearby-locations-list::1',
        },
        GetProjectedLocationTaskTodos: {
            v1: 'locations::get-projected-location-task-todos::1',
        },
        GetStatsCountsByLocation: {
            v1: 'locations::get-stats-counts-by-location::1',
        },
        LinkLocationToContact: {
            v1: 'locations::link-location-to-contact::1',
        },
        LinkLocationToInfoBlock: {
            v1: 'locations::link-location-to-info-block::1',
        },
        SaveLocationAdminComment: {
            v1: 'locations::save-location-admin-comment::1',
        },
        SaveLocationCheckpointScan: {
            v1: 'locations::save-location-checkpoint-scan::1',
            v2: 'locations::save-location-checkpoint-scan::2',
        },
        SendLocationInfoSubscriberDailyEmail: {
            v1: 'locations::send-location-info-subscriber-daily-email::1',
        },
        StartLocationCheckpointTourRun: {
            v1: 'locations::start-location-checkpoint-tour-run::1',
        },
        UnlinkLocationFromContact: {
            v1: 'locations::unlink-location-from-contact::1',
        },
        UnlinkLocationFromInfoBlock: {
            v1: 'locations::unlink-location-from-info-block::1',
        },
        UpdateLocation: {
            v1: 'locations::update-location::1',
        },
        UpdateLocationBolo: {
            v1: 'locations::update-location-bolo::1',
        },
        UpdateLocationCheckpoint: {
            v1: 'locations::update-location-checkpoint::1',
        },
        UpdateLocationCheckpointScan: {
            v1: 'locations::update-location-checkpoint-scan::1',
            v2: 'locations::update-location-checkpoint-scan::2',
        },
        UpdateLocationCheckpointTour: {
            v1: 'locations::update-location-checkpoint-tour::1',
        },
        UpdateLocationContact: {
            v1: 'locations::update-location-contact::1',
        },
        UpdateLocationGroup: {
            v1: 'locations::update-location-group::1',
        },
        UpdateLocationInfoBlock: {
            v1: 'locations::update-location-info-block::1',
        },
        UpdateLocationInfoBlockCategory: {
            v1: 'locations::update-location-info-block-category::1',
        },
        UpdateLocationLogEntry: {
            v1: 'locations::update-location-log-entry::1',
            v2: 'locations::update-location-log-entry::2',
        },
        UpdateLocationLogEntryType: {
            v1: 'locations::update-location-log-entry-type::1',
        },
        UpdateLocationLogEntryTypeLocationsRelations: {
            v1: 'locations::update-location-log-entry-type-locations-relations::1',
        },
        UpdateLocationPassDown: {
            v1: 'locations::update-location-pass-down::1',
        },
        UpdateLocationSubscriber: {
            v1: 'locations::update-location-subscriber::1',
        },
        UpdateLocationTask: {
            v1: 'locations::update-location-task::1',
        },
    },
    Mail: {
        DeleteMessages: {
            v1: 'mail::delete-messages::1',
        },
        GetMessage: {
            v1: 'mail::get-message::1',
        },
        GetMessagesList: {
            v1: 'mail::get-messages-list::1',
        },
        GetUnreadMessagesCount: {
            v1: 'mail::get-unread-messages-count::1',
        },
        SendMessage: {
            v1: 'mail::send-message::1',
        },
        SetMessageFlagged: {
            v1: 'mail::set-message-flagged::1',
        },
        SetMessageRead: {
            v1: 'mail::set-message-read::1',
        },
    },
    Notifications: {
        FindMyNotifications: {
            v1: 'notifications::find-my-notifications::1',
        },
        GetMyNotificationPreferences: {
            v1: 'notifications::get-my-notification-preferences::1',
        },
        MarkNotificationsRead: {
            v1: 'notifications::mark-notifications-read::1',
        },
        ResolveNotification: {
            v1: 'notifications::resolve-notification::1',
        },
        SendPushNotification: {
            v1: 'notifications::send-push-notification::1',
        },
        SendPushNotificationRaw: {
            v1: 'notifications::send-push-notification-raw::1',
        },
        SendTestPushNotificationToUser: {
            v1: 'notifications::send-test-push-notification-to-user::1',
        },
        SetMyNotificationPreferences: {
            v1: 'notifications::set-my-notification-preferences::1',
        },
    },
    OpsTrends: {
        CompareTrendPeriods: {
            v1: 'ops-trends::compare-trend-periods::1',
        },
        CreateTrendConfig: {
            v1: 'ops-trends::create-trend-config::1',
        },
        DeleteTrendConfig: {
            v1: 'ops-trends::delete-trend-config::1',
        },
        FindTrendConfigs: {
            v1: 'ops-trends::find-trend-configs::1',
        },
        GetTrendsPeriod: {
            v1: 'ops-trends::get-trends-period::1',
        },
        UpdateTrendConfig: {
            v1: 'ops-trends::update-trend-config::1',
        },
    },
    Organization: {
        GetAuditLogs: {
            v1: 'organization::get-audit-logs::1',
        },
        GetEmailLog: {
            v1: 'organization::get-email-log::1',
        },
    },
    Organizations: {
        ActivateScheduling: {
            v1: 'organizations::activate-scheduling::1',
        },
        DeactivateScheduling: {
            v1: 'organizations::deactivate-scheduling::1',
        },
        GetOrganizationProfile: {
            v1: 'organizations::get-organization-profile::1',
        },
        GetOrganizationStripeBillingPortalLink: {
            v1: 'organizations::get-organization-stripe-billing-portal-link::1',
        },
        GetOrganizationSubscriptionDetails: {
            v1: 'organizations::get-organization-subscription-details::1',
        },
        SetOrganizationNotificationDefaults: {
            v1: 'organizations::set-organization-notification-defaults::1',
        },
        ToggleDispatch: {
            v1: 'organizations::toggle-dispatch::1',
        },
        TogglePatrol: {
            v1: 'organizations::toggle-patrol::1',
        },
        ToggleRegions: {
            v1: 'organizations::toggle-regions::1',
        },
        ToggleSos: {
            v1: 'organizations::toggle-sos::1',
        },
        UpdateOrganization: {
            v1: 'organizations::update-organization::1',
        },
        UpdateOrganizationOrganizationBillingContacts: {
            v1: 'organizations::update-organization-organization-billing-contacts::1',
        },
        UpgradeOrganizationPlanToCore: {
            v1: 'organizations::upgrade-organization-plan-to-core::1',
        },
    },
    PassDowns: {
        DeletePassDown: {
            v1: 'pass-downs::delete-pass-down::1',
        },
        GetPassDown: {
            v1: 'pass-downs::get-pass-down::1',
        },
    },
    Patrol: {
        CreatePatrolRoute: {
            v1: 'patrol::create-patrol-route::1',
            v2: 'patrol::create-patrol-route::2',
        },
        DeletePatrolRouteRuns: {
            v1: 'patrol::delete-patrol-route-runs::1',
        },
        DeletePatrolRoutes: {
            v1: 'patrol::delete-patrol-routes::1',
        },
        EndPatrolRouteRun: {
            v1: 'patrol::end-patrol-route-run::1',
        },
        FindPatrolRoutes: {
            v1: 'patrol::find-patrol-routes::1',
        },
        FindPatrolRoutesRuns: {
            v1: 'patrol::find-patrol-routes-runs::1',
            v2: 'patrol::find-patrol-routes-runs::2',
        },
        GetPatrolRouteDetails: {
            v1: 'patrol::get-patrol-route-details::1',
            v2: 'patrol::get-patrol-route-details::2',
        },
        GetPatrolRouteRunDetails: {
            v1: 'patrol::get-patrol-route-run-details::1',
            v2: 'patrol::get-patrol-route-run-details::2',
        },
        GetPatrolRoutesActivityForTheDay: {
            v1: 'patrol::get-patrol-routes-activity-for-the-day::1',
        },
        ReOpenPatrolRouteRun: {
            v1: 'patrol::re-open-patrol-route-run::1',
        },
        StartPatrolRouteRun: {
            v1: 'patrol::start-patrol-route-run::1',
            v2: 'patrol::start-patrol-route-run::2',
        },
        UpdatePatrolRoute: {
            v1: 'patrol::update-patrol-route::1',
        },
        UpdatePatrolRouteRun: {
            v1: 'patrol::update-patrol-route-run::1',
        },
        UpdatePatrolRouteRunVisit: {
            v1: 'patrol::update-patrol-route-run-visit::1',
        },
    },
    Public: {
        DownloadPublicContentPdf: {
            v1: 'public::download-public-content-pdf::1',
        },
        GetCheckpoint: {
            v1: 'public::get-checkpoint::1',
        },
        GetLocation: {
            v1: 'public::get-location::1',
        },
        GetLocationSubscriberContent: {
            v1: 'public::get-location-subscriber-content::1',
        },
        GetPublicContentDetails: {
            v1: 'public::get-public-content-details::1',
            v2: 'public::get-public-content-details::2',
        },
        GetRecord: {
            v1: 'public::get-record::1',
        },
        GetRequestPortalAccessLink: {
            v1: 'public::get-request-portal-access-link::1',
        },
        GetUser: {
            v1: 'public::get-user::1',
        },
        ResendPublicContentCode: {
            v1: 'public::resend-public-content-code::1',
        },
        VerifyPublicContentAccess: {
            v1: 'public::verify-public-content-access::1',
        },
    },
    Records: {
        AddRecordDateSensitiveTag: {
            v1: 'records::add-record-date-sensitive-tag::1',
        },
        AddRecordFiles: {
            v1: 'records::add-record-files::1',
        },
        AddRecordRefs: {
            v1: 'records::add-record-refs::1',
        },
        BulkCreateRecords: {
            v1: 'records::bulk-create-records::1',
        },
        CreateRecord: {
            v1: 'records::create-record::1',
        },
        CreateRecordComment: {
            v1: 'records::create-record-comment::1',
        },
        CreateRecordTag: {
            v1: 'records::create-record-tag::1',
        },
        DeleteRecord: {
            v1: 'records::delete-record::1',
        },
        DeleteRecordComment: {
            v1: 'records::delete-record-comment::1',
        },
        DeleteRecordTags: {
            v1: 'records::delete-record-tags::1',
        },
        DownloadRecord: {
            v1: 'records::download-record::1',
            v2: 'records::download-record::2',
        },
        GetRecordAuditLogs: {
            v1: 'records::get-record-audit-logs::1',
        },
        GetRecordComments: {
            v1: 'records::get-record-comments::1',
        },
        GetRecordProfile: {
            v1: 'records::get-record-profile::1',
        },
        GetRecordProfiles: {
            v1: 'records::get-record-profiles::1',
        },
        GetRecordTagsList: {
            v1: 'records::get-record-tags-list::1',
        },
        GetRecordsFieldOptionsConfig: {
            v1: 'records::get-records-field-options-config::1',
        },
        GetRecordsList: {
            v1: 'records::get-records-list::1',
        },
        MoveRecordDateSensitiveTagToTags: {
            v1: 'records::move-record-date-sensitive-tag-to-tags::1',
        },
        RemoveRecordDateSensitiveTag: {
            v1: 'records::remove-record-date-sensitive-tag::1',
        },
        RemoveRecordRefs: {
            v1: 'records::remove-record-refs::1',
        },
        SaveRecordsFieldOptionsConfig: {
            v1: 'records::save-records-field-options-config::1',
        },
        SetRecordTags: {
            v1: 'records::set-record-tags::1',
        },
        UpdateRecord: {
            v1: 'records::update-record::1',
        },
        UpdateRecordComment: {
            v1: 'records::update-record-comment::1',
        },
        UpdateRecordDateSensitiveTag: {
            v1: 'records::update-record-date-sensitive-tag::1',
        },
        UpdateRecordTag: {
            v1: 'records::update-record-tag::1',
        },
    },
    RefLinks: {
        DeleteRefLink: {
            v1: 'ref-links::delete-ref-link::1',
        },
        GetRefLink: {
            v1: 'ref-links::get-ref-link::1',
        },
        GetRefLinkCounts: {
            v1: 'ref-links::get-ref-link-counts::1',
        },
        GetRefLinks: {
            v1: 'ref-links::get-ref-links::1',
        },
        SaveRefLink: {
            v1: 'ref-links::save-ref-link::1',
        },
    },
    Regions: {
        ActivateRegion: {
            v1: 'regions::activate-region::1',
        },
        CreateRegion: {
            v1: 'regions::create-region::1',
        },
        DeactivateRegion: {
            v1: 'regions::deactivate-region::1',
        },
        GetRegionProfile: {
            v1: 'regions::get-region-profile::1',
        },
        GetRegionsList: {
            v1: 'regions::get-regions-list::1',
        },
        UpdateRegion: {
            v1: 'regions::update-region::1',
        },
    },
    Reports: {
        ChangeReportStatus: {
            v1: 'reports::change-report-status::1',
        },
        CreateReport: {
            v1: 'reports::create-report::1',
        },
        CreateReportEntry: {
            v1: 'reports::create-report-entry::1',
            v2: 'reports::create-report-entry::2',
        },
        CreateReportEntryType: {
            v1: 'reports::create-report-entry-type::1',
        },
        CreateReportType: {
            v1: 'reports::create-report-type::1',
        },
        CreateReportTypesSubscribers: {
            v1: 'reports::create-report-types-subscribers::1',
        },
        DeleteReport: {
            v1: 'reports::delete-report::1',
        },
        DeleteReportEntry: {
            v1: 'reports::delete-report-entry::1',
        },
        DeleteReportEntryType: {
            v1: 'reports::delete-report-entry-type::1',
        },
        DeleteReportEntryTypes: {
            v1: 'reports::delete-report-entry-types::1',
        },
        DeleteReportType: {
            v1: 'reports::delete-report-type::1',
        },
        DeleteReportTypes: {
            v1: 'reports::delete-report-types::1',
        },
        DeleteReportTypesSubscribers: {
            v1: 'reports::delete-report-types-subscribers::1',
        },
        DownloadReport: {
            v1: 'reports::download-report::1',
            v2: 'reports::download-report::2',
        },
        GetCurrentReportCounts: {
            v1: 'reports::get-current-report-counts::1',
        },
        GetReport: {
            v1: 'reports::get-report::1',
        },
        GetReportDataSheet: {
            v1: 'reports::get-report-data-sheet::1',
        },
        GetReportEntryDetail: {
            v1: 'reports::get-report-entry-detail::1',
        },
        GetReportEntryList: {
            v1: 'reports::get-report-entry-list::1',
            v2: 'reports::get-report-entry-list::2',
        },
        GetReportEntryType: {
            v1: 'reports::get-report-entry-type::1',
        },
        GetReportEntryTypesList: {
            v1: 'reports::get-report-entry-types-list::1',
        },
        GetReportNextStatuses: {
            v1: 'reports::get-report-next-statuses::1',
        },
        GetReportTypeEntryTypesFormBuilderInputFields: {
            v1: 'reports::get-report-type-entry-types-form-builder-input-fields::1',
        },
        GetReportTypesDetails: {
            v1: 'reports::get-report-types-details::1',
        },
        GetReportTypesList: {
            v1: 'reports::get-report-types-list::1',
        },
        GetReportTypesSubscriberDailyEmailPreview: {
            v1: 'reports::get-report-types-subscriber-daily-email-preview::1',
        },
        GetReportTypesSubscribers: {
            v1: 'reports::get-report-types-subscribers::1',
        },
        GetReportTypesWithEntryTypeList: {
            v1: 'reports::get-report-types-with-entry-type-list::1',
        },
        GetReportsList: {
            v1: 'reports::get-reports-list::1',
        },
        SendReportTypesSubscriberDailyEmail: {
            v1: 'reports::send-report-types-subscriber-daily-email::1',
        },
        SetReportTypesActive: {
            v1: 'reports::set-report-types-active::1',
        },
        UpdateReport: {
            v1: 'reports::update-report::1',
        },
        UpdateReportEntry: {
            v1: 'reports::update-report-entry::1',
            v2: 'reports::update-report-entry::2',
        },
        UpdateReportEntryType: {
            v1: 'reports::update-report-entry-type::1',
        },
        UpdateReportType: {
            v1: 'reports::update-report-type::1',
        },
        UpdateReportTypesSubscriber: {
            v1: 'reports::update-report-types-subscriber::1',
        },
    },
    Scheduling: {
        CopyScheduledShiftsToDate: {
            v1: 'scheduling::copy-scheduled-shifts-to-date::1',
        },
        CreateCustomSchedulingAssignment: {
            v1: 'scheduling::create-custom-scheduling-assignment::1',
        },
        CreateScheduledShift: {
            v1: 'scheduling::create-scheduled-shift::1',
        },
        CreateShift: {
            v1: 'scheduling::create-shift::1',
        },
        DeleteCustomSchedulingAssignment: {
            v1: 'scheduling::delete-custom-scheduling-assignment::1',
        },
        DeleteScheduledShifts: {
            v1: 'scheduling::delete-scheduled-shifts::1',
        },
        EditShift: {
            v1: 'scheduling::edit-shift::1',
        },
        EndBreak: {
            v1: 'scheduling::end-break::1',
        },
        EndShift: {
            v1: 'scheduling::end-shift::1',
        },
        GetCurrentShiftsCounts: {
            v1: 'scheduling::get-current-shifts-counts::1',
        },
        GetCurrentShiftsList: {
            v1: 'scheduling::get-current-shifts-list::1',
        },
        GetScheduleConfig: {
            v1: 'scheduling::get-schedule-config::1',
        },
        GetScheduledShiftsByStartTime: {
            v1: 'scheduling::get-scheduled-shifts-by-start-time::1',
        },
        GetSchedulingAssignment: {
            v1: 'scheduling::get-scheduling-assignment::1',
        },
        GetSchedulingAssignments: {
            v1: 'scheduling::get-scheduling-assignments::1',
        },
        GetSchedulingUser: {
            v1: 'scheduling::get-scheduling-user::1',
        },
        GetSchedulingUsers: {
            v1: 'scheduling::get-scheduling-users::1',
        },
        GetShiftDetail: {
            v1: 'scheduling::get-shift-detail::1',
        },
        GetShiftsByStartTimeDetails: {
            v1: 'scheduling::get-shifts-by-start-time-details::1',
        },
        GetShiftsByStartTimeList: {
            v1: 'scheduling::get-shifts-by-start-time-list::1',
        },
        GetUserCurrentOrFutureShift: {
            v1: 'scheduling::get-user-current-or-future-shift::1',
        },
        PublishScheduledShifts: {
            v1: 'scheduling::publish-scheduled-shifts::1',
        },
        SaveScheduleConfig: {
            v1: 'scheduling::save-schedule-config::1',
        },
        SetShiftAcknowledged: {
            v1: 'scheduling::set-shift-acknowledged::1',
        },
        StartBreak: {
            v1: 'scheduling::start-break::1',
        },
        StartShift: {
            v1: 'scheduling::start-shift::1',
        },
        ToggleAllLocationSchedulingAssignments: {
            v1: 'scheduling::toggle-all-location-scheduling-assignments::1',
        },
        ToggleAllLocationSchedulingUsers: {
            v1: 'scheduling::toggle-all-location-scheduling-users::1',
        },
        ToggleCustomSchedulingAssignment: {
            v1: 'scheduling::toggle-custom-scheduling-assignment::1',
        },
        ToggleLocationSchedulingAssignment: {
            v1: 'scheduling::toggle-location-scheduling-assignment::1',
        },
        ToggleSchedulingUser: {
            v1: 'scheduling::toggle-scheduling-user::1',
        },
        UnpublishScheduledShifts: {
            v1: 'scheduling::unpublish-scheduled-shifts::1',
        },
        UpdateCustomSchedulingAssignment: {
            v1: 'scheduling::update-custom-scheduling-assignment::1',
        },
        UpdateScheduledShift: {
            v1: 'scheduling::update-scheduled-shift::1',
        },
    },
    ServicePeriods: {
        ApplyServicePeriodTemplate: {
            v1: 'service-periods::apply-service-period-template::1',
        },
        CreateServicePeriod: {
            v1: 'service-periods::create-service-period::1',
        },
        CreateServicePeriodTemplate: {
            v1: 'service-periods::create-service-period-template::1',
        },
        DeleteServicePeriodTemplates: {
            v1: 'service-periods::delete-service-period-templates::1',
        },
        DeleteServicePeriods: {
            v1: 'service-periods::delete-service-periods::1',
        },
        FindActivityEvals: {
            v1: 'service-periods::find-activity-evals::1',
        },
        FindServicePeriodInstances: {
            v1: 'service-periods::find-service-period-instances::1',
        },
        FindServicePeriodTemplates: {
            v1: 'service-periods::find-service-period-templates::1',
        },
        FindServicePeriods: {
            v1: 'service-periods::find-service-periods::1',
        },
        UpdateServicePeriod: {
            v1: 'service-periods::update-service-period::1',
        },
        UpdateServicePeriodTemplate: {
            v1: 'service-periods::update-service-period-template::1',
        },
    },
    Stats: {
        DownloadLocationStats: {
            v1: 'stats::download-location-stats::1',
            v2: 'stats::download-location-stats::2',
        },
        DownloadOrganizationStats: {
            v1: 'stats::download-organization-stats::1',
            v2: 'stats::download-organization-stats::2',
        },
        GetEventsHistogram: {
            v1: 'stats::get-events-histogram::1',
        },
        GetEventsStatsCount: {
            v1: 'stats::get-events-stats-count::1',
        },
        GetLocationCheckpointScansHistogram: {
            v1: 'stats::get-location-checkpoint-scans-histogram::1',
        },
        GetLocationGeoHistoryStats: {
            v1: 'stats::get-location-geo-history-stats::1',
        },
        GetLocationLogEntriesHistogram: {
            v1: 'stats::get-location-log-entries-histogram::1',
        },
        GetLocationLogEntriesStatsCount: {
            v1: 'stats::get-location-log-entries-stats-count::1',
        },
        GetReportsHistogram: {
            v1: 'stats::get-reports-histogram::1',
        },
        GetReportsStatsCount: {
            v1: 'stats::get-reports-stats-count::1',
        },
        GetUserWithStatusHistogram: {
            v1: 'stats::get-user-with-status-histogram::1',
        },
    },
    Summaries: {
        GetOpsSummaryForDates: {
            v1: 'summaries::get-ops-summary-for-dates::1',
        },
    },
    Support: {
        ReportIssue: {
            v1: 'support::report-issue::1',
        },
        RequestCall: {
            v1: 'support::request-call::1',
        },
    },
    System: {
        GetSystemInfoForTarget: {
            v1: 'system::get-system-info-for-target::1',
        },
    },
    Tags: {
        CreateActivityTypeTag: {
            v1: 'tags::create-activity-type-tag::1',
        },
        DeleteActivityTypeTags: {
            v1: 'tags::delete-activity-type-tags::1',
        },
        GetActivityTypeTagsList: {
            v1: 'tags::get-activity-type-tags-list::1',
        },
        UpdateActivityTypeTag: {
            v1: 'tags::update-activity-type-tag::1',
        },
    },
    UserClient: {
        ClearUnread: {
            v1: 'user-client::clear-unread::1',
        },
        RemoveRecentLocations: {
            v1: 'user-client::remove-recent-locations::1',
        },
        RemoveRecentRecords: {
            v1: 'user-client::remove-recent-records::1',
        },
        RemoveRecentReports: {
            v1: 'user-client::remove-recent-reports::1',
        },
        ViewLocation: {
            v1: 'user-client::view-location::1',
        },
        ViewRecord: {
            v1: 'user-client::view-record::1',
        },
        ViewReport: {
            v1: 'user-client::view-report::1',
        },
    },
    UserSos: {
        ActivateUserSos: {
            v1: 'user-sos::activate-user-sos::1',
        },
        DeactivateUserSos: {
            v1: 'user-sos::deactivate-user-sos::1',
        },
        DeleteUserSosComment: {
            v1: 'user-sos::delete-user-sos-comment::1',
        },
        GetActivatedUserSos: {
            v1: 'user-sos::get-activated-user-sos::1',
        },
        GetUserSosComments: {
            v1: 'user-sos::get-user-sos-comments::1',
        },
        GetUserSosHistory: {
            v1: 'user-sos::get-user-sos-history::1',
        },
        SaveUserSosComment: {
            v1: 'user-sos::save-user-sos-comment::1',
        },
        UpdateActivatedUserSos: {
            v1: 'user-sos::update-activated-user-sos::1',
        },
    },
    Users: {
        ActivateUser: {
            v1: 'users::activate-user::1',
        },
        AddLocationToUserAnp: {
            v1: 'users::add-location-to-user-anp::1',
        },
        CheckOrganizationExistingEmail: {
            v1: 'users::check-organization-existing-email::1',
        },
        CreateUser: {
            v1: 'users::create-user::1',
        },
        CreateUserAdminComment: {
            v1: 'users::create-user-admin-comment::1',
        },
        CreateUserGroup: {
            v1: 'users::create-user-group::1',
        },
        CreateUserPositionOption: {
            v1: 'users::create-user-position-option::1',
        },
        CreateUserStatusOption: {
            v1: 'users::create-user-status-option::1',
        },
        DeactivateUser: {
            v1: 'users::deactivate-user::1',
        },
        DeleteUserAdminComment: {
            v1: 'users::delete-user-admin-comment::1',
        },
        DeleteUserGroups: {
            v1: 'users::delete-user-groups::1',
        },
        DeleteUserPositionOptions: {
            v1: 'users::delete-user-position-options::1',
        },
        DeleteUserStatusOptions: {
            v1: 'users::delete-user-status-options::1',
        },
        GetAllowedUserStatusOptionsAndPositions: {
            v1: 'users::get-allowed-user-status-options-and-positions::1',
        },
        GetNearbyUsersList: {
            v1: 'users::get-nearby-users-list::1',
        },
        GetUserAccessAndPermissions: {
            v1: 'users::get-user-access-and-permissions::1',
        },
        GetUserAdminComments: {
            v1: 'users::get-user-admin-comments::1',
        },
        GetUserAuditLogs: {
            v1: 'users::get-user-audit-logs::1',
        },
        GetUserAuthSessionsHistoryList: {
            v1: 'users::get-user-auth-sessions-history-list::1',
        },
        GetUserAuthSessionsList: {
            v1: 'users::get-user-auth-sessions-list::1',
        },
        GetUserGeoFenceCrossings: {
            v1: 'users::get-user-geo-fence-crossings::1',
        },
        GetUserGeoLocationHistory: {
            v1: 'users::get-user-geo-location-history::1',
        },
        GetUserGeoLocationHistoryAtLocation: {
            v1: 'users::get-user-geo-location-history-at-location::1',
        },
        GetUserGroup: {
            v1: 'users::get-user-group::1',
        },
        GetUserGroups: {
            v1: 'users::get-user-groups::1',
        },
        GetUserGroupsList: {
            v1: 'users::get-user-groups-list::1',
        },
        GetUserGroupsWithLocationAccessList: {
            v1: 'users::get-user-groups-with-location-access-list::1',
        },
        GetUserName: {
            v1: 'users::get-user-name::1',
        },
        GetUserNames: {
            v1: 'users::get-user-names::1',
        },
        GetUserPositionOption: {
            v1: 'users::get-user-position-option::1',
        },
        GetUserPositionOptionsList: {
            v1: 'users::get-user-position-options-list::1',
        },
        GetUserProfile: {
            v1: 'users::get-user-profile::1',
        },
        GetUserRegistrationRequests: {
            v1: 'users::get-user-registration-requests::1',
        },
        GetUserStatusHistory: {
            v1: 'users::get-user-status-history::1',
        },
        GetUserStatusOption: {
            v1: 'users::get-user-status-option::1',
        },
        GetUserStatusOptionsList: {
            v1: 'users::get-user-status-options-list::1',
        },
        GetUsersAndGroupsForCommunicationsList: {
            v1: 'users::get-users-and-groups-for-communications-list::1',
        },
        GetUsersAndGroupsLabelsList: {
            v1: 'users::get-users-and-groups-labels-list::1',
        },
        GetUsersGeoSearch: {
            v1: 'users::get-users-geo-search::1',
        },
        GetUsersList: {
            v1: 'users::get-users-list::1',
        },
        GetUsersWithLocationAccessList: {
            v1: 'users::get-users-with-location-access-list::1',
        },
        KillAllUserAuthSessions: {
            v1: 'users::kill-all-user-auth-sessions::1',
        },
        KillUserAuthSessions: {
            v1: 'users::kill-user-auth-sessions::1',
        },
        RejectUserRegistrationRequest: {
            v1: 'users::reject-user-registration-request::1',
        },
        RemoveLocationFromUserAnp: {
            v1: 'users::remove-location-from-user-anp::1',
        },
        RequestUsersDevicesGeoLocationReport: {
            v1: 'users::request-users-devices-geo-location-report::1',
        },
        ResetUserPassword: {
            v1: 'users::reset-user-password::1',
        },
        SaveUserDeviceGeo: {
            v1: 'users::save-user-device-geo::1',
        },
        SetUserPosition: {
            v1: 'users::set-user-position::1',
        },
        SetUserStatus: {
            v1: 'users::set-user-status::1',
        },
        SetUsersAnpRoles: {
            v1: 'users::set-users-anp-roles::1',
        },
        UpdateUser: {
            v1: 'users::update-user::1',
        },
        UpdateUserAdminComment: {
            v1: 'users::update-user-admin-comment::1',
        },
        UpdateUserGroup: {
            v1: 'users::update-user-group::1',
        },
        UpdateUserPositionOption: {
            v1: 'users::update-user-position-option::1',
        },
        UpdateUserStatusOption: {
            v1: 'users::update-user-status-option::1',
        },
    },
};
export const RPCService = (rpcClient) => ({
    ActivityFeed: {
        GetOpsActivityFeed: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ActivityFeed.GetOpsActivityFeed.v1, args, opts),
            },
        },
        GetOpsUserRecentActivity: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ActivityFeed.GetOpsUserRecentActivity.v1, args, opts),
            },
        },
    },
    Admin: {
        CreateOpsSummarySubscriber: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Admin.CreateOpsSummarySubscriber.v1, args, opts),
            },
        },
        DeleteOpsSummarySubscriber: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Admin.DeleteOpsSummarySubscriber.v1, args, opts),
            },
        },
        FindOpsSummarySubscribers: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Admin.FindOpsSummarySubscribers.v1, args, opts),
            },
        },
        GetOpsSummarySubscriberEmailPreview: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Admin.GetOpsSummarySubscriberEmailPreview.v1, args, opts),
            },
        },
        OptimizeSmartWatchCriteria: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Admin.OptimizeSmartWatchCriteria.v1, args, opts),
            },
        },
        SendOpsSummarySubscriberEmail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Admin.SendOpsSummarySubscriberEmail.v1, args, opts),
            },
        },
        UpdateOpsSummarySubscriber: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Admin.UpdateOpsSummarySubscriber.v1, args, opts),
            },
        },
    },
    Ai: {
        GetAiConfigs: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Ai.GetAiConfigs.v1, args, opts),
            },
        },
        GetAvailableProviders: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Ai.GetAvailableProviders.v1, args, opts),
            },
        },
        GetOrganizationAiProviderKeys: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Ai.GetOrganizationAiProviderKeys.v1, args, opts),
            },
        },
        SetOrganizationAiProviderKey: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Ai.SetOrganizationAiProviderKey.v1, args, opts),
            },
        },
    },
    Auth: {
        Authenticate: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.Authenticate.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.Authenticate.v2, args, opts),
            },
        },
        AuthenticateAsUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.AuthenticateAsUser.v1, args, opts),
            },
        },
        CheckExistingEmail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.CheckExistingEmail.v1, args, opts),
            },
        },
        DeAuthenticate: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.DeAuthenticate.v1, args, opts),
            },
        },
        GetAuthInfo: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.GetAuthInfo.v1, args, opts),
            },
        },
        GetIdentityInfo: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.GetIdentityInfo.v1, args, opts),
            },
        },
        ReadonlyToken: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.ReadonlyToken.v1, args, opts),
            },
        },
        RefreshAuthToken: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.RefreshAuthToken.v1, args, opts),
            },
        },
        RequestResetPassword: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.RequestResetPassword.v1, args, opts),
            },
        },
        SaveDeviceInfo: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.SaveDeviceInfo.v1, args, opts),
            },
        },
        SaveDevicePhysicalActivity: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.SaveDevicePhysicalActivity.v1, args, opts),
            },
        },
        SaveUserClientMetadataWebData: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.SaveUserClientMetadataWebData.v1, args, opts),
            },
        },
        SelfSendPushNotification: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.SelfSendPushNotification.v1, args, opts),
            },
        },
        SendMobileAppLinkSms: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.SendMobileAppLinkSms.v1, args, opts),
            },
        },
        SetNewPassword: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.SetNewPassword.v1, args, opts),
            },
        },
        Simulate401: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.Simulate401.v1, args, opts),
            },
        },
        SwitchUserProfile: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Auth.SwitchUserProfile.v1, args, opts),
            },
        },
    },
    Bolos: {
        DeleteBolo: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bolos.DeleteBolo.v1, args, opts),
            },
        },
        GetBolo: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bolos.GetBolo.v1, args, opts),
            },
        },
    },
    Bulletins: {
        AcknowledgeBulletin: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bulletins.AcknowledgeBulletin.v1, args, opts),
            },
        },
        CreateBulletin: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bulletins.CreateBulletin.v1, args, opts),
            },
        },
        DeleteBulletinComments: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bulletins.DeleteBulletinComments.v1, args, opts),
            },
        },
        DeleteBulletins: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bulletins.DeleteBulletins.v1, args, opts),
            },
        },
        GetBulletinComments: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bulletins.GetBulletinComments.v1, args, opts),
            },
        },
        GetBulletinsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bulletins.GetBulletinsList.v1, args, opts),
            },
        },
        SaveBulletinComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bulletins.SaveBulletinComment.v1, args, opts),
            },
        },
        UpdateBulletin: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bulletins.UpdateBulletin.v1, args, opts),
            },
        },
        ViewBulletin: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Bulletins.ViewBulletin.v1, args, opts),
            },
        },
    },
    Entries: {
        GetEntry: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Entries.GetEntry.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Entries.GetEntry.v2, args, opts),
            },
            v3: {
                call: (args, opts) => rpcClient.call(RPCs.Entries.GetEntry.v3, args, opts),
            },
        },
        GetEntryTypeDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Entries.GetEntryTypeDetail.v1, args, opts),
            },
        },
        GetEntryTypesDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Entries.GetEntryTypesDetails.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Entries.GetEntryTypesDetails.v2, args, opts),
            },
            v3: {
                call: (args, opts) => rpcClient.call(RPCs.Entries.GetEntryTypesDetails.v3, args, opts),
            },
        },
        GetEntryTypesList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Entries.GetEntryTypesList.v1, args, opts),
            },
        },
    },
    Events: {
        AddEventAssignedUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.AddEventAssignedUser.v1, args, opts),
            },
        },
        CloseEvent: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.CloseEvent.v1, args, opts),
            },
        },
        CreateEvent: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.CreateEvent.v1, args, opts),
            },
        },
        CreateEventComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.CreateEventComment.v1, args, opts),
            },
        },
        CreateEventType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.CreateEventType.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Events.CreateEventType.v2, args, opts),
            },
        },
        DeleteEvent: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.DeleteEvent.v1, args, opts),
            },
        },
        DeleteEventComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.DeleteEventComment.v1, args, opts),
            },
        },
        DeleteEventType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.DeleteEventType.v1, args, opts),
            },
        },
        DownloadEvent: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.DownloadEvent.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Events.DownloadEvent.v2, args, opts),
            },
        },
        GetCurrentEventCounts: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.GetCurrentEventCounts.v1, args, opts),
            },
        },
        GetEvent: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.GetEvent.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Events.GetEvent.v2, args, opts),
            },
        },
        GetEventComments: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.GetEventComments.v1, args, opts),
            },
        },
        GetEventTypeDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.GetEventTypeDetail.v1, args, opts),
            },
        },
        GetEventTypesDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.GetEventTypesDetails.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Events.GetEventTypesDetails.v2, args, opts),
            },
        },
        GetEventTypesList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.GetEventTypesList.v1, args, opts),
            },
        },
        GetEventsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.GetEventsList.v1, args, opts),
            },
        },
        RemoveEventAssignedUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.RemoveEventAssignedUser.v1, args, opts),
            },
        },
        ReopenEvent: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.ReopenEvent.v1, args, opts),
            },
        },
        SaveEventDisposition: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.SaveEventDisposition.v1, args, opts),
            },
        },
        SaveEventDispositionFields: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.SaveEventDispositionFields.v1, args, opts),
            },
        },
        SaveEventRefs: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.SaveEventRefs.v1, args, opts),
            },
        },
        SetEventAssignedUserAcknowledged: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.SetEventAssignedUserAcknowledged.v1, args, opts),
            },
        },
        SetEventAssignedUserStatus: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.SetEventAssignedUserStatus.v1, args, opts),
            },
        },
        UpdateEvent: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.UpdateEvent.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Events.UpdateEvent.v2, args, opts),
            },
        },
        UpdateEventComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.UpdateEventComment.v1, args, opts),
            },
        },
        UpdateEventType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Events.UpdateEventType.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Events.UpdateEventType.v2, args, opts),
            },
        },
    },
    External: {
        CheckEmailSuppression: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.CheckEmailSuppression.v1, args, opts),
            },
        },
        CompleteOrganizationRegistration: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.CompleteOrganizationRegistration.v1, args, opts),
            },
        },
        CompletePortalUserRegistration: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.CompletePortalUserRegistration.v1, args, opts),
            },
        },
        CompleteUserRegistration: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.CompleteUserRegistration.v1, args, opts),
            },
        },
        GetFileUploadUrl: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.GetFileUploadUrl.v1, args, opts),
            },
        },
        GetLocationSubscriberDetailsForPortalUserAccountRegistrationRequest: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External
                    .GetLocationSubscriberDetailsForPortalUserAccountRegistrationRequest
                    .v1, args, opts),
            },
        },
        NewRegistrationWithEmail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.NewRegistrationWithEmail.v1, args, opts),
            },
        },
        OrganizationLookup: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.OrganizationLookup.v1, args, opts),
            },
        },
        RegisterOrganization: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.RegisterOrganization.v1, args, opts),
            },
        },
        ResetEmailSuppression: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.ResetEmailSuppression.v1, args, opts),
            },
        },
        SimulateDelay: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.SimulateDelay.v1, args, opts),
            },
        },
        SimulateResponse: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.External.SimulateResponse.v1, args, opts),
            },
        },
    },
    Files: {
        GetFileUploadUrl: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Files.GetFileUploadUrl.v1, args, opts),
            },
        },
    },
    Forms: {
        DeleteForm: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Forms.DeleteForm.v1, args, opts),
            },
        },
        DeleteFormFieldTemplate: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Forms.DeleteFormFieldTemplate.v1, args, opts),
            },
        },
        GetForm: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Forms.GetForm.v1, args, opts),
            },
        },
        GetFormFieldTemplates: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Forms.GetFormFieldTemplates.v1, args, opts),
            },
        },
        GetFormTemplates: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Forms.GetFormTemplates.v1, args, opts),
            },
        },
        GetForms: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Forms.GetForms.v1, args, opts),
            },
        },
        SaveForm: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Forms.SaveForm.v1, args, opts),
            },
        },
        SaveFormFieldTemplate: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Forms.SaveFormFieldTemplate.v1, args, opts),
            },
        },
        SaveFormTemplate: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Forms.SaveFormTemplate.v1, args, opts),
            },
        },
    },
    Geo: {
        GetGooglePlaceDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Geo.GetGooglePlaceDetails.v1, args, opts),
            },
        },
        GetGooglePlacesAutocompleteSuggestions: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Geo.GetGooglePlacesAutocompleteSuggestions.v1, args, opts),
            },
        },
        GetLatLngFromAddress: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Geo.GetLatLngFromAddress.v1, args, opts),
            },
        },
        GetStreetPhotoFromLatLng: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Geo.GetStreetPhotoFromLatLng.v1, args, opts),
            },
        },
    },
    GeoZones: {
        CreateGeoZone: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.GeoZones.CreateGeoZone.v1, args, opts),
            },
        },
        DeleteGeoZones: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.GeoZones.DeleteGeoZones.v1, args, opts),
            },
        },
        FindGeoZones: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.GeoZones.FindGeoZones.v1, args, opts),
            },
        },
        UpdateGeoZone: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.GeoZones.UpdateGeoZone.v1, args, opts),
            },
        },
    },
    Locations: {
        ActivateLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.ActivateLocation.v1, args, opts),
            },
        },
        ActivateLocationLogEntryType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.ActivateLocationLogEntryType.v1, args, opts),
            },
        },
        BulkUpdateLocationConfigSettings: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.BulkUpdateLocationConfigSettings.v1, args, opts),
            },
        },
        CompleteLocationTaskTodo: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CompleteLocationTaskTodo.v1, args, opts),
            },
        },
        CreateAddressLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateAddressLocation.v1, args, opts),
            },
        },
        CreateLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocation.v1, args, opts),
            },
        },
        CreateLocationBolo: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationBolo.v1, args, opts),
            },
        },
        CreateLocationCheckpoint: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationCheckpoint.v1, args, opts),
            },
        },
        CreateLocationCheckpointTour: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationCheckpointTour.v1, args, opts),
            },
        },
        CreateLocationContact: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationContact.v1, args, opts),
            },
        },
        CreateLocationGroup: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationGroup.v1, args, opts),
            },
        },
        CreateLocationInfoBlock: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationInfoBlock.v1, args, opts),
            },
        },
        CreateLocationInfoBlockCategory: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationInfoBlockCategory.v1, args, opts),
            },
        },
        CreateLocationLogEntry: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationLogEntry.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationLogEntry.v2, args, opts),
            },
        },
        CreateLocationLogEntryType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationLogEntryType.v1, args, opts),
            },
        },
        CreateLocationPassDown: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationPassDown.v1, args, opts),
            },
        },
        CreateLocationSubscriber: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationSubscriber.v1, args, opts),
            },
        },
        CreateLocationTask: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.CreateLocationTask.v1, args, opts),
            },
        },
        DeactivateLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeactivateLocation.v1, args, opts),
            },
        },
        DeactivateLocationLogEntryType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeactivateLocationLogEntryType.v1, args, opts),
            },
        },
        DeleteLocationAdminComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationAdminComment.v1, args, opts),
            },
        },
        DeleteLocationCheckpoint: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationCheckpoint.v1, args, opts),
            },
        },
        DeleteLocationCheckpointScan: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationCheckpointScan.v1, args, opts),
            },
        },
        DeleteLocationCheckpointTour: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationCheckpointTour.v1, args, opts),
            },
        },
        DeleteLocationCheckpointTourRun: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationCheckpointTourRun.v1, args, opts),
            },
        },
        DeleteLocationContact: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationContact.v1, args, opts),
            },
        },
        DeleteLocationContacts: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationContacts.v1, args, opts),
            },
        },
        DeleteLocationGroups: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationGroups.v1, args, opts),
            },
        },
        DeleteLocationInfoBlockCategories: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationInfoBlockCategories.v1, args, opts),
            },
        },
        DeleteLocationInfoBlocks: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationInfoBlocks.v1, args, opts),
            },
        },
        DeleteLocationLogEntry: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationLogEntry.v1, args, opts),
            },
        },
        DeleteLocationLogEntryType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationLogEntryType.v1, args, opts),
            },
        },
        DeleteLocationSubscribers: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationSubscribers.v1, args, opts),
            },
        },
        DeleteLocationTasks: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DeleteLocationTasks.v1, args, opts),
            },
        },
        DownloadLocationCheckpointActivity: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DownloadLocationCheckpointActivity.v1, args, opts),
            },
        },
        DownloadLocationCheckpointScans: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DownloadLocationCheckpointScans.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DownloadLocationCheckpointScans.v2, args, opts),
            },
        },
        DownloadLocationCheckpointTours: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DownloadLocationCheckpointTours.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DownloadLocationCheckpointTours.v2, args, opts),
            },
        },
        DownloadLocationLogEntries: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DownloadLocationLogEntries.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DownloadLocationLogEntries.v2, args, opts),
            },
        },
        DownloadLocationLogEntry: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DownloadLocationLogEntry.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.DownloadLocationLogEntry.v2, args, opts),
            },
        },
        EndLocationCheckpointTourRun: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.EndLocationCheckpointTourRun.v1, args, opts),
            },
        },
        GetContactsForLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetContactsForLocation.v1, args, opts),
            },
        },
        GetInfoBlockCategoriesForLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetInfoBlockCategoriesForLocation.v1, args, opts),
            },
        },
        GetInfoBlocksForLocationCategory: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetInfoBlocksForLocationCategory.v1, args, opts),
            },
        },
        GetLocationActivitySummary: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationActivitySummary.v1, args, opts),
            },
        },
        GetLocationAdminComments: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationAdminComments.v1, args, opts),
            },
        },
        GetLocationAuditDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationAuditDetails.v1, args, opts),
            },
        },
        GetLocationBolosList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationBolosList.v1, args, opts),
            },
        },
        GetLocationCheckpointDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointDetail.v1, args, opts),
            },
        },
        GetLocationCheckpointScanDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointScanDetail.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointScanDetail.v2, args, opts),
            },
        },
        GetLocationCheckpointScansList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointScansList.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointScansList.v2, args, opts),
            },
        },
        GetLocationCheckpointTourDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointTourDetail.v1, args, opts),
            },
        },
        GetLocationCheckpointTourRunDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointTourRunDetail.v1, args, opts),
            },
        },
        GetLocationCheckpointTourRunsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointTourRunsList.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointTourRunsList.v2, args, opts),
            },
        },
        GetLocationCheckpointToursList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointToursList.v1, args, opts),
            },
        },
        GetLocationCheckpointsDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointsDetail.v1, args, opts),
            },
        },
        GetLocationCheckpointsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationCheckpointsList.v1, args, opts),
            },
        },
        GetLocationContact: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationContact.v1, args, opts),
            },
        },
        GetLocationContactsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationContactsList.v1, args, opts),
            },
        },
        GetLocationGeoDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationGeoDetail.v1, args, opts),
            },
        },
        GetLocationGroup: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationGroup.v1, args, opts),
            },
        },
        GetLocationGroupsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationGroupsList.v1, args, opts),
            },
        },
        GetLocationInfoBlock: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationInfoBlock.v1, args, opts),
            },
        },
        GetLocationInfoBlockCategories: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationInfoBlockCategories.v1, args, opts),
            },
        },
        GetLocationInfoBlockCategory: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationInfoBlockCategory.v1, args, opts),
            },
        },
        GetLocationInfoBlocksDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationInfoBlocksDetail.v1, args, opts),
            },
        },
        GetLocationInfoBlocksList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationInfoBlocksList.v1, args, opts),
            },
        },
        GetLocationInfoSubscriberDailyEmailPreview: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationInfoSubscriberDailyEmailPreview.v1, args, opts),
            },
        },
        GetLocationLogEntriesDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationLogEntriesDetails.v1, args, opts),
            },
        },
        GetLocationLogEntriesList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationLogEntriesList.v1, args, opts),
            },
        },
        GetLocationLogEntryDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationLogEntryDetail.v1, args, opts),
            },
        },
        GetLocationLogEntryList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationLogEntryList.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationLogEntryList.v2, args, opts),
            },
        },
        GetLocationLogEntryType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationLogEntryType.v1, args, opts),
            },
        },
        GetLocationLogEntryTypeLocationsRelations: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationLogEntryTypeLocationsRelations.v1, args, opts),
            },
        },
        GetLocationLogEntryTypesList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationLogEntryTypesList.v1, args, opts),
            },
        },
        GetLocationPassDownsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationPassDownsList.v1, args, opts),
            },
        },
        GetLocationProfile: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationProfile.v1, args, opts),
            },
        },
        GetLocationSubscribers: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationSubscribers.v1, args, opts),
            },
        },
        GetLocationTask: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationTask.v1, args, opts),
            },
        },
        GetLocationTaskCompletions: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationTaskCompletions.v1, args, opts),
            },
        },
        GetLocationTaskTodos: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationTaskTodos.v1, args, opts),
            },
        },
        GetLocationTasks: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationTasks.v1, args, opts),
            },
        },
        GetLocationUserGeofenceHistory: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationUserGeofenceHistory.v1, args, opts),
            },
        },
        GetLocationsAndGroupsLabelsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationsAndGroupsLabelsList.v1, args, opts),
            },
        },
        GetLocationsFromLocationAndGroupIdsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationsFromLocationAndGroupIdsList.v1, args, opts),
            },
        },
        GetLocationsGeoSearch: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationsGeoSearch.v1, args, opts),
            },
        },
        GetLocationsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetLocationsList.v1, args, opts),
            },
        },
        GetNearbyLocationsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetNearbyLocationsList.v1, args, opts),
            },
        },
        GetProjectedLocationTaskTodos: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetProjectedLocationTaskTodos.v1, args, opts),
            },
        },
        GetStatsCountsByLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.GetStatsCountsByLocation.v1, args, opts),
            },
        },
        LinkLocationToContact: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.LinkLocationToContact.v1, args, opts),
            },
        },
        LinkLocationToInfoBlock: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.LinkLocationToInfoBlock.v1, args, opts),
            },
        },
        SaveLocationAdminComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.SaveLocationAdminComment.v1, args, opts),
            },
        },
        SaveLocationCheckpointScan: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.SaveLocationCheckpointScan.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.SaveLocationCheckpointScan.v2, args, opts),
            },
        },
        SendLocationInfoSubscriberDailyEmail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.SendLocationInfoSubscriberDailyEmail.v1, args, opts),
            },
        },
        StartLocationCheckpointTourRun: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.StartLocationCheckpointTourRun.v1, args, opts),
            },
        },
        UnlinkLocationFromContact: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UnlinkLocationFromContact.v1, args, opts),
            },
        },
        UnlinkLocationFromInfoBlock: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UnlinkLocationFromInfoBlock.v1, args, opts),
            },
        },
        UpdateLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocation.v1, args, opts),
            },
        },
        UpdateLocationBolo: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationBolo.v1, args, opts),
            },
        },
        UpdateLocationCheckpoint: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationCheckpoint.v1, args, opts),
            },
        },
        UpdateLocationCheckpointScan: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationCheckpointScan.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationCheckpointScan.v2, args, opts),
            },
        },
        UpdateLocationCheckpointTour: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationCheckpointTour.v1, args, opts),
            },
        },
        UpdateLocationContact: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationContact.v1, args, opts),
            },
        },
        UpdateLocationGroup: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationGroup.v1, args, opts),
            },
        },
        UpdateLocationInfoBlock: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationInfoBlock.v1, args, opts),
            },
        },
        UpdateLocationInfoBlockCategory: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationInfoBlockCategory.v1, args, opts),
            },
        },
        UpdateLocationLogEntry: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationLogEntry.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationLogEntry.v2, args, opts),
            },
        },
        UpdateLocationLogEntryType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationLogEntryType.v1, args, opts),
            },
        },
        UpdateLocationLogEntryTypeLocationsRelations: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationLogEntryTypeLocationsRelations.v1, args, opts),
            },
        },
        UpdateLocationPassDown: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationPassDown.v1, args, opts),
            },
        },
        UpdateLocationSubscriber: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationSubscriber.v1, args, opts),
            },
        },
        UpdateLocationTask: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Locations.UpdateLocationTask.v1, args, opts),
            },
        },
    },
    Mail: {
        DeleteMessages: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Mail.DeleteMessages.v1, args, opts),
            },
        },
        GetMessage: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Mail.GetMessage.v1, args, opts),
            },
        },
        GetMessagesList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Mail.GetMessagesList.v1, args, opts),
            },
        },
        GetUnreadMessagesCount: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Mail.GetUnreadMessagesCount.v1, args, opts),
            },
        },
        SendMessage: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Mail.SendMessage.v1, args, opts),
            },
        },
        SetMessageFlagged: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Mail.SetMessageFlagged.v1, args, opts),
            },
        },
        SetMessageRead: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Mail.SetMessageRead.v1, args, opts),
            },
        },
    },
    Notifications: {
        FindMyNotifications: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Notifications.FindMyNotifications.v1, args, opts),
            },
        },
        GetMyNotificationPreferences: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Notifications.GetMyNotificationPreferences.v1, args, opts),
            },
        },
        MarkNotificationsRead: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Notifications.MarkNotificationsRead.v1, args, opts),
            },
        },
        ResolveNotification: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Notifications.ResolveNotification.v1, args, opts),
            },
        },
        SendPushNotification: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Notifications.SendPushNotification.v1, args, opts),
            },
        },
        SendPushNotificationRaw: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Notifications.SendPushNotificationRaw.v1, args, opts),
            },
        },
        SendTestPushNotificationToUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Notifications.SendTestPushNotificationToUser.v1, args, opts),
            },
        },
        SetMyNotificationPreferences: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Notifications.SetMyNotificationPreferences.v1, args, opts),
            },
        },
    },
    OpsTrends: {
        CompareTrendPeriods: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.OpsTrends.CompareTrendPeriods.v1, args, opts),
            },
        },
        CreateTrendConfig: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.OpsTrends.CreateTrendConfig.v1, args, opts),
            },
        },
        DeleteTrendConfig: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.OpsTrends.DeleteTrendConfig.v1, args, opts),
            },
        },
        FindTrendConfigs: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.OpsTrends.FindTrendConfigs.v1, args, opts),
            },
        },
        GetTrendsPeriod: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.OpsTrends.GetTrendsPeriod.v1, args, opts),
            },
        },
        UpdateTrendConfig: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.OpsTrends.UpdateTrendConfig.v1, args, opts),
            },
        },
    },
    Organization: {
        GetAuditLogs: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organization.GetAuditLogs.v1, args, opts),
            },
        },
        GetEmailLog: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organization.GetEmailLog.v1, args, opts),
            },
        },
    },
    Organizations: {
        ActivateScheduling: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.ActivateScheduling.v1, args, opts),
            },
        },
        DeactivateScheduling: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.DeactivateScheduling.v1, args, opts),
            },
        },
        GetOrganizationProfile: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.GetOrganizationProfile.v1, args, opts),
            },
        },
        GetOrganizationStripeBillingPortalLink: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.GetOrganizationStripeBillingPortalLink.v1, args, opts),
            },
        },
        GetOrganizationSubscriptionDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.GetOrganizationSubscriptionDetails.v1, args, opts),
            },
        },
        SetOrganizationNotificationDefaults: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.SetOrganizationNotificationDefaults.v1, args, opts),
            },
        },
        ToggleDispatch: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.ToggleDispatch.v1, args, opts),
            },
        },
        TogglePatrol: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.TogglePatrol.v1, args, opts),
            },
        },
        ToggleRegions: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.ToggleRegions.v1, args, opts),
            },
        },
        ToggleSos: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.ToggleSos.v1, args, opts),
            },
        },
        UpdateOrganization: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.UpdateOrganization.v1, args, opts),
            },
        },
        UpdateOrganizationOrganizationBillingContacts: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.UpdateOrganizationOrganizationBillingContacts.v1, args, opts),
            },
        },
        UpgradeOrganizationPlanToCore: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Organizations.UpgradeOrganizationPlanToCore.v1, args, opts),
            },
        },
    },
    PassDowns: {
        DeletePassDown: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.PassDowns.DeletePassDown.v1, args, opts),
            },
        },
        GetPassDown: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.PassDowns.GetPassDown.v1, args, opts),
            },
        },
    },
    Patrol: {
        CreatePatrolRoute: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.CreatePatrolRoute.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.CreatePatrolRoute.v2, args, opts),
            },
        },
        DeletePatrolRouteRuns: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.DeletePatrolRouteRuns.v1, args, opts),
            },
        },
        DeletePatrolRoutes: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.DeletePatrolRoutes.v1, args, opts),
            },
        },
        EndPatrolRouteRun: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.EndPatrolRouteRun.v1, args, opts),
            },
        },
        FindPatrolRoutes: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.FindPatrolRoutes.v1, args, opts),
            },
        },
        FindPatrolRoutesRuns: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.FindPatrolRoutesRuns.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.FindPatrolRoutesRuns.v2, args, opts),
            },
        },
        GetPatrolRouteDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.GetPatrolRouteDetails.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.GetPatrolRouteDetails.v2, args, opts),
            },
        },
        GetPatrolRouteRunDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.GetPatrolRouteRunDetails.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.GetPatrolRouteRunDetails.v2, args, opts),
            },
        },
        GetPatrolRoutesActivityForTheDay: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.GetPatrolRoutesActivityForTheDay.v1, args, opts),
            },
        },
        ReOpenPatrolRouteRun: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.ReOpenPatrolRouteRun.v1, args, opts),
            },
        },
        StartPatrolRouteRun: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.StartPatrolRouteRun.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.StartPatrolRouteRun.v2, args, opts),
            },
        },
        UpdatePatrolRoute: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.UpdatePatrolRoute.v1, args, opts),
            },
        },
        UpdatePatrolRouteRun: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.UpdatePatrolRouteRun.v1, args, opts),
            },
        },
        UpdatePatrolRouteRunVisit: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Patrol.UpdatePatrolRouteRunVisit.v1, args, opts),
            },
        },
    },
    Public: {
        DownloadPublicContentPdf: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Public.DownloadPublicContentPdf.v1, args, opts),
            },
        },
        GetCheckpoint: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Public.GetCheckpoint.v1, args, opts),
            },
        },
        GetLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Public.GetLocation.v1, args, opts),
            },
        },
        GetLocationSubscriberContent: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Public.GetLocationSubscriberContent.v1, args, opts),
            },
        },
        GetPublicContentDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Public.GetPublicContentDetails.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Public.GetPublicContentDetails.v2, args, opts),
            },
        },
        GetRecord: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Public.GetRecord.v1, args, opts),
            },
        },
        GetRequestPortalAccessLink: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Public.GetRequestPortalAccessLink.v1, args, opts),
            },
        },
        GetUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Public.GetUser.v1, args, opts),
            },
        },
        ResendPublicContentCode: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Public.ResendPublicContentCode.v1, args, opts),
            },
        },
        VerifyPublicContentAccess: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Public.VerifyPublicContentAccess.v1, args, opts),
            },
        },
    },
    Records: {
        AddRecordDateSensitiveTag: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.AddRecordDateSensitiveTag.v1, args, opts),
            },
        },
        AddRecordFiles: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.AddRecordFiles.v1, args, opts),
            },
        },
        AddRecordRefs: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.AddRecordRefs.v1, args, opts),
            },
        },
        BulkCreateRecords: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.BulkCreateRecords.v1, args, opts),
            },
        },
        CreateRecord: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.CreateRecord.v1, args, opts),
            },
        },
        CreateRecordComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.CreateRecordComment.v1, args, opts),
            },
        },
        CreateRecordTag: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.CreateRecordTag.v1, args, opts),
            },
        },
        DeleteRecord: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.DeleteRecord.v1, args, opts),
            },
        },
        DeleteRecordComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.DeleteRecordComment.v1, args, opts),
            },
        },
        DeleteRecordTags: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.DeleteRecordTags.v1, args, opts),
            },
        },
        DownloadRecord: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.DownloadRecord.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Records.DownloadRecord.v2, args, opts),
            },
        },
        GetRecordAuditLogs: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.GetRecordAuditLogs.v1, args, opts),
            },
        },
        GetRecordComments: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.GetRecordComments.v1, args, opts),
            },
        },
        GetRecordProfile: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.GetRecordProfile.v1, args, opts),
            },
        },
        GetRecordProfiles: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.GetRecordProfiles.v1, args, opts),
            },
        },
        GetRecordTagsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.GetRecordTagsList.v1, args, opts),
            },
        },
        GetRecordsFieldOptionsConfig: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.GetRecordsFieldOptionsConfig.v1, args, opts),
            },
        },
        GetRecordsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.GetRecordsList.v1, args, opts),
            },
        },
        MoveRecordDateSensitiveTagToTags: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.MoveRecordDateSensitiveTagToTags.v1, args, opts),
            },
        },
        RemoveRecordDateSensitiveTag: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.RemoveRecordDateSensitiveTag.v1, args, opts),
            },
        },
        RemoveRecordRefs: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.RemoveRecordRefs.v1, args, opts),
            },
        },
        SaveRecordsFieldOptionsConfig: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.SaveRecordsFieldOptionsConfig.v1, args, opts),
            },
        },
        SetRecordTags: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.SetRecordTags.v1, args, opts),
            },
        },
        UpdateRecord: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.UpdateRecord.v1, args, opts),
            },
        },
        UpdateRecordComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.UpdateRecordComment.v1, args, opts),
            },
        },
        UpdateRecordDateSensitiveTag: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.UpdateRecordDateSensitiveTag.v1, args, opts),
            },
        },
        UpdateRecordTag: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Records.UpdateRecordTag.v1, args, opts),
            },
        },
    },
    RefLinks: {
        DeleteRefLink: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.RefLinks.DeleteRefLink.v1, args, opts),
            },
        },
        GetRefLink: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.RefLinks.GetRefLink.v1, args, opts),
            },
        },
        GetRefLinkCounts: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.RefLinks.GetRefLinkCounts.v1, args, opts),
            },
        },
        GetRefLinks: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.RefLinks.GetRefLinks.v1, args, opts),
            },
        },
        SaveRefLink: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.RefLinks.SaveRefLink.v1, args, opts),
            },
        },
    },
    Regions: {
        ActivateRegion: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Regions.ActivateRegion.v1, args, opts),
            },
        },
        CreateRegion: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Regions.CreateRegion.v1, args, opts),
            },
        },
        DeactivateRegion: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Regions.DeactivateRegion.v1, args, opts),
            },
        },
        GetRegionProfile: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Regions.GetRegionProfile.v1, args, opts),
            },
        },
        GetRegionsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Regions.GetRegionsList.v1, args, opts),
            },
        },
        UpdateRegion: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Regions.UpdateRegion.v1, args, opts),
            },
        },
    },
    Reports: {
        ChangeReportStatus: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.ChangeReportStatus.v1, args, opts),
            },
        },
        CreateReport: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.CreateReport.v1, args, opts),
            },
        },
        CreateReportEntry: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.CreateReportEntry.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.CreateReportEntry.v2, args, opts),
            },
        },
        CreateReportEntryType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.CreateReportEntryType.v1, args, opts),
            },
        },
        CreateReportType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.CreateReportType.v1, args, opts),
            },
        },
        CreateReportTypesSubscribers: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.CreateReportTypesSubscribers.v1, args, opts),
            },
        },
        DeleteReport: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.DeleteReport.v1, args, opts),
            },
        },
        DeleteReportEntry: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.DeleteReportEntry.v1, args, opts),
            },
        },
        DeleteReportEntryType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.DeleteReportEntryType.v1, args, opts),
            },
        },
        DeleteReportEntryTypes: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.DeleteReportEntryTypes.v1, args, opts),
            },
        },
        DeleteReportType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.DeleteReportType.v1, args, opts),
            },
        },
        DeleteReportTypes: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.DeleteReportTypes.v1, args, opts),
            },
        },
        DeleteReportTypesSubscribers: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.DeleteReportTypesSubscribers.v1, args, opts),
            },
        },
        DownloadReport: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.DownloadReport.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.DownloadReport.v2, args, opts),
            },
        },
        GetCurrentReportCounts: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetCurrentReportCounts.v1, args, opts),
            },
        },
        GetReport: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReport.v1, args, opts),
            },
        },
        GetReportDataSheet: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportDataSheet.v1, args, opts),
            },
        },
        GetReportEntryDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportEntryDetail.v1, args, opts),
            },
        },
        GetReportEntryList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportEntryList.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportEntryList.v2, args, opts),
            },
        },
        GetReportEntryType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportEntryType.v1, args, opts),
            },
        },
        GetReportEntryTypesList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportEntryTypesList.v1, args, opts),
            },
        },
        GetReportNextStatuses: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportNextStatuses.v1, args, opts),
            },
        },
        GetReportTypeEntryTypesFormBuilderInputFields: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportTypeEntryTypesFormBuilderInputFields.v1, args, opts),
            },
        },
        GetReportTypesDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportTypesDetails.v1, args, opts),
            },
        },
        GetReportTypesList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportTypesList.v1, args, opts),
            },
        },
        GetReportTypesSubscriberDailyEmailPreview: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportTypesSubscriberDailyEmailPreview.v1, args, opts),
            },
        },
        GetReportTypesSubscribers: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportTypesSubscribers.v1, args, opts),
            },
        },
        GetReportTypesWithEntryTypeList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportTypesWithEntryTypeList.v1, args, opts),
            },
        },
        GetReportsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.GetReportsList.v1, args, opts),
            },
        },
        SendReportTypesSubscriberDailyEmail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.SendReportTypesSubscriberDailyEmail.v1, args, opts),
            },
        },
        SetReportTypesActive: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.SetReportTypesActive.v1, args, opts),
            },
        },
        UpdateReport: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.UpdateReport.v1, args, opts),
            },
        },
        UpdateReportEntry: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.UpdateReportEntry.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.UpdateReportEntry.v2, args, opts),
            },
        },
        UpdateReportEntryType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.UpdateReportEntryType.v1, args, opts),
            },
        },
        UpdateReportType: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.UpdateReportType.v1, args, opts),
            },
        },
        UpdateReportTypesSubscriber: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Reports.UpdateReportTypesSubscriber.v1, args, opts),
            },
        },
    },
    Scheduling: {
        CopyScheduledShiftsToDate: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.CopyScheduledShiftsToDate.v1, args, opts),
            },
        },
        CreateCustomSchedulingAssignment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.CreateCustomSchedulingAssignment.v1, args, opts),
            },
        },
        CreateScheduledShift: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.CreateScheduledShift.v1, args, opts),
            },
        },
        CreateShift: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.CreateShift.v1, args, opts),
            },
        },
        DeleteCustomSchedulingAssignment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.DeleteCustomSchedulingAssignment.v1, args, opts),
            },
        },
        DeleteScheduledShifts: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.DeleteScheduledShifts.v1, args, opts),
            },
        },
        EditShift: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.EditShift.v1, args, opts),
            },
        },
        EndBreak: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.EndBreak.v1, args, opts),
            },
        },
        EndShift: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.EndShift.v1, args, opts),
            },
        },
        GetCurrentShiftsCounts: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetCurrentShiftsCounts.v1, args, opts),
            },
        },
        GetCurrentShiftsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetCurrentShiftsList.v1, args, opts),
            },
        },
        GetScheduleConfig: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetScheduleConfig.v1, args, opts),
            },
        },
        GetScheduledShiftsByStartTime: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetScheduledShiftsByStartTime.v1, args, opts),
            },
        },
        GetSchedulingAssignment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetSchedulingAssignment.v1, args, opts),
            },
        },
        GetSchedulingAssignments: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetSchedulingAssignments.v1, args, opts),
            },
        },
        GetSchedulingUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetSchedulingUser.v1, args, opts),
            },
        },
        GetSchedulingUsers: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetSchedulingUsers.v1, args, opts),
            },
        },
        GetShiftDetail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetShiftDetail.v1, args, opts),
            },
        },
        GetShiftsByStartTimeDetails: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetShiftsByStartTimeDetails.v1, args, opts),
            },
        },
        GetShiftsByStartTimeList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetShiftsByStartTimeList.v1, args, opts),
            },
        },
        GetUserCurrentOrFutureShift: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.GetUserCurrentOrFutureShift.v1, args, opts),
            },
        },
        PublishScheduledShifts: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.PublishScheduledShifts.v1, args, opts),
            },
        },
        SaveScheduleConfig: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.SaveScheduleConfig.v1, args, opts),
            },
        },
        SetShiftAcknowledged: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.SetShiftAcknowledged.v1, args, opts),
            },
        },
        StartBreak: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.StartBreak.v1, args, opts),
            },
        },
        StartShift: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.StartShift.v1, args, opts),
            },
        },
        ToggleAllLocationSchedulingAssignments: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.ToggleAllLocationSchedulingAssignments.v1, args, opts),
            },
        },
        ToggleAllLocationSchedulingUsers: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.ToggleAllLocationSchedulingUsers.v1, args, opts),
            },
        },
        ToggleCustomSchedulingAssignment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.ToggleCustomSchedulingAssignment.v1, args, opts),
            },
        },
        ToggleLocationSchedulingAssignment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.ToggleLocationSchedulingAssignment.v1, args, opts),
            },
        },
        ToggleSchedulingUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.ToggleSchedulingUser.v1, args, opts),
            },
        },
        UnpublishScheduledShifts: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.UnpublishScheduledShifts.v1, args, opts),
            },
        },
        UpdateCustomSchedulingAssignment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.UpdateCustomSchedulingAssignment.v1, args, opts),
            },
        },
        UpdateScheduledShift: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Scheduling.UpdateScheduledShift.v1, args, opts),
            },
        },
    },
    ServicePeriods: {
        ApplyServicePeriodTemplate: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.ApplyServicePeriodTemplate.v1, args, opts),
            },
        },
        CreateServicePeriod: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.CreateServicePeriod.v1, args, opts),
            },
        },
        CreateServicePeriodTemplate: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.CreateServicePeriodTemplate.v1, args, opts),
            },
        },
        DeleteServicePeriodTemplates: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.DeleteServicePeriodTemplates.v1, args, opts),
            },
        },
        DeleteServicePeriods: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.DeleteServicePeriods.v1, args, opts),
            },
        },
        FindActivityEvals: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.FindActivityEvals.v1, args, opts),
            },
        },
        FindServicePeriodInstances: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.FindServicePeriodInstances.v1, args, opts),
            },
        },
        FindServicePeriodTemplates: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.FindServicePeriodTemplates.v1, args, opts),
            },
        },
        FindServicePeriods: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.FindServicePeriods.v1, args, opts),
            },
        },
        UpdateServicePeriod: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.UpdateServicePeriod.v1, args, opts),
            },
        },
        UpdateServicePeriodTemplate: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.ServicePeriods.UpdateServicePeriodTemplate.v1, args, opts),
            },
        },
    },
    Stats: {
        DownloadLocationStats: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.DownloadLocationStats.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.DownloadLocationStats.v2, args, opts),
            },
        },
        DownloadOrganizationStats: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.DownloadOrganizationStats.v1, args, opts),
            },
            v2: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.DownloadOrganizationStats.v2, args, opts),
            },
        },
        GetEventsHistogram: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.GetEventsHistogram.v1, args, opts),
            },
        },
        GetEventsStatsCount: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.GetEventsStatsCount.v1, args, opts),
            },
        },
        GetLocationCheckpointScansHistogram: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.GetLocationCheckpointScansHistogram.v1, args, opts),
            },
        },
        GetLocationGeoHistoryStats: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.GetLocationGeoHistoryStats.v1, args, opts),
            },
        },
        GetLocationLogEntriesHistogram: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.GetLocationLogEntriesHistogram.v1, args, opts),
            },
        },
        GetLocationLogEntriesStatsCount: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.GetLocationLogEntriesStatsCount.v1, args, opts),
            },
        },
        GetReportsHistogram: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.GetReportsHistogram.v1, args, opts),
            },
        },
        GetReportsStatsCount: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.GetReportsStatsCount.v1, args, opts),
            },
        },
        GetUserWithStatusHistogram: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Stats.GetUserWithStatusHistogram.v1, args, opts),
            },
        },
    },
    Summaries: {
        GetOpsSummaryForDates: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Summaries.GetOpsSummaryForDates.v1, args, opts),
            },
        },
    },
    Support: {
        ReportIssue: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Support.ReportIssue.v1, args, opts),
            },
        },
        RequestCall: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Support.RequestCall.v1, args, opts),
            },
        },
    },
    System: {
        GetSystemInfoForTarget: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.System.GetSystemInfoForTarget.v1, args, opts),
            },
        },
    },
    Tags: {
        CreateActivityTypeTag: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Tags.CreateActivityTypeTag.v1, args, opts),
            },
        },
        DeleteActivityTypeTags: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Tags.DeleteActivityTypeTags.v1, args, opts),
            },
        },
        GetActivityTypeTagsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Tags.GetActivityTypeTagsList.v1, args, opts),
            },
        },
        UpdateActivityTypeTag: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Tags.UpdateActivityTypeTag.v1, args, opts),
            },
        },
    },
    UserClient: {
        ClearUnread: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserClient.ClearUnread.v1, args, opts),
            },
        },
        RemoveRecentLocations: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserClient.RemoveRecentLocations.v1, args, opts),
            },
        },
        RemoveRecentRecords: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserClient.RemoveRecentRecords.v1, args, opts),
            },
        },
        RemoveRecentReports: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserClient.RemoveRecentReports.v1, args, opts),
            },
        },
        ViewLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserClient.ViewLocation.v1, args, opts),
            },
        },
        ViewRecord: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserClient.ViewRecord.v1, args, opts),
            },
        },
        ViewReport: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserClient.ViewReport.v1, args, opts),
            },
        },
    },
    UserSos: {
        ActivateUserSos: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserSos.ActivateUserSos.v1, args, opts),
            },
        },
        DeactivateUserSos: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserSos.DeactivateUserSos.v1, args, opts),
            },
        },
        DeleteUserSosComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserSos.DeleteUserSosComment.v1, args, opts),
            },
        },
        GetActivatedUserSos: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserSos.GetActivatedUserSos.v1, args, opts),
            },
        },
        GetUserSosComments: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserSos.GetUserSosComments.v1, args, opts),
            },
        },
        GetUserSosHistory: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserSos.GetUserSosHistory.v1, args, opts),
            },
        },
        SaveUserSosComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserSos.SaveUserSosComment.v1, args, opts),
            },
        },
        UpdateActivatedUserSos: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.UserSos.UpdateActivatedUserSos.v1, args, opts),
            },
        },
    },
    Users: {
        ActivateUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.ActivateUser.v1, args, opts),
            },
        },
        AddLocationToUserAnp: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.AddLocationToUserAnp.v1, args, opts),
            },
        },
        CheckOrganizationExistingEmail: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.CheckOrganizationExistingEmail.v1, args, opts),
            },
        },
        CreateUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.CreateUser.v1, args, opts),
            },
        },
        CreateUserAdminComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.CreateUserAdminComment.v1, args, opts),
            },
        },
        CreateUserGroup: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.CreateUserGroup.v1, args, opts),
            },
        },
        CreateUserPositionOption: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.CreateUserPositionOption.v1, args, opts),
            },
        },
        CreateUserStatusOption: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.CreateUserStatusOption.v1, args, opts),
            },
        },
        DeactivateUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.DeactivateUser.v1, args, opts),
            },
        },
        DeleteUserAdminComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.DeleteUserAdminComment.v1, args, opts),
            },
        },
        DeleteUserGroups: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.DeleteUserGroups.v1, args, opts),
            },
        },
        DeleteUserPositionOptions: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.DeleteUserPositionOptions.v1, args, opts),
            },
        },
        DeleteUserStatusOptions: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.DeleteUserStatusOptions.v1, args, opts),
            },
        },
        GetAllowedUserStatusOptionsAndPositions: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetAllowedUserStatusOptionsAndPositions.v1, args, opts),
            },
        },
        GetNearbyUsersList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetNearbyUsersList.v1, args, opts),
            },
        },
        GetUserAccessAndPermissions: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserAccessAndPermissions.v1, args, opts),
            },
        },
        GetUserAdminComments: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserAdminComments.v1, args, opts),
            },
        },
        GetUserAuditLogs: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserAuditLogs.v1, args, opts),
            },
        },
        GetUserAuthSessionsHistoryList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserAuthSessionsHistoryList.v1, args, opts),
            },
        },
        GetUserAuthSessionsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserAuthSessionsList.v1, args, opts),
            },
        },
        GetUserGeoFenceCrossings: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserGeoFenceCrossings.v1, args, opts),
            },
        },
        GetUserGeoLocationHistory: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserGeoLocationHistory.v1, args, opts),
            },
        },
        GetUserGeoLocationHistoryAtLocation: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserGeoLocationHistoryAtLocation.v1, args, opts),
            },
        },
        GetUserGroup: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserGroup.v1, args, opts),
            },
        },
        GetUserGroups: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserGroups.v1, args, opts),
            },
        },
        GetUserGroupsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserGroupsList.v1, args, opts),
            },
        },
        GetUserGroupsWithLocationAccessList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserGroupsWithLocationAccessList.v1, args, opts),
            },
        },
        GetUserName: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserName.v1, args, opts),
            },
        },
        GetUserNames: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserNames.v1, args, opts),
            },
        },
        GetUserPositionOption: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserPositionOption.v1, args, opts),
            },
        },
        GetUserPositionOptionsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserPositionOptionsList.v1, args, opts),
            },
        },
        GetUserProfile: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserProfile.v1, args, opts),
            },
        },
        GetUserRegistrationRequests: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserRegistrationRequests.v1, args, opts),
            },
        },
        GetUserStatusHistory: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserStatusHistory.v1, args, opts),
            },
        },
        GetUserStatusOption: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserStatusOption.v1, args, opts),
            },
        },
        GetUserStatusOptionsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUserStatusOptionsList.v1, args, opts),
            },
        },
        GetUsersAndGroupsForCommunicationsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUsersAndGroupsForCommunicationsList.v1, args, opts),
            },
        },
        GetUsersAndGroupsLabelsList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUsersAndGroupsLabelsList.v1, args, opts),
            },
        },
        GetUsersGeoSearch: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUsersGeoSearch.v1, args, opts),
            },
        },
        GetUsersList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUsersList.v1, args, opts),
            },
        },
        GetUsersWithLocationAccessList: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.GetUsersWithLocationAccessList.v1, args, opts),
            },
        },
        KillAllUserAuthSessions: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.KillAllUserAuthSessions.v1, args, opts),
            },
        },
        KillUserAuthSessions: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.KillUserAuthSessions.v1, args, opts),
            },
        },
        RejectUserRegistrationRequest: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.RejectUserRegistrationRequest.v1, args, opts),
            },
        },
        RemoveLocationFromUserAnp: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.RemoveLocationFromUserAnp.v1, args, opts),
            },
        },
        RequestUsersDevicesGeoLocationReport: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.RequestUsersDevicesGeoLocationReport.v1, args, opts),
            },
        },
        ResetUserPassword: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.ResetUserPassword.v1, args, opts),
            },
        },
        SaveUserDeviceGeo: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.SaveUserDeviceGeo.v1, args, opts),
            },
        },
        SetUserPosition: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.SetUserPosition.v1, args, opts),
            },
        },
        SetUserStatus: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.SetUserStatus.v1, args, opts),
            },
        },
        SetUsersAnpRoles: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.SetUsersAnpRoles.v1, args, opts),
            },
        },
        UpdateUser: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.UpdateUser.v1, args, opts),
            },
        },
        UpdateUserAdminComment: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.UpdateUserAdminComment.v1, args, opts),
            },
        },
        UpdateUserGroup: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.UpdateUserGroup.v1, args, opts),
            },
        },
        UpdateUserPositionOption: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.UpdateUserPositionOption.v1, args, opts),
            },
        },
        UpdateUserStatusOption: {
            v1: {
                call: (args, opts) => rpcClient.call(RPCs.Users.UpdateUserStatusOption.v1, args, opts),
            },
        },
    },
});
//# sourceMappingURL=client.js.map